export default {
  // layout
  LAYOUT: {
    header: {
      routes: {
        title: {
          ___caseList: '症例リスト',
          ___phenoVarDBPopulationFrequencies: 'PhenoVarDB<br>集団頻度'
        },
        info: {
          ___userManual: 'ユーザーマニュアル',
          ___logOut: 'ログアウト'
        }
      },
      menu: {
        title: {
          ___userSetting: 'ユーザー設定'
        }
      }
    },
    footer: {
    },
    pageFooter: {
      ___compassBioinformatics: 'コンパスバイオインフォマティクス株式会社',
      ___cookie_policy: 'Cookie policy',
      ___privacy_policy: 'Privacy policy',
      ___alert: '本製品は研究目的にのみご利用いただけます。'
    },
    uploading: {
      ___title: 'アップロード'
    }
  },
  // mixin
  MIXIN: {
    routeLoading: {
      ___noPermission: '権限がありません。'
    }
  },
  // page
  PAGE: {
    main: {
      ___forgetPassword: 'パスワードをお忘れですか？',
      ___or: 'または',
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）',
          ___password: 'パスワード'
        }
      }
    },
    forget: {
      ___info01: 'ご登録のアカウント（メールアドレス）を入力してください。',
      ___info02: 'パスワード再設定メールをご登録のメールアドレスに送信します。',
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）'
        },
        placeholder: {
          ___email: 'wiseTony@compassbioinfo.com'
        }
      }
    },
    reset: {
      ___info01: 'こちらがパスワード再設定ページです。',
      ___info02: 'アカウントのパスワードを再設定してください：',
      form: {
        title: {
          ___newPassword: '新しいパスワード',
          ___confirmed: '新しいパスワードを確認する'
        },
        errorTitle: {
          ___newPassword: 'パスワード',
          ___confirmed: 'パスワード'
        },
        placeholder: {
          ___newPassword: '14～100文字を入力してください。',
          ___confirmed: 'パスワードをもう一度入力してください。'
        },
        customValidate: {
          ___confirmed: '入力されたパスワードは一致しません。'
        }
      }
    },
    active: {
      ___info01: 'ご担当者さまへ、新規ユーザー登録があります。',
      ___info02: 'ユーザー情報を確認し、アカウントの認証を行なってください。',
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）',
          ___firstName: '名前',
          ___lastName: '苗字',
          ___country: '国や地域',
          ___organization: '所属機関',
          ___appliedDate: '申請日'
        }
      }
    },
    deviceAlert: {
      ___info01: 'パソコンまたはノートパソコンでのログインを推奨します。',
      ___info02: 'それ以外の場合、使用体験に影響を及ぼす可能性があります。'
    },
    datasetAccess: {
      form: {
        title: {
          ___accessKey: 'アクセスキー'
        },
        placeholder: {
          ___accessKey: '16桁のアクセスキーを入力してください。'
        }
      }
    },
    genePanel: {
      ___title: '遺伝子パネル検索',
      geneTag: {
        ___placeholder: '疾患または遺伝子パネルを入力してください。'
      },
      introduction: {
        collapse: {
          ___content01: '始め方がわからない場合は、以下の内容を参考にしてください。'
        },
        display: {
          ___content01: '始め方がわからない場合は、以下の内容を参考にしてください。',
          ___content02: '遺伝性疾患の代表的な表現型は以下の通りです：',
          ___content03: '例：マルファン症候群、レーベル遺伝性視神経症、ファブリー病、てんかん、ヌーナン症候群とラソパシーズなど。'
        }
      }
    },
    phenotypeDisease: {
      ___title01: '両者の類似度',
      ___title02: '表現型と疾患',
      ___alert01: '本結果はあくまでも可能性を示す参考情報であり、',
      ___alert02: '確定診断を目的とするものではありません。',
      ___selectedTitle: '選択する',
      ___selectedRemind: 'チェックボックスの選択を解除すると、表現型を削除できます。',
      ___resultPhenotypeTitle: '入力された表現型',
      ___resultTableTitle: '結果',
      phenotypeTag: {
        ___placeholder: '表現型を入力してください。'
      },
      introduction: {
        collapse: {
          ___content01: '始め方がわからない場合は、以下の内容を参考にしてください。'
        },
        display: {
          ___content01: '始め方がわからない場合は、以下の内容を参考にしてください。',
          ___content02: '遺伝性疾患の代表的な表現型は以下の通りです：',
          ___content03: '例：全般的発達遅滞、低身長、筋緊張低下、 眼球振とう、聴覚障害、知的障害、小頭症など。',
          ___content04: 'ただし、<span class="alert"> 10項目を超えないように </span> してください。',
          ___content05: '<a href="https://hpo.jax.org/app/" target="_blank">HPOのウェブサイト</a> からも関連する表現型を検索することができます。</a>.'
        }
      },
      table: {
        title: {
          ___index: 'Rk',
          ___omimID: 'OMIM ID',
          ___name: '疾患名'
        }
      },
      uploading: {
        ___pleaseWait: 'ページを表示した状態でしばらくお待ちください。'
      }
    },
    coverageRate: {
      ___title: 'カバレッジ率の検索ツール',
      ___searchPlaceholder: 'RefSeq ID（例：NM_000059.4）または遺伝子名（例：BRCA1）',
      table: {
        title: {
          ___refseqID: 'RefSeq ID',
          ___symbol: '遺伝子名',
          ___region: '遺伝子領域',
          ___libraryKit: 'ライブラリーキット',
          ___10XPctMeanCov: '10X 以上カバー率(%)',
          ___20XPctMeanCov: '20X 以上カバー率(%)'
        }
      }
    },
    register: {
      ___info01: 'AI遺伝子スクリーニングシステムのInheriNextへようこそ。',
      ___info02: '必要事項をご記入の上、利用規約に同意してご登録ください。',
      ___info03: '当社にてご利用の審査と承認を行いますので、しばらくお待ちください。',
      ___agreementCheckTitle: '利用規約および<a class="link" href="{link}" target="_blank">プライバシーポリシー</a>を注意深く読み、すべてに同意します。',
      ___agreementDownloadPDFTitle: '利用規約（繁体字中国語版）PDF ダウンロード',
      ___agreementContent: `<span style="font-size:1.5rem; font-weight:500;">InheriNext® Edgeへようこそ</span>
InheriNext® Edgeは、Compass Bioinformatics Inc.によって開発されたプラットフォームです。InheriNext® Edgeをご利用いただくことで、以下の利用規約に同意されたものとみなされます。もし、以下の利用規約に関して不明点や懸念がある場合は、InheriNext® Edgeの使用を中止してください。

<span style="font-size:1rem; font-weight:500;">InheriNext® Edgeの用途</span>
InheriNext® Edgeは、科学的なユーザー向けに遺伝学的データの解析結果を提供します。InheriNext® Edgeは、診断結果または医療的なアドバイスを含みません。上記以外の目的で使用することはできません。

<span style="font-size:1rem; font-weight:500;">データの所有権について</span>
InheriNext® Edgeにアップロードされたすべてのデータの所有権は、完全にユーザーに帰属します。Compass Bioinformatics Inc.は、アップロードされたデータをレポートの作成のみに使用します。Compass Bioinformatics Inc.は、これらのレポートから得られる集計データ（要約データ）を、解析手法の精度向上のために使用します。データが第三者に販売または譲渡されることはありません。

<span style="font-size:1rem; font-weight:500;">個人情報の保護</span>
InheriNext® Edgeにアップロードされたデータは、安全に保管され、当社のプライバシーポリシーに基づき保護されます。登録ユーザーには、システムの更新、メンテナンス、新バージョンなどについてEメールで通知されます。これらの通知は、Eメール内の「配信停止」リンクから解除可能です。個人情報が第三者に共有されたり販売されたりすることはありません。

<span style="font-size:1rem; font-weight:500;">サービスの停止・中断</span>
Compass Bioinformatics Inc.は、任意の理由によりInheriNext® Edgeの一部またはすべての機能を中断または停止する権利を有します。未使用のサービスについてのみ返金が行われます。Compass Bioinformatics Inc.は、それ以外のサービス責任を一切負いません。

<span style="font-size:1rem; font-weight:500;">保証および免責事項</span>
InheriNext® Edgeが使用するナレッジベースは科学的に妥当であると考えられますが、100%の正確性または完全性が保証されるものではありません。InheriNext® Edgeによる解析結果の解釈にあたっては、独立した判断を行うことに同意し、その結果得られる知見についてはすべて自己の責任であることに同意します。

<span style="font-size:1rem; font-weight:500;">最適化について</span>
InheriNext® Edgeはユーザーの使用を通じて最適化される可能性がありますが、そのことによってユーザーがInheriNext® Edgeの全体または一部に対する所有権を持つことはありません。

<span style="font-size:1rem; font-weight:500;">現地の法令の遵守</span>
InheriNext® Edgeの利用規約に従うこと、そしてご自身の居住地の法令にも準拠していることを確認します。`,
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）',
          ___verification: '認証',
          ___firstName: '名前',
          ___lastName: '苗字',
          ___country: '国や地域',
          ___countryCode: '電話番号',
          ___organization: '所属機関',
          ___division: '部署や役職',
          ___managerID: '管理者ID',
          ___password: '新しいパスワード',
          ___confirmed: '新しいパスワードの確認'
        },
        placeholder: {
          ___email: 'wiseTony@compassbioinfo.com',
          ___verification: '6桁の認証コード',
          ___firstName: '花子',
          ___lastName: '山田',
          ___country: '日本',
          ___countryCode: '+886',
          ___phone: '電話番号',
          ___organization: 'コンパスバイオインフォマティクス株式会社',
          ___division: '臨床研究部門',
          ___managerID: '3桁のコード',
          ___password: '14～100文字を入力してください。',
          ___confirmed: 'パスワードをもう一度入力してください。'
        },
        errorTitle: {
          ___email: 'アカウント（メールアドレス）',
          ___password: 'パスワード',
          ___confirmed: 'パスワード'
        },
        customValidate: {
          ___country: '国名の形式が間違っています。入力内容を再度確認してください。',
          ___countryCode: '国番号が存在していません。',
          ___confirmed: '入力されたパスワードが一致していません。',
          ___verificationCode: '認証コードが間違っています。'
        }
      }
    },
    user: {
      ___avatarTitle: 'アバター',
      tab: {
        ___info: '基本情報',
        ___password: 'パスワード設定',
        ___license: 'ライセンスマネージャー'
      },
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）',
          ___firstName: '名前',
          ___lastName: '苗字',
          ___country: '国や地域',
          ___countryCode: '電話番号',
          ___manager: 'ご担当の管理者名',
          ___organization: '所属機関',
          ___division: '部署や役職',
          ___emailVerification: 'メール認証ログイン',
          ___originalPassword: '前のパスワード',
          ___password: '新しいパスワード',
          ___confirmed: '新しいパスワードの確認'
        },
        placeholder: {
          ___firstName: '花子',
          ___lastName: '山田',
          ___country: '日本',
          ___countryCode: '+886',
          ___phone: '電話番号',
          ___organization: 'コンパスバイオインフォマティクス株式会社',
          ___division: '臨床研究部門',
          ___originalPassword: '14～100文字を入力してください。',
          ___password: '14～100文字を入力してください。',
          ___confirmed: 'パスワードをもう一度入力してください。'
        },
        errorTitle: {
          ___originalPassword: 'パスワード',
          ___password: 'パスワード',
          ___confirmed: 'パスワード'
        },
        customValidate: {
          ___country: '国名の形式が間違っています。入力内容を再度確認してください。',
          ___countryCode: '国番号が存在していません。',
          ___confirmed: '入力されたパスワードが一致していません。',
          ___verificationCode: '認証コードが間違っています。'
        }
      }
    },
    systemInfo: {
      tab: {
        ___database: 'バージョン情報'
      },
      group: {
        ___version: 'バージョン',
        ___result: '{count}の項目',
        title: {
          ___pipeline: '解析パイプラインバージョン',
          ___analysis: 'アノテーションバージョン'
        }
      },
      table: {
        title: {
          ___category: 'カテゴリー',
          ___title: 'タイトル',
          ___version: 'バージョン'
        }
      }
    },
    panel: {
      tab: {
        ___phenotype: '表現型の設定',
        ___gene: '遺伝子パネル'
      }
    },
    config: {
      tab: {
        ___filter: '設定フィルター'
      }
    },
    workgroup: {
      tab: {
        ___case: '症例'
      }
    },
    genomeBrowser: {
      table: {
        title: {
          ___position: '位置 (HG38)',
          ___location: 'エクソンやイントロンの位置',
          ___HGVSc: 'HGVSc',
          ___HGVSp: 'HGVSp'
        }
      }
    },
    caseBatchUpload: {
      form: {
        title: {
          ___owner: '所有者'
        }
      },
      alert: {
        ___content: '<b>5日以内</b>に編集が行われない場合、本バッチアップロードに関するすべての記録<br>（VCFおよびサンプルシートを含む）は自動的に削除されます。',
        ___date: '<b>作成日:</b> {create} | <b>更新日:</b> {update}'
      }
    },
    caseDetail: {
      title: {
        ___deleted: '削除'
      },
      project: {
        title: {
          alert: {
            ___sexDifferent: '解析の性別情報が症例と異なっています。解析のパラメータを編集することで再解析が可能です。'
          }
        },
        card: {
          title: {
            ___modified: '更新日'
          }
        },
        info: {
          title: {
            ___status: 'ステータス',
            ___created: '作成日',
            ___modified: '更新日'
          }
        },
        icon: {
          title: {
            ___delete: '削除'
          }
        },
        detail: {
          intractablePanel: {
            ___title: 'D006-4 遺伝学的検査疾患名',
            ___less: '閉じる',
            ___more: '{count} もっと見る'
          },
          phenotype: {
            ___title: '表現型',
            ___less: '閉じる',
            ___more: '{count} もっと見る'
          },
          genePanel: {
            ___title: '遺伝子/疾患パネル',
            ___infoTitle: 'メンデル遺伝形式',
            ___info: 'スイッチがオンになっている場合、選択された遺伝子座はメンデル遺伝学の法則に従います。メンデル遺伝学の法則に適合しない遺伝子座をフィルタリングする理由は次の通りです: 1.NGS（次世代シーケンス）の技術的制限により、遺伝型の判断ミスが発生する可能性があります。 2.特定の疾患によって、遺伝子座がメンデル遺伝学の法則に適合しなくても症状が引き起こされることがあります。',
            ___less: '閉じる',
            ___more: '{count} もっと見る'
          },
          mendelian: {
            ___title: 'メンデル遺伝形式'
          },
          afThreshold: {
            ___title: 'MOIのAF閾値',
            ___info: 'アレル頻度の閾値は、疾患の流行率に依存するので、それに応じて調整すべきである。その値は0以上で1以下でなければならない。閾値を編集したい場合は、表現型の近くにある編集ボタンをクリックしてください。',
            item: {
              title: {
                ___ad: 'AD',
                ___compHet: '複合ヘテロ接合体',
                ___ar: 'AR',
                ___exclLQ: '低品質除外'
              }
            }
          },
          phenotypeVariant: {
            ___title: '表現型及びバリアントスコアの閾値',
            ___info: '表現型スコアは、ユーザーが提供した表現型に基づいて、類似性の観点から算出された。バリアントスコアは、複数の予測スコア（例：SIFT、CADDなど）と集団のアレル頻度から計算された。閾値を編集したい場合は、表現型の近くにある編集ボタンをクリックしてください。',
            item: {
              title: {
                ___phenotypeScore: '表現型スコア',
                ___variantScore: 'バリアントスコア'
              }
            }
          }
        }
      },
      top: {
        icon: {
          title: {
            ___digitalMLPA: 'digitalMLPA',
            ___file: 'ファイル',
            ___analysisVersion: '解析バージョン',
            ___qc: '品質管理',
            ___delete: '削除'
          }
        }
      },
      caseInfo: {
        title: {
          ___owner: '所有者',
          ___subjectName: '被検者名',
          ___sex: '性別',
          ___birthYear: '生年',
          ___population: '集団',
          ___note: '注釈',
          ___workgroup_name: 'ワークグループ',
          ___workgroup_stage: '- 作業段階',
          ___workgroup_due_date: '- 締切日',
          ___workgroup_assignee: '- 担当者'
        },
        empty: {
          ___birthYear: '不明'
        }
      },
      tab: {
        data: {
          ___defaultTitle: 'デフォルト',
          examinationIntractableDisease: {
            ___title: '保険検査と指定難病',
            subTab: {
              intractableDiseaseResults: {
                ___title: 'D006-4の結果'
              },
              designatedIntractableDiseaseResults: {
                ___title: '指定難病の結果'
              }
            }
          },
          diagnosticTest: {
            ___title: '解析結果',
            subTab: {
              intractableDiseaseResults: {
                ___title: 'D006-4の結果'
              },
              phenotypeResults: {
                ___title: '表現型の結果'
              },
              genePanelResults: {
                ___title: '遺伝子パネルの結果'
              },
              repeatResults: {
                ___title: 'repeatの結果'
              }
            }
          },
          proactiveTest: {
            ___title: 'プロアクティブ・テスト',
            subTab: {
              pathogenicVariants: {
                ___title: '病原性バリアント'
              },
              nullVariants: {
                ___title: 'ヌルバリアント'
              },
              carrier: {
                ___title: 'キャリア'
              },
              incidentalFindings: {
                ___title: '二次的所見'
              }
            }
          },
          filter: {
            ___title: 'フィルター'
          },
          monitor: {
            ___title: 'モニター'
          },
          report: {
            ___title: 'レポート'
          }
        },
        info: {
          ___limit: '記録が200件の上限に達しました。一部のデータはご利用いただけませんのでご了承ください。'
        }
      },
      displayView: {
        title: {
          ___SNV: 'SNV',
          ___SV: 'SV',
          ___STR: 'STR'
        }
      },
      edit: {
        ___info: 'NGSデータ（FASTQ、uBAMまたはVCF）をアップロードする前に、症例と解析情報を編集することができます。'
      },
      modal: {
        content: {
          ___delete: '症例を削除すると、その症例の結果はInheriNextから削除されます。この症例を削除しますか？',
          ___user: 'この症例は、PhenoVarDB の {dataset} のデータセット構築に使用されています。症例を削除する前に、上記のデータセットを削除してください。 | これらの症例は、PhenoVarDB の {dataset} のデータセット構築に使用されています。症例を削除する前に、上記のデータセットを削除してください。',
          ___admin: 'この症例は、PhenoVarDB の {dataset} のデータセット構築に使用されています。サンプルを削除すると、上記のデータセットへのアクセシビリティに影響が出ます。この症例を削除しますか？| これらの症例はPhenoVarDBの {dataset} のデータセットビルドに使用されています。サンプルを削除すると、上記のデータセットへのアクセスに影響があります。これらの症例を削除しますか？',
          ___truelyDelete: 'この症例のファイルおよび情報はすべて永久に削除されます。それでも続けますか？',
          ___truelyAdmin: 'この症例は、PhenoVarDBの {dataset} のデータセットビルドに使用されています。サンプルを削除すると、上記のデータセットへのアクセシビリティに影響が出ます。この症例を削除しますか？| これらの症例は、PhenoVarDBの {dataset} のデータセットビルドに使用されています。サンプルを削除すると、上記のデータセットへのアクセシビリティに影響が出ます。これらの症例を削除しますか？',
          ___restartPipeline: '<span style="color:#FA3D3D">エラーが修正されていることを確認してください。修正がされていない場合、解析が再び失敗する可能性があります。</span>',
          ___deleteProject: '<span style="color:#FF414D">解析を削除すると、関連する結果はInheriNextから削除されます。それでも削除しますか？</span>'
        }
      }
    },
    caseList: {
      tab: {
        title: {
          ___single: 'シングル'
        }
      }
    },
    datasetDetail: {
      top: {
        icon: {
          content: {
            ___adminAnnotation: '管理者の注釈を選択する。',
            ___annotation: '注釈を選択する。',
            ___unchiveDataset: 'データセットのアーカイブを解除する。',
            ___archiveDataset: 'データセットをアーカイブします。'
          }
        }
      },
      info: {
        title: {
          ___create: '作成日',
          ___modified: '更新日',
          ___sampleSize: 'サンプルサイズ',
          ___externalData: '外部データ',
          ___owner: '所有者',
          ___description: '詳細',
          ___tags: 'タグ一覧',
          ___sharing: '共有',
          ___users: 'ユーザー',
          ___datasetURL: 'データセットのURL',
          ___accessKey: 'アクセスキー'
        },
        content: {
          externalData: {
            ___yes: 'はい',
            ___no: 'いいえ'
          },
          sharing: {
            ___community: 'コミュニティー',
            ___notAvailable: 'ご利用できません。'
          },
          users: {
            ___users: '{count} ユーザー'
          }
        },
        icon: {
          title: {
            ___datasetURL: 'コピー'
          }
        }
      },
      tab: {
        title: {
          ___summary: '概要',
          ___samplesList: 'サンプルリスト'
        }
      },
      modal: {
        content: {
          ___deleteDataset: '<span style="color:#FF414D">このデータセットを削除すると、永久に削除されます。<br>データセットを削除しますか？</span>',
          ___setDatasetAnnotation01: 'この症例の集団データベースで、PhenoVarDB {type} の注釈にこのデータセットを選択してください。',
          ___setDatasetAnnotation02: 'PhenoVarDB {type} の注釈を更新するために、必ず症例を再度解析してください。',
          ___setDatasetAnnotation03: '<span>データセット {dataset} が注釈の為に選択されました。<br>このデータセットを選択しますか？</span>'
        }
      }
    },
    datasetList: {
      ___roleFilterTitle: '役割',
      ___roleFilterPlaceholder: 'すべて',
      ___sortTitle: '並び替え',
      ___searchPlaceholder: '検索するデータセットのキーワードを入力してください（例：乳がん）。',
      sortOption: {
        default: {
          title: {
            ___name: 'データセット名',
            ___createdAt: '作成日',
            ___updatedAt: '更新日',
            ___sampleSize: 'サンプルサイズ',
            ___externalDataIncluded: '外部データ',
            ___state: 'ステータス'
          }
        },
        community: {
          title: {
            ___name: 'データセット名',
            ___createdAt: '作成日',
            ___updatedAt: '更新日',
            ___sampleSize: 'サンプルサイズ',
            ___communityPermission: '権限'
          }
        }
      },
      tab: {
        title: {
          ___default: 'マイデータセット',
          ___community: 'コミュニティー'
        }
      },
      subTab: {
        default: {
        },
        community: {
          title: {
            ___default: 'コミュニティー・データセット',
            ___sharedWithMe: '共有されたデータセット',
            ___myShares: '私が共有したデータセット'
          }
        }
      }
    },
    common: {
      accountTab: {
        ___user: 'アカウント',
        ___workgroup: 'ワークグループ',
        ___panel: 'パネル',
        ___config: '構成',
        ___systemInfo: 'システム情報'
      }
    }
  },
  // component
  COMPONENT: {
    case: {
      base: {
        customForm: {
          affected: {
            ___title: '疾患あり<br>（Affected）'
          },
          reportPhenovardb: {
            ___off: 'オフ',
            ___on: 'オン'
          }
        },
        analysis: {
          ___title: '表現型の優先順位付け',
          ___familyTitle: '家族解析',
          panel: {
            ___title: '表現型パネル',
            ___empty: 'パネルがまだありません。こちらでパネルを作成できます。'
          },
          phenotype: {
            ___selectedTitle: '選択する',
            phenotypeTag: {
              ___placeholder: '表現型(例：呼吸困難)または疾患(例：乳がん)'
            }
          },
          gene: {
            ___title: '遺伝子フィルター',
            ___selectedTitle: '選択する',
            geneTag: {
              ___placeholder: '遺伝子パネル(例：健康関連所見の追加)'
            }
          },
          genePanel: {
            ___title: '遺伝子/疾患パネル'
          },
          alleleFrequencyThreshold: {
            ___title: '遺伝モードのアレル頻度閾値',
            ___info: 'アレル頻度の閾値は、疾患の流行率に依存するので、それに応じて調整すべきである。その値は0以上で1以下でなければならない。'
          },
          scoreThreshold: {
            ___title: '表現型・遺伝子パネル選択のスコア閾値',
            ___info: '表現型スコアは、ユーザーが提供した表現型に基づいて、類似性の観点から算出された。バリアントスコアは、複数の予測スコア（例：SIFT、CADDなど）と集団のアレル頻度から計算された。その値は0.6以上で1以下でなければならない。'
          },
          familyAnalysis: {
            ___title: '家族メンバー',
            alert: {
              ___vcf: 'この VCF ファイルの形式は家族解析に対応していません。'
            },
            option: {
              title: {
                ___excludeVariant: '家系分離アルゴリズムによりバリアントを除外する'
              }
            }
          }
        },
        file: {
          ___afterAlert: 'データなしでも後からアップロード可',
          ___cloudTitle: 'Google Bucketからアップロード',
          vcf: {
            ___title: 'VCFデータセット',
            file: {
              ___snvTitle: 'SNV/INDEL VCFファイル',
              ___svTitle: 'SV VCFファイル',
              ___strTitle: 'STR VCFファイル (ExpansionHunter/TRGT/Straglr)',
              ___svInfo: '複数のSV VCFファイルに対応しています（最大{count}つまで）。',
              ___source01: '現時点では、ゲノムビルドバージョン GRCh38/hg38 のみサポートしています。',
              ___source02: 'VCFファイルのゲノムビルドバージョンがアップロードされていることを確認してください。'

            }
          },
          fastq: {
            ___title: 'FASTQデータセット',
            file: {
              ___title: 'Set{set}-Fastq-{read}'
            }
          },
          ubam: {
            ___title: 'uBAMデータセット',
            file: {
              ___title: 'Set{set}-uBAM'
            }
          },
          alert: {
            ___content: '<b>重要なお知らせ！</b>ゲノムビルドバージョン GRCh38/hg38 のみサポートしています。VCFファイルのゲノムビルドバージョンがアップロードされていることを確認してください。'
          },
          pipeline: {
            title: {
              ___single: 'Single-end',
              ___paired: 'Paired-end'
            }
          }
        },
        option: {
          sex: {
            title: {
              ___male: '男性',
              ___female: '女性',
              ___unknown: '不明'
            }
          },
          popuplation: {
            title: {
              ___AfricanAfricanAmerican: 'アフリカン/アフリカ系アメリカ人',
              ___LatinoAdmixedAmerican: 'ラテン系/混血アメリカ人',
              ___AshkenaziJewish: 'アシュケナージ系ユダヤ人',
              ___EastAsian: '東アジア人',
              ___Koreans: '韓国人',
              ___Japanese: '日本人',
              ___OtherEastAsian: 'その他の東アジア人',
              ___Finnish: 'フィンランド人',
              ___NonFinnishEuropean: 'フィンランド以外のヨーロッパ人',
              ___Bulgarian: 'ブルガリア人',
              ___Estonian: 'エストニア人',
              ___NorthWesternEuropean: '北西ヨーロッパ人',
              ___SouthernEuropean: '南ヨーロッパ人',
              ___Swedish: 'スウェーデン人',
              ___OthernonFinnishEuropean: 'その他のフィンランド以外のヨーロッパ人',
              ___SouthAsian: '南アジア人',
              ___Other: 'その他'
            }
          }
        },
        form: {
          case: {
            title: {
              ___owner: '所有者',
              ___caseID: '症例ID',
              ___affected: 'サンプルの種類',
              ___subjectName: '被検者名',
              ___sex: '性別',
              ___birthYear: '生年',
              ___population: '集団',
              ___note: '注釈'
            },
            placeholder: {
              ___caseID: '症例ID',
              ___subjectName: 'John',
              ___sex: '性別',
              ___birthYear: '生年',
              ___population: '集団',
              ___note: '例：コンパスバイオインフォマティクス株式会社'
            },
            format: {
              affected: {
                ___true: '疾患あり<br>（Affected）',
                ___false: '疾患なし<br>（Unaffected）'
              }
            },
            option: {
              birthYear: {
                ___unknown: '不明'
              }
            }
          },
          analysis: {
            title: {
              ___name: '解析名',
              ___note: '解析注釈',
              ___report: 'PhenoVarDBに報告する'
            },
            placeholder: {
              ___name: '乳がんパネル',
              ___note: '例：コンパスバイオインフォマティクス株式会社'
            }
          },
          alleleFrequencyThreshold: {
            title: {
              ___ad_cutoff: '常染色体優性遺伝(AD)',
              ___ar_cutoff: '常染色体劣性遺伝(AR)',
              ___comp_het_cutoff: '複合ヘテロ接合性',
              ___exclude_low_quality_variants: 'LQバリアントを除外する。',
              ___enable_clinvar_benign_filter: '既知の良性バリアントの優先度は低い。'
            },
            errorTitle: {
              ___ad_cutoff: '常染色体優性遺伝(AD)',
              ___ar_cutoff: '常染色体劣性遺伝(AR)'
            },
            placeholder: {
              ___ad_cutoff: '0.001',
              ___ar_cutoff: '0.05',
              ___comp_het_cutoff: '0.05'
            }
          },
          scoreThreshold: {
            title: {
              ___phenotype_score_cutoff: '表現型スコア',
              ___variant_score_cutoff: 'バリアントスコア'
            },
            placeholder: {
              ___phenotype_score_cutoff: '0.3',
              ___variant_score_cutoff: '0.7'
            }
          },
          pipeline: {
            title: {
              ___omics_name: 'パイプライン'
            },
            errorTitle: {
              ___omics_name: 'オーミクス',
              ___pipeline_name: 'パイプライン',
              ___library_type_name: 'ライブラリーの種類'
            },
            placeholder: {
              ___omics_name: 'オーミクス',
              ___pipeline_name: '類型（例：WGS）',
              ___library_type_name: 'ライブラリーキット（例：Roche KAPA HyperExome kit）'
            }
          }
        }
      },
      baseFamilyCase: {
        ___searchPlaceholder: '症例ID（例：Case1）',
        table: {
          title: {
            ___case_id: '症例ID',
            ___type: 'サンプルの種類',
            ___relation: '関係'
          },
          option: {
            type: {
              title: {
                ___Affected: '疾患あり<br>（Affected）',
                ___Unaffected: '疾患なし</br>（Unaffected）'
              }
            },
            relation: {
              ___placeholder: '関係を選択してください'
            }
          }
        }
      },
      genotypeIcon: {
        altMessage: {
          relation: {
            ___father: '父',
            ___mother: '母',
            ___proband: '発端者'
          },
          result: {
            ___ref: 'ref',
            ___homo: 'homo',
            ___hemi: 'hemi',
            ___ref_hemi: 'ref',
            ___het: 'het',
            ___unknown: '不明'
          }
        }
      },
      diseaseIcon: {
        ___text01: '疾患に関連するHPOに<br>直接マップします。',
        ___text02: '疾患に関連するHPOに間接的にマップします。',
        ___text03: '類似性のパスは、提供されたHPO項から、長さ <b>{length}</b> 近隣のHPO項を介した疾患関連HPO項への関連性を示す。'
      },
      errorMessage: {
        ___uploading: 'データをアップロード中...',
        ___analyzing: 'データを解析中...',
        ___failed01: '予期しない問題が発生しました。',
        ___failed02: '現在、この問題を解決しています。',
        ___failed03: '予期しない問題が発生しました：'
      },
      intractableDisease: {
        select: {
          ___title: 'D006-4 遺伝学的検査'
        },
        switch: {
          ___title: '指定難病分析',
          switchButton: {
            ___off: 'オフ',
            ___on: 'オン'
          }
        },
        selectResult: {
          ___title: '選択する'
        }
      },
      mastermindFilterTable: {
        table: {
          title: {
            ___report: 'レポート',
            ___classification: '分類',
            ___variantIdentifiers: 'バリアント識別子',
            ___publications: '文献'
          },
          value: {
            ___publications: '{count} 文献 | {count} 文献',
            ___empty: 'Mastermind はロックされています。結果を表示するには、ロックを解除してください。'
          }
        }
      },
      mastermindPublicationTable: {
        table: {
          title: {
            ___no: 'No.',
            ___details: '詳細',
            ___PMID: 'PMID'
          },
          info: {
            details: {
              ___open: '(詳細)',
              ___hide: '非表示'
            }
          }
        },
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        }
      }
    },
    caseBatchUpload: {
      base: {
        modal: {
          content: {
            ___deleteSet: '<span style="color:#FA3D3D">この操作により、アップロード記録はすべて完全に削除されます。バッチアップロードを削除してもよろしいですか？</span>',
            ___confirmSuccess: '<span style="color:#003679"><b>{count} 件のサンプルの準備がすべて完了しました。</b>送信しますか？</span>',
            ___confirmFailed: '<span style="color:#FA3D3D"><b>{count} 件のサンプルが未準備です。</b>続行すると、未準備サンプルは作成されません。送信しますか？</span>'
          }
        }
      },
      sheetUpload: {
        form: {
          ___title: 'サンプルシート',
          ___info: '<span>テンプレート</span>'
        },
        result: {
          ___title: 'サンプルシートチェック',
          group: {
            title: {
              ___error: '{count} 件のエラー | {count} 件のエラー | {count} 件のエラー'
            },
            error: {
              ___invalidFilesize: 'ファイルサイズが大きすぎます'
            }
          }
        }
      },
      fileUpload: {
        form: {
          ___title: 'VCF データセット',
          upload: {
            ___title: 'ここにファイルをドラッグしてください',
            ___content: 'またはデバイスから<br><span>ファイルを選択</span> してください。'
          }
        },
        result: {
          ___title: 'ファイルをアップロード',
          ___info: '完了: <b>{upload}</b>/{total}',
          group: {
            title: {
              ___uploading: 'アップロード中 {info}',
              ___finished: '完了 {info}',
              ___failed: '失敗・エラー {info}'
            }
          },
          file: {
            info: {
              ___uploading: '(<span class=uploading>処理待ち</span>)',
              ___pending: '(<span class=uploading>保留中</span>)',
              ___finished: '(<span class=finished>完了</span>)',
              ___matched: '(<span class=finished>ファイル名が一致</span>)',
              error: {
                ___invalidFormat: '無効なファイル形式です',
                ___duplicatedFilename: 'ファイル名が重複しています',
                ___invalidFilesize: 'ファイルサイズが大きすぎます'
              }
            }
          }
        }
      },
      sheetResult: {
        ___title: 'アップロード内容を確認',
        ___info: '(<span>{count}/{total} が一致</span>)',
        search: {
          ___placeholder: '検索キーワードを入力してください（例：Case ID、性別 など）'
        },
        table: {
          title: {
            ___case_id: '症例ID',
            ___sampleType: 'サンプルの種類',
            ___sex: '性別',
            ___analysisName: '解析名',
            ___phenotype: '表現型',
            ___snvVCF: 'SNV VCF',
            ___svVCF: 'SV VCF',
            ___strVCF: 'STR VCF',
            ___delete: 'DEL',
            info: {
              ___phenotype: '表現型を編集する場合は、サンプルシートを更新のうえ再度アップロードしてください。'
            }
          },
          display: {
            sampleType: {
              ___true: '疾患あり<br>（Affected）',
              ___false: '疾患なし<br>（Unaffected）'
            },
            sex: {
              ___Male: 'M',
              ___Female: 'F',
              ___Unknown: 'U'
            }
          },
          content: {
            info: {
              ___phenotype: 'HPOデータベースに該当がありません。'
            },
            empty: {
              ___phenotype: '表現型なし',
              ___file: 'ファイルなし'
            }
          }
        },
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数： {display}'
        }
      }
    },
    caseDetail: {
      analysisVersionTable: {
        table: {
          title: {
            ___category: 'カテゴリー',
            ___name: '名称',
            ___version: 'バージョン',
            ___systemVersion: 'システムバージョン'
          }
        }
      },
      filter: {
        ___empty: '0件',
        table: {
          title: {
            ___CHROM: 'Chr',
            ___POS: 'Pos',
            ___REF: 'Ref / Alt',
            ___dbSNP_ID: 'rsID',
            ___Consequence: '変異タイプ',
            ___GT: '遺伝子型',
            ___SYMBOL: '遺伝子名',
            ___HGVSc: 'HGVSc',
            ___HGVSp: 'HGVSp'
          }
        },
        modal: {
          content: {
            ___retryAlert: '<span>ジョブが失敗しました。ジョブを再送信しますか？</span>'
          }
        }
      },
      dataList: {
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        },
        error: {
          ___text: '疾患の原因となりうるバリアントは見つかりませんでした。',
          ___empty: 'データなし'
        }
      },
      geneData: {
        table: {
          ___variantAlert: 'バリアントのフェージングは考慮されていません。',
          icon: {
            monitor: {
              ___title01: 'モニターに追加する',
              ___title02: 'モニターから外す'
            },
            report: {
              ___title01: 'レポートに追加する',
              ___title02: 'レポートから外す'
            }
          },
          title: {
            ___position: '位置<br>(HG38)',
            ___rank: 'エクソン/<br>イントロン<br>位置',
            ___HGVSm: 'HGVSm',
            ___HGVSc: 'HGVSc',
            ___HGVSp: 'HGVSp',
            ___Zygosity: '接合性',
            ___HeteroplasmyLevel: 'ヘテロプラスミー・<br>レベル(%)',
            ___Consequence: '変異タイプ',
            ___Prediction: '予測<br>スコア',
            ___AlleleFrequency: 'アレル頻度',
            ___Homoplasmy: 'ホモプラスミー<br>EAS AF',
            ___Heteroplasmy: 'ヘテロプラスミー<br>EAS AF',
            ___variantDatabase: 'バリアントデータベース',
            ___ACMG: 'ACMG',
            ___rsID: 'rs ID',
            ___parentalOrigin: '親由来'
          },
          link: {
            position: {
              ___UCSC: 'UCSC',
              ___Ensembl: 'Ensembl',
              ___Genomebrowser: 'ゲノム・ブラウザ'
            }
          }
        },
        mainLink: {
          title: {
            ___Pedigree: '家系図'
          }
        },
        externalLink: {
          title: {
            ___GHR: 'GHR',
            ___NCBI_Gene: 'NCBI Gene',
            ___OMIM: 'OMIM',
            ___UniProt: 'UniProt',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        intractableDiseaseLink: {
          title: {
            ___center: '難病情報センター',
            ___other: '他の関連情報',
            ___nando: 'NanbyoData 難病データ'
          }
        },
        condition: {
          ___title: '疾患',
          ___alert01: '二次的所見の報告を推奨する疾患。',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        },
        disease: {
          ___title: '選択した疾患の表現型ネットワーク',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        }
      },
      genePreviewDisplayForm: {
        mainFormOptions: {
          title: {
            ___1st: '第1カラム',
            ___2nd: '第2カラム'
          }
        }
      },
      geneClinvarData: {
        ___clinvarStatisticTitle: 'ClinVar遺伝子統計',
        table: {
          clinvar: {
            ___title: 'ClinVar',
            title: {
              ___interpretation: '解釈',
              ___reviewStatus: 'レビュー状況',
              ___condition: '疾患',
              ___conflicts: '競合'
            }
          }
        }
      },
      geneMastermindData: {
        ___lockAlert: 'Mastermind はロックされています。結果を表示するには、ロックを解除してください。',
        table: {
          mastermind: {
            ___title: 'Mastermind',
            title: {
              ___report: 'レポート',
              ___classification: '分類',
              ___variantIdentifiers: 'バリアント識別子',
              ___publications: '文献'
            },
            value: {
              ___publications: '{count} 文献 | {count} 文献'
            }
          },
          publication: {
            ___title: '<b>レポート {count}</b> の <b>{variant}</b> に関する文献詳細'
          }
        },
        modal: {
          content: {
            ___unlockReanalyze: 'この解析に<b>Mastermindのアノテーション</b>を適用しますか？適用後、システムがこのケースを再解析します。再解析が完了すると、更新された結果が表示されます。',
            ___unlockReanalyzeForOwner: '<b>{owner}の解析にMastermindのアノテーション</b>を適用しますか？この操作を実行すると、<span class=alert>あなたのライセンスのクオータが消費されます</span>。適用後、システムがこのケースを再解析し、再解析が完了すると更新された結果が表示されます。',
            ___unlockReload: 'この解析に<b>Mastermindのアノテーション</b>を適用しますか？適用後、ページが再読み込みされます。更新された結果を表示するには、このページを再度開いてください。',
            ___unlockReloadForOwner: '<b>{owner}の解析にMastermindのアノテーション</b>を適用しますか？この操作を実行すると、<span class=alert>あなたのライセンスのクオータが消費されます</span>。適用後、ページが再読み込みされます。更新された結果を表示するには、このページを再度開いてください。'
          }
        }
      },
      geneMitomapData: {
        table: {
          mitomap: {
            ___title: 'MITOMAP',
            title: {
              ___af: 'AF',
              ___heteroplasmy: 'ヘテロプラスミー',
              ___homoplasmy: 'ホモプラスミー',
              ___diseaseStatus: '病状',
              ___disease: '疾患',
              ___pubmedIDs: 'PubMed ID'
            }
          }
        }
      },
      regionData: {
        ___geneTitle: 'オーバーラップ遺伝子',
        table: {
          icon: {
            monitor: {
              ___title01: 'モニターに追加する',
              ___title02: 'モニターから外す'
            },
            report: {
              ___title01: 'レポートに追加する',
              ___title02: 'レポートから外す'
            }
          },
          title: {
            ___Cytoband: 'サイトバンド',
            ___Length: '長さ',
            ___Zygosity: '接合性',
            ___dbVar: 'dbVar',
            ___DECIPHER: 'DECIPHER',
            ___AF: 'AF',
            ___SV_Caller: 'SV コーラー',
            ___ACMG_SV: 'ACMG SV'
          },
          value: {
            Zygosity: {
              ___no_call: 'No call',
              ___unknown: 'Unknown',
              ___hemizygote: 'Hem',
              ___homozygote: 'Hom',
              ___heterozygote: 'Het'
            }
          }
        },
        externalLink: {
          title: {
            ___DGV: 'DGV',
            ___DECIPHER: 'DECIPHER',
            ___GHR: 'GHR',
            ___OMIM: 'OMIM',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        condition: {
          // ___title: '疾患',
          ___title: '上位5遺伝子と関連疾患',
          ___emptyText: '<a class=link>オーバーラップ遺伝子</a>をクリックすると、各遺伝子に関連する疾患が表示されます',
          ___alert01: '二次的所見の報告を推奨する疾患。',
          ___less: '閉じる',
          ___more: '{count} もっと見る',
          inheritance: {
            ___info: 'ほか {count} 件の疾患'
          }
        },
        disease: {
          ___title: 'DECIPHERの表現型ネットワーク',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        }
      },
      regionOverlappingGeneData: {
        table: {
          title: {
            ___Overlap_region: '重複領域',
            ___Dosage_sensitivity: '遺伝子量感受性',
            ___pLI: 'pLI',
            ___LOEUF: 'LOEUF'
          },
          content: {
            Dosage_sensitivity: {
              ___Haplo: 'Haplo',
              ___Triplo: 'Triplo'
            },
            pLI: {
              ___GenomAD: 'genomAD',
              ___ExAC: 'ExAC'
            }
          }
        },
        externalLink: {
          title: {
            ___GHR: 'GHR',
            ___NCBI_Gene: 'NCBI Gene',
            ___OMIM: 'OMIM',
            ___UniProt: 'UniProt',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        condition: {
          ___title: '関連する疾患',
          ___alert01: '二次的所見の報告を推奨する疾患。',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        },
        disease: {
          ___title: '選択した疾患の表現型ネットワーク',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        }
      },
      regionGeneData: {
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        }
      },
      regionVariantData: {
        ___overViewTitle: '概要',
        table: {
          dbVar: {
            title: {
              ___dbVarID: 'dbVar ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___Classification: '分類',
              ___Zygosity: '接合性',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する領域に関するアノテーション',
                type: {
                  ___pathogenic: '病原性SVの場合',
                  ___other: 'その他の場合'
                },
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          DECIPHER: {
            title: {
              ___DECIPHERID: 'DECIPHER ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___Classification: '分類',
              ___Zygosity: '接合性',
              ___Phenotype: '表現型',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する領域に関するアノテーション',
                type: {
                  ___pathogenic: '病原性SVの場合',
                  ___other: 'その他の場合'
                },
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            },
            content: {
              ___more: 'もっと見る'
            },
            detailData: {
              ___hideTitle: '非表示',
              phenotype: {
                ___title: '{id} の表現型リスト'
              }
            }
          },
          overlapInfo: {
            title: {
              ___db: 'データベース',
              ___sample: '症例'
            }
          }
        },
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        }
      },
      regionPublicationData: {
        table: {
          gnomAD: {
            title: {
              ___gnomADID: 'gnomAD ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___AlleleFrequency: 'アレル頻度',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する特徴についてのアノテーションアノテーション',
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          dbVar: {
            title: {
              ___dbVarID: 'dbVar ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___AlleleFrequency: 'アレル頻度',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する特徴についてのアノテーションアノテーション',
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          JSV2: {
            title: {
              ___JSV2ID: 'JSV2 ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___AlleleFrequency: 'アレル頻度',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する特徴についてのアノテーションアノテーション',
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          CoLoRSdb: {
            title: {
              ___CoLoRSdbID: 'CoLoRSdb ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___AlleleFrequency: 'アレル頻度',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する特徴についてのアノテーションアノテーション',
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          overlapInfo: {
            title: {
              ___db: 'データベース',
              ___sample: '症例'
            }
          }
        },
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        }
      },
      repeatData: {
        table: {
          ___variantAlert: 'バリアントのフェージングは考慮されていません。',
          icon: {
            monitor: {
              ___title01: 'モニターに追加する',
              ___title02: 'モニターから外す'
            },
            report: {
              ___title01: 'レポートに追加する',
              ___title02: 'レポートから外す'
            }
          },
          title: {
            ___position: '位置<br>(HG38)',
            ___Region: '領域',
            ___Repeat_unit: '反復単位',
            ___REF: '参照コピー数',
            ___ALT: 'ALT',
            ___Zygosity: '接合性',
            ___Allele_Repeat_Copy_Number: 'アレル反復回数<br>（CI）',
            ___Classification: '分類'
          }
        },
        externalLink: {
          title: {
            ___STRipy: 'STRipy',
            ___gnomAD: 'gnomAD',
            ___OMIM: 'OMIM',
            ___HPO: 'HPO'
          }
        },
        condition: {
          ___title: '疾患',
          ___alert01: '二次的所見の報告を推奨する疾患。',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        }
      },
      report: {
        ___editTitle: '報告書ツールボックス',
        ___templateTitle: 'テンプレート',
        ___reportTitle: '報告書のプレビューと編集',
        page: {
          title: {
            ___pre: '前章',
            ___next: '次章'
          }
        }
      }
    },
    caseList: {
      single: {
        ___roleFilterTitle: '役割',
        ___roleFilterPlaceholder: 'すべて',
        ___searchPlaceholder: 'キーワード（例：症例ID、名前、...）を入力して検索してください。',
        table: {
          title: {
            ___case_id: '症例ID',
            ___sex: '性別',
            ___birth_year: '生年',
            ___population: '集団',
            ___created_at: '作成日',
            ___updated_at: '更新日',
            ___user: '所有者',
            ___seq: 'Seq',
            ___state: '解析ステータス',
            ___note: '注釈',
            ___workgroup: 'ワークグループ',
            ___stage: '作業段階',
            ___due_date: '締切日',
            ___assignee: '担当者'
          },
          content: {
            seq: {
              ___WES: 'WES',
              ___WES_MT: 'WES+MT',
              ___WGS: 'WGS'
            },
            workgroup_stage: {
              ___select: '作業段階を選択してください'
            }
          },
          display: {
            sex: {
              ___Male: '男性',
              ___Female: '女性',
              ___Unknown: '不明'
            }
          }
        },
        modal: {
          content: {
            ___pointAlert: '<span style="color:#FA3D3D">症例を作成するには {price} ポイントが必要です。所持ポイントが足りません。追加購入しますか？</span>'
          }
        }
      }
    },
    digitalMLPA: {
      mainUpload: {
        upload: {
          ___title: 'XMLファイルをアップロード'
        },
        notification: {
          ___title: 'digitalMLPA 統合バージョン：{version}',
          ___content: '解析するサンプルについて、Coffalyserからエクスポートした.Coffa.xmlファイルをアップロードしてください。現在対応しているdigitalMLPAキットは、D001、D002、D006、D007、D008、D024、D028です。未対応のキットまたは未対応バージョンのキットで作成されたファイルは、現在解析できません。解析結果は、対応するCoffalyserの製品定義に基づき、元のパネル構成および内容を保持した状態で表示されます。'
        }
      },
      mainData: {
        status: {
          title: {
            ___analyzing: 'データ解析中…',
            ___error: '予期しない問題が発生しました。<br>現在、問題の解決を進めています。'
          }
        },
        info: {
          ___title: '基本情報・品質サマリー'
        },
        form: {
          Panel: {
            ___title: 'パネル',
            ___placeholder: 'パネルを選択してください'
          },
          Subpanel: {
            ___title: 'サブパネル',
            ___placeholder: 'サブパネルを選択してください'
          },
          Segment: {
            ___title: 'セグメント',
            data: {
              title: {
                ___Aberrant_Count: '異常数',
                ___Mean: '平均値',
                ___SD: '標準偏差',
                ___Med: '中央値',
                ___Min: '最小値',
                ___Max: '最大値',
                ___Range: '範囲'
              }
            }
          }
        }
      },
      mainDataInfo: {
        data: {
          info: {
            table: {
              Barcode_Name: {
                ___title: 'バーコード名'
              },
              Sample_Name: {
                ___title: 'サンプル名'
              },
              Sample_Type: {
                ___title: 'サンプルタイプ'
              },
              Product_Name: {
                ___title: '製品名 '
              },
              Sheet_Name: {
                ___title: 'シート名'
              },
              Analyzed_Sex: {
                ___title: '解析された性別',
                value: {
                  ___Male: '男性',
                  ___Female: '女性'
                }
              },
              Analyzed_Panels: {
                ___title: '解析済みパネル（異常：{count}）'
              }
            }
          },
          quality: {
            ___title: '品質',
            table: {
              Is_Passed: {
                ___title: '判定',
                value: {
                  ___Pass: '合格',
                  ___Failed: '不合格'
                }
              },
              Plausible_Root_Cause: {
                ___title: '推定原因',
                value: {
                  ___NotApplicable: '該当なし',
                  ___Others: 'その他'
                }
              },
              Plausible_Root_Cause_Description: {
                ___title: '推定原因の詳細',
                value: {
                  ___NA: '該当なし',
                  ___Others: 'その他'
                }
              }
            }
          }
        },
        table: {
          quality: {
            title: {
              ___Overall: '総合',
              ___Data_Analysis: 'データ解析',
              ___Dna: 'DNA',
              ___Hybridisation: 'ハイブリダイゼーション',
              ___Identity: '同一性',
              ___Ligase_Activity: 'リガーゼ活性',
              ___Ligation: 'ライゲーション',
              ___Polymerase: 'ポリメラーゼ',
              ___Program: 'プログラム',
              ___Sample_Run: 'サンプルラン'
            },
            content: {
              ___OK: '正常',
              ___Warning: '警告'
            },
            info: {
              ___OK: '{field} <b>正常</b>',
              ___Failed: '{field} <b>不合格</b>'
            }
          }
        }
      },
      mainDataChart: {
        chart: {
          axis: {
            title: {
              ___Copy_Number_Ratio: 'コピー数比(Copy Number Ratio)',
              ___Probe: 'プローブ'
            }
          }
        }
      },
      mainDataTable: {
        table: {
          topTitle: {
            ___Prob_Information: 'プローブ情報',
            ___Comparison_Reference_Samples: '比較用リファレンスサンプル',
            ___Sample_Results: 'サンプル解析結果'
          },
          title: {
            ___Probe_No: 'プローブ番号',
            ___Function: '機能',
            ___Location: '位置（kb）',
            ___Gene: '遺伝子',
            ___Exon: 'エクソン',
            ___CN_Exp: '期待コピー数',
            ___Ref_95: 'リファレンス95%',
            ___Exp_Range: '期待範囲',
            ___Result: '結果',
            ___Aberrant: '異常',
            ___Quality_issue: '品質上の問題'
          }
        }
      }
    },
    dataset: {
      base: {
        customForm: {
          tag: {
            ___dataTagPlaceholder: 'タグ名'
          }
        },
        picture: {
          ___title: 'データセット画像',
          ___customTitle: 'カスタム画像'
        },
        sample: {
          ___title: 'データセットのサンプル',
          ___info: '{count} 選択済みサンプル',
          viewTitle: {
            ___detail: '詳細表示',
            ___list: '一覧表示'
          },
          searchPlaceholder: {
            ___case: 'サンプルの症例ID',
            ___dataset: 'データセットのキーワード'
          },
          emptyText: {
            ___case: 'データセットにはサンプルが選択されていません。'
          }
        },
        sampleTable: {
          case: {
            ___case_id: '症例ID',
            ___sex: '性別',
            ___birth_year: '生年',
            ___created_at: '作成日',
            ___updated_at: '更新日'
          },
          dataset: {
            ___name: 'データセット名',
            ___sample_size: 'サンプルサイズ',
            ___user: 'ユーザー',
            ___detail: '詳細'
          }
        },
        sampleList: {
          title: {
            ___case: '選択済みサンプル',
            ___dataset: 'コミュニティー・データセット'
          }
        },
        form: {
          title: {
            ___owner: '所有者',
            ___name: 'データセット名',
            ___tag: 'タグを追加する',
            ___pipeline: 'パイプライン',
            ___description: 'データセットの説明'
          },
          placeholder: {
            ___name: 'データセット名',
            ___tag: 'タグ名',
            ___pipeline: 'パイプライン',
            ___description: 'データセットに関するあらゆる説明を注釈する。'
          },
          customValidate: {
            ___user_id: 'この名前はすでに使われています。',
            ___sample_size: 'サンプルサイズが小さすぎます。'
          }
        }
      },
      card: {
        annotation: {
          default: {
            ___info01: '全データを含むデータセットが、',
            ___info02: '注釈の為に選択されている。'
          },
          community: {
            ___info01: 'コミュニティー・データセットを含むデータセットが、',
            ___info02: '注釈の為に選択されている。'
          }
        },
        information: {
          title: {
            ___Create: '作成日',
            ___Modified: '更新日',
            ___Samplesize: 'サンプルサイズ',
            ___Pipeline: 'パイプライン',
            ___Externaldata: '外部データ',
            ___Status: 'ステータス',
            ___Permission: '権限',
            ___Description: '詳細',
            ___Owner: '所有者',
            ___Tags: 'タグ一覧'
          },
          value: {
            external_data_included: {
              ___Yes: 'はい',
              ___No: 'いいえ'
            }
          }
        }
      },
      disabledMsg: {
        ___title01: 'データセット {dataset} (時間 {time} に作成済み) から1つ以上のサンプル/データセットが削除されましたので、このデータセットはもうご利用になれません。下の表は、共有が解除されたデータセットを示しています。',
        ___title02: 'データセット {dataset} (時間 {time} に作成済み) から1つ以上のサンプル/データセットが削除されましたので、このデータセットはもうご利用になれません。',
        table: {
          title: {
            ___category: 'カテゴリー',
            ___title: 'データセット名 / 症例ID',
            ___modified: '更新日',
            ___owner: '所有者'
          }
        }
      },
      msg: {
        ___created: '解析の作成に失敗しました。',
        ___analyzing: 'データを解析中...',
        ___failed01: '予期しない問題が発生しました。',
        ___failed02: '現在、この問題を解決しています。',
        ___failed03: '予期しない問題が発生しました：'
      }
    },
    datasetDetail: {
      sample: {
        ___title: 'データセットには {count} つのサンプルがあります。',
        ___searchPlaceholder: 'サンプルの症例ID',
        viewTitle: {
          ___detail: '詳細表示',
          ___list: '一覧表示'
        },
        table: {
          title: {
            ___case_id: '症例ID',
            ___sex: '性別',
            ___birth_year: '生年',
            ___created_at: '作成日',
            ___updated_at: '更新日',
            ___dataset_name: 'データセット名',
            ___user: 'ユーザー'
          }
        }
      },
      share: {
        ___invitationIconTitle: 'コピー',
        customForm: {
          url: {
            icon: {
              ___title: 'コピー'
            }
          },
          public_permission: {
            ___title: '公開権限',
            ___alert: 'この権限によって、どんなユーザーでもあなたのデータセットの要約ページにアクセスできるようになる。あなたのデータ集合を一般に公開する場合、この権限を使用すると便利です。あなたのデータセットに機密情報が含まれている可能性がある場合は、この権限を使用しないでください。あなたが許可したユーザーに、あなたのデータセットを公開したい場合は、アクセスキーを使ってください。'
          },
          access_key: {
            ___title: 'アクセスキー'
          },
          invitation_permission: {
            ___selectPlaceholder: '権限を選択する'
          }
        },
        userList: {
          ___title: 'ユーザー一覧',
          ___info: 'このデータセットは {count} 人のユーザーと共有されています。'
        },
        table: {
          title: {
            ___user_id: 'ユーザーID（所属、メールアドレス）',
            ___permission: '権限',
            ___option: '編集'
          }
        },
        form: {
          title: {
            ___url: 'データセットのURL',
            ___community_permission: 'コミュニティー権限',
            ___invitation_url: '招待URL'
          }
        },
        modal: {
          content: {
            ___deleteShare: '<span>ユーザーを削除すると、権限も削除されます。ユーザーを削除しますか？</span>'
          }
        }
      },
      summary: {
        ___filterPlaceholder01: 'フィルター選択',
        ___filterPlaceholder02: 'オペレーター',
        ___filterSelectPlaceholder: '範囲',
        ___filterNumberPlaceholder: '範囲',
        ___conditionJoin: 'または',
        defaultOperatorOption: {
          title: {
            in: {
              ___true: '含む',
              ___false: '含まない'
            },
            like: {
              ___true: '含む',
              ___false: '含まない'
            }
          }
        },
        summaryFilter: {
          title: {
            ___VARIANT_CLASS: 'バリアント・クラス',
            ___F_MISSING: 'バリアント欠損率',
            ___AC: 'AC',
            ___AN: 'AN',
            ___AF: 'AF',
            ___NS: 'NS',
            ___DP: 'DP',
            ___AC_Het: 'AC Het',
            ___AC_Hom: 'AC Hom',
            ___AC_Hemi: 'AC Hemi',
            ___Consequence: '変異タイプ',
            ___SYMBOL: '遺伝子',
            ___Sex: '性別',
            ___HPO: 'HPO'
          },
          rangeOption: {
            title: {
              VARIANT_CLASS: {
                ___SNV: 'SNV',
                ___Ins: '挿入',
                ___Del: '欠失'
              },
              Sex: {
                ___Male: '男性',
                ___Female: '女性',
                ___Unknown: '不明'
              }
            }
          }
        },
        summaryMain: {
          title: {
            ___dataCounts: 'データ数',
            ___variantCounts: 'バリアント数',
            ___geneStatistics: '遺伝子統計',
            ___phenotypeStatistics: '表現型統計',
            ___consequenceStatistics: '変異タイプ別統計',
            ___consequencePerSample: 'サンプルごとの変異タイプ',
            ___populationDatabase: 'AF分布の比較'
          },
          option: {
            geneStatisticsType: {
              ___Caseaffected: '疾患のある症例（Case affected）',
              ___Variantcount: 'バリアント数'
            }
          },
          info: {
            geneStatistics: {
              ___info01: '罹患症例（Case affected）：遺伝子ごとの罹患症例の割合',
              ___info02: 'バリアント数：遺伝子ごとのバリアント数'
            },
            phenotypeStatistics: {
              ___info01: 'フェノグラムプロット。中央に示されている数字は、患者の表現型からHP:0000118へのパスの項の出現回数の合計を示す。'
            },
            consequenceStatistics: {
              ___info01: '変異タイプ別の割合。'
            },
            consequencePerSample: {
              ___info01: '変異タイプ別にグループ化したサンプルごとのバリアント数。'
            }
          }
        },
        chartOption: {
          geneStatisticstestChart: {
            ___yAxis01: '疾患のある症例（Case affected）の割合 %',
            ___yAxis02: 'バリアント数'
          },
          consequencePerSample: {
            ___xAxis: 'サンプルごとのバリアント数',
            ___yAxis: '件数',
            seriesName: {
              ___Missense: 'ミスセンス',
              ___Null: 'ヌル',
              ___Synonymous: 'シノニマス'
            }
          },
          populationDatabase: {
            ___xAxis: 'バリアント数 (M)',
            seriesName: {
              ___cohort: '私のコホート',
              ___TOPMED: '私のコホート + TOPMed',
              ___gnomAD: '私のコホート + gnomAD Genome',
              ___all: '私のコホート + TOPMed + gnomAD Genome'
            }
          }
        },
        dataTotal: {
          title: {
            ___Total: '合計',
            ___Male: '男性',
            ___Female: '女性'
          }
        },
        variantTotal: {
          title: {
            ___Total: '合計バリアント',
            ___SNV: 'SNVs',
            ___Ins: '挿入',
            ___Del: '欠失'
          }
        },
        consequenceMapDatas: {
          title: {
            ___transcript_ablation: 'Transcript ablation',
            ___splice_acceptor_variant: 'Splice acceptor variant',
            ___splice_donor_variant: 'Splice donor variant',
            ___stop_gained: 'Stop gained',
            ___frameshift_variant: 'Frameshift variant',
            ___stop_lost: 'Stop lost',
            ___start_lost: 'Start lost',
            ___transcript_amplification: 'Transcript amplification',
            ___inframe_insertion: 'Inframe insertion',
            ___inframe_deletion: 'Inframe deletion',
            ___missense_variant: 'Missense variant',
            ___protein_altering_variant: 'Protein altering variant',
            ___splice_region_variant: 'Splice region variant',
            ___incomplete_terminal_codon_variant: 'Incomplete terminal codon variant',
            ___start_retained_variant: 'Start retained variant',
            ___stop_retained_variant: 'Stop retained variant',
            ___synonymous_variant: 'Synonymous variant',
            ___coding_sequence_variant: 'Coding sequence variant',
            ___mature_miRNA_variant: 'Mature miRNA variant',
            ___5_prime_UTR_variant: '5 prime UTR variant',
            ___3_prime_UTR_variant: '3 prime UTR variant',
            ___non_coding_transcript_exon_variant: 'Non coding transcript exon variant',
            ___intron_variant: 'Intron variant',
            ___NMD_transcript_variant: 'NMD transcript variant',
            ___non_coding_transcript_variant: 'Non coding transcript variant',
            ___upstream_gene_variant: 'Upstream gene variant',
            ___downstream_gene_variant: 'Downstream gene variant',
            ___TFBS_ablation: 'TFBS ablation',
            ___TFBS_amplification: 'TFBS amplification',
            ___TF_binding_site_variant: 'TF binding site variant',
            ___regulatory_region_ablation: 'Regulatory region ablation',
            ___regulatory_region_amplification: 'Regulatory region amplification',
            ___feature_elongation: 'Feature elongation',
            ___regulatory_region_variant: 'Regulatory region variant',
            ___feature_truncation: 'Feature truncation',
            ___intergenic_variant: 'Intergenic variant'
          }
        }
      }
    },
    setting: {
      workgroupCase: {
        ___selectAll: 'すべて',
        ___emptyContent: '最初にワークグループをお選びください。',
        workgroupList: {
          ___roleTitle: '役割',
          ___roleSelectTitle: 'ユーザーを選択してください',
          group: {
            title: {
              ___default: '私のワークグループ (最大グループ数は{limit}組です)',
              ___shared: '共有ワークグループ'
            }
          }
        },
        workgroupResult: {
          member: {
            ___default: 'グループにメンバーがいません。 | グループに{count} 人のメンバーがいます。 | グループに{count} 人のメンバーがいます。'
          },
          case: {
            ___default: 'グループに症例がありません。 | グループに{count}件の症例があります。 | グループに{count}件の症例があります。'
          },
          stage: {
            ___default: 'グループに作業段階がありません。 | グループに{count}個の作業段階があります。 | グループに{count}個の作業段階があります。'
          }
        },
        workgroupData: {
          member: {
            ___title: 'メンバー'
          },
          case: {
            ___title: '症例'
          },
          stage: {
            ___title: '作業段階'
          }
        },
        form: {
          title: {
            ___name: 'グループ名',
            ___user: '作成者',
            ___createdAt: '作成日',
            ___updatedAt: '更新日',
            ___permissionSetting: '権限設定',
            ___userSetting: 'ユーザー設定'
          },
          placeholder: {
            ___name: 'グループ名を入力してください。'
          },
          switchData: {
            title: {
              ___memberChange: '<b>メンバー</b>にグループの症例編集を許可します。',
              ___memberEdit: '<b>メンバー</b>に症例の状態および割り当ての変更を許可します。',
              ___autoShare: 'このワークグループに症例を自動共有'
            },
            info: {
              ___memberChange: '症例の編集権限は初期設定でディレクターに付与されています。このオプションを設定することで、メンバーにも編集権限を付与するかどうかを選択できます。',
              ___autoShare: '有効にすると、今後アップロードするすべての症例が自動的にこのワークグループへ共有されます。'
            },
            disabled: {
              ___autoShare: '他のワークグループで自動共有がすでに有効になっています。'
            }
          }
        },
        modal: {
          content: {
            ___deleteWorkgroup: '<span style="color:#FF414D">グループを削除すると、共有症例およびメンバーも削除されます。 グループ：{name} を削除しますか？</span>',
            ___leaveWorkgroup: '<span style="color:#FF414D">グループを退出すると、共有症例も削除されます。グループ：{name} を退出されますか？</span>'
          }
        }
      },
      panelGene: {
        ___selectAll: 'すべて',
        ___panelSearchPlaceholder: '遺伝子パネル(例：健康関連所見の追加)',
        ___panelDefault: 'デフォルト',
        ___panelGeneCount: '{count} 遺伝子',
        ___emptyContent: 'まず遺伝子パネルを選択してください。',
        geneTag: {
          ___placeholder: '遺伝子（例：BRCA1）、表現型（例：頭痛）、疾患（例：乳がん）など。'
        },
        panelResult: {
          ___selected: '選択済み',
          gene: {
            ___type01: '自由入力',
            ___type02: 'ユーザー定義',
            ___title: '遺伝子',
            ___empty: '遺伝子なし'
          },
          panel: {
            ___title: 'パネル',
            ___empty: 'パネルなし'
          },
          phenotype: {
            ___title: '表現型',
            ___empty: '表現型なし'
          },
          condition: {
            ___title: '疾患',
            ___empty: '疾患なし'
          },
          pathway: {
            ___title: '経路',
            ___empty: '経路なし'
          }
        },
        panelData: {
          ___searchTitle: '遺伝子/疾患パネル',
          gene: {
            ___title: '遺伝子',
            freeTyping: {
              ___title: '自由入力リスト'
            },
            userDefined: {
              ___title: 'ユーザー定義',
              ___updateTitle: '新しいエクセルファイルで更新する。',
              ___updateTemplate: 'テンプレート',
              ___downloadList: 'ダウンロードリスト'
            }
          },
          panel: {
            ___title: 'パネル',
            item: {
              ___createdAt: '{time} にパネル <b>{panel}</b> へ追加',
              ___updatedAt: '最終更新時間：{time}'
            }
          },
          phenotype: {
            ___title: 'HPO表現型'
          },
          condition: {
            ___title: '疾患'
          },
          pathway: {
            ___title: '経路'
          }
        },
        form: {
          edit: {
            title: {
              ___name: '遺伝子パネル',
              ___newName: '新しい遺伝子パネル',
              ___division: 'ディビジョン',
              ___note: '注釈',
              ___updatedAt: '最終更新日',
              ___createdAt: '作成日'
            },
            placeholder: {
              ___name: '例：てんかん発作',
              ___division: 'ディビジョンを選択してください。',
              ___note: '注釈は自由に入力できます。'
            }
          },
          default: {
            title: {
              ___name: 'デフォルトの遺伝子パネル',
              ___division: 'ディビジョン'
            }
          }
        },
        modal: {
          content: {
            ___deletePanel: '<span style="color:#FF414D">このパネルを削除すると、中の設定もすべて削除されます。パネルを削除しますか？</span>',
            ___overwriteGeneList: '<span style="color:#FA3D3D">過去にアップロードした遺伝子リストを上書きしますか？</span>'
          }
        }
      },
      panelPhenotype: {
        ___emptyContent: 'まず表現型パネルを選択してください。',
        phenotypeTag: {
          ___placeholder: '表現型(例：呼吸困難)または疾患(例：乳がん)'
        },
        form: {
          title: {
            ___name: '表現型設定',
            ___newName: '新しい表現型設定'
          },
          placeholder: {
            ___name: '例：てんかん発作'
          }
        },
        table: {
          panel: {
            title: {
              ___panel: '表現型設定'
            }
          },
          phenotype: {
            title: {
              ___query: '表現型または疾患'
            }
          }
        },
        modal: {
          content: {
            ___deletePanel: '<span style="color:#FF414D">このパネルを削除すると、中の表現型も削除されます。パネルを削除しますか？</span>',
            ___deleteFromPanel: '<span style="color:#FF414D">パネル {panel} の表現型を削除しますか？</span>'
          }
        }
      },
      configFilter: {
        ___emptyContent: 'まず構成を選択してください。',
        form: {
          title: {
            ___name: '構成名',
            ___updatedAt: '最終更新日',
            ___createdAt: '作成日'
          },
          placeholder: {
            ___name: '構成名'
          }
        },
        table: {
          config: {
            title: {
              ___name: '構成名'
            }
          }
        },
        modal: {
          content: {
            ___deleteConfig: '<span style="color:#FF414D">フィルター構成 <br>{config} を削除しますか？</span>'
          }
        }
      }
    },
    workgroupCase: {
      memberTable: {
        title: {
          ___Name: 'ユーザー名',
          ___Organization: '所属機関・部署',
          ___Email: 'メールアドレス',
          ___Role: '役割',
          ___Edit: '編集'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">メンバーを削除すると、一部の共有症例も削除されます。メンバー：{member} を削除しますか？</span>'
          }
        }
      },
      caseTable: {
        title: {
          ___Case_ID: '症例ID',
          ___Owner: '所有者',
          ___Workgroup_Stage: '作業段階',
          ___Due_date: '締切日',
          ___Assignee: '担当者',
          ___Edit: '編集'
        },
        placeholder: {
          ___Workgroup_Stage: '作業段階を選択してください。'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">症例を削除すると、共有権限も削除されます。症例：{case} を削除しますか？</span>'
          }
        }
      },
      stageTable: {
        title: {
          ___Workgroup_Stage: '作業段階',
          ___Assignee: '担当者',
          ___Edit: '編集'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">作業段階を削除すると、自動割り当て機能も解除されます。作業段階：{stage} を削除しますか？</span>'
          }
        }
      }
    },
    config: {
      filter: {
        customConfig: {
          databaseSet: {
            ___valuePlaceholder: 'ex：0.001'
          },
          genePanel: {
            geneTag: {
              ___placeholder: '遺伝子、パネル、表現型、疾患。'
            }
          },
          rsID: {
            ___valuePlaceholder: 'rs123456'
          }
        },
        defaultPlaceholder: {
          ___compare: '>, …',
          ___select: 'タイプ',
          ___value: 'ナンバー'
        },
        selectOption: {
          criteria: {
            title: {
              ___union: '和集合',
              ___intersection: '積集合'
            },
            resultTitle: {
              ___union: '判定基準の和集合',
              ___intersection: '判定基準の積集合'
            }
          },
          annotation: {
            title: {
              ___withAnnotation: '注釈付き',
              ___withoutAnnotation: '注釈なし'
            },
            resultTitle: {
              ___withAnnotation: '注釈付き',
              ___withoutAnnotation: '注釈なし'
            }
          }
        },
        configOption: {
          qualityFilter: {
            ___title: '品質フィルター',
            configGroup: {
              default01: {
                config: {
                  filter_pass: {
                    ___valueTitle: 'フィルター・パス',
                    ___resultTitle: 'パス'
                  },
                  dp: {
                    ___switchTitle: 'DP'
                  },
                  ad: {
                    ___switchTitle: 'AD'
                  },
                  ad_dp: {
                    ___switchTitle: 'AD/DP'
                  },
                  genotype: {
                    ___switchTitle: '遺伝子型フィルター'
                  }
                }
              }
            }
          },
          populationDatabase: {
            ___title: '集団データベース',
            configGroup: {
              default01: {
                ___title: 'すべてのデータベース・セット',
                config: {
                  database_include_empty_values: {
                    ___valueTitle: '空の値を含む'
                  }
                }
              },
              populationDatabase_1000Genomes: {
                ___title: '1000 Genomes',
                config: {
                  KG_AF: {
                    ___checkTitle: 'AF'
                  },
                  KG_AFR_AF: {
                    ___checkTitle: 'AFR AF'
                  },
                  KG_AMR_AF: {
                    ___checkTitle: 'AMR AF'
                  },
                  KG_EAS_AF: {
                    ___checkTitle: 'EAS AF'
                  },
                  KG_EUR_AF: {
                    ___checkTitle: 'EUR AF'
                  },
                  KG_SAS_AF: {
                    ___checkTitle: 'SAS AF'
                  }
                }
              },
              populationDatabase_gnomAD: {
                ___title: 'gnomAD Exomes',
                config: {
                  gnomAD_AF: {
                    ___checkTitle: 'AF'
                  },
                  gnomAD_AFR_AF: {
                    ___checkTitle: 'AFR AF'
                  },
                  gnomAD_AMR_AF: {
                    ___checkTitle: 'AMR AF'
                  },
                  gnomAD_ASJ_AF: {
                    ___checkTitle: 'ASJ AF'
                  },
                  gnomAD_EAS_AF: {
                    ___checkTitle: 'EAS AF'
                  },
                  gnomAD_FIN_AF: {
                    ___checkTitle: 'FIN AF'
                  },
                  gnomAD_NFE_AF: {
                    ___checkTitle: 'NFE AF'
                  },
                  gnomAD_OTH_AF: {
                    ___checkTitle: 'OTH AF'
                  },
                  gnomAD_SAS_AF: {
                    ___checkTitle: 'SAS AF'
                  },
                  gnomAD_MID_AF: {
                    ___checkTitle: 'MID AF'
                  }
                }
              },
              populationDatabase_gnomAD_g: {
                ___title: 'gnomAD Genomes',
                config: {
                  gnomAD_g_AF: {
                    ___checkTitle: 'AF'
                  },
                  gnomAD_g_AF_afr: {
                    ___checkTitle: 'AFR AF'
                  },
                  gnomAD_g_AF_ami: {
                    ___checkTitle: 'AMI AF'
                  },
                  gnomAD_g_AF_amr: {
                    ___checkTitle: 'AMR AF'
                  },
                  gnomAD_g_AF_asj: {
                    ___checkTitle: 'ASJ AF'
                  },
                  gnomAD_g_AF_eas: {
                    ___checkTitle: 'EAS AF'
                  },
                  gnomAD_g_AF_fin: {
                    ___checkTitle: 'FIN AF'
                  },
                  gnomAD_g_AF_mid: {
                    ___checkTitle: 'MID AF'
                  },
                  gnomAD_g_AF_nfe: {
                    ___checkTitle: 'NFE AF'
                  },
                  gnomAD_g_AF_oth: {
                    ___checkTitle: 'OTH AF'
                  },
                  gnomAD_g_AF_sas: {
                    ___checkTitle: 'SAS AF'
                  },
                  gnomAD_g_mt_AF_het: {
                    ___checkTitle: 'ヘテロプラスミー AF'
                  },
                  gnomAD_g_mt_pop_AF_het_afr: {
                    ___checkTitle: 'ヘテロプラスミー AFR AF'
                  },
                  gnomAD_g_mt_pop_AF_het_ami: {
                    ___checkTitle: 'ヘテロプラスミー AMI AF'
                  },
                  gnomAD_g_mt_pop_AF_het_amr: {
                    ___checkTitle: 'ヘテロプラスミー AMR AF'
                  },
                  gnomAD_g_mt_pop_AF_het_asj: {
                    ___checkTitle: 'ヘテロプラスミー ASJ AF'
                  },
                  gnomAD_g_mt_pop_AF_het_eas: {
                    ___checkTitle: 'ヘテロプラスミー EAS AF'
                  },
                  gnomAD_g_mt_pop_AF_het_fin: {
                    ___checkTitle: 'ヘテロプラスミー FIN AF'
                  },
                  gnomAD_g_mt_pop_AF_het_mid: {
                    ___checkTitle: 'ヘテロプラスミー MID AF'
                  },
                  gnomAD_g_mt_pop_AF_het_nfe: {
                    ___checkTitle: 'ヘテロプラスミー NFE AF'
                  },
                  gnomAD_g_mt_pop_AF_het_oth: {
                    ___checkTitle: 'ヘテロプラスミー OTH AF'
                  },
                  gnomAD_g_mt_pop_AF_het_sas: {
                    ___checkTitle: 'ヘテロプラスミー SAS AF'
                  },
                  gnomAD_g_mt_AF_hom: {
                    ___checkTitle: 'ホモプラスミー AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_afr: {
                    ___checkTitle: 'ホモプラスミー AFR AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_ami: {
                    ___checkTitle: 'ホモプラスミー AMI AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_amr: {
                    ___checkTitle: 'ホモプラスミー AMR AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_asj: {
                    ___checkTitle: 'ホモプラスミー ASJ AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_eas: {
                    ___checkTitle: 'ホモプラスミー EAS AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_fin: {
                    ___checkTitle: 'ホモプラスミー FIN AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_mid: {
                    ___checkTitle: 'ホモプラスミー MID AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_nfe: {
                    ___checkTitle: 'ホモプラスミー NFE AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_oth: {
                    ___checkTitle: 'ホモプラスミー OTH AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_sas: {
                    ___checkTitle: 'ホモプラスミー SAS AF'
                  }
                }
              },
              populationDatabase_others: {
                ___title: 'その他',
                config: {
                  ExAC_AF: {
                    ___checkTitle: 'ExAC AF'
                  },
                  ESP6500_AA_AF: {
                    ___checkTitle: 'ESP6500 AA'
                  },
                  ESP6500_EA_AF: {
                    ___checkTitle: 'ESP6500 EA AF'
                  },
                  TW_AF: {
                    ___checkTitle: 'TW AF'
                  },
                  TOPMED_AF: {
                    ___checkTitle: 'TOPMed AF'
                  },
                  ChinaMAP_AF: {
                    ___checkTitle: 'ChinaMAP AF'
                  }
                }
              },
              default02: {
                ___title: '判定基準の設定'
              }
            }
          },
          computationalPredictiveData: {
            ___title: '計算・予測データ',
            configGroup: {
              default01: {
                config: {
                  predictive_include_empty_values: {
                    ___valueTitle: '空の値を含む'
                  }
                }
              },
              computationalPredictiveData_splicingImpact: {
                ___title: 'スプライシングの影響',
                config: {
                  ada_score: {
                    ___checkTitle: 'adaスコア'
                  },
                  rf_score: {
                    ___checkTitle: 'rfスコア'
                  },
                  CI_SpliceAI: {
                    ___checkTitle: 'CI SpliceAI'
                  },
                  SpliceAI_DS_AG: {
                    ___checkTitle: 'SpliceAI DS AG'
                  },
                  SpliceAI_DS_AL: {
                    ___checkTitle: 'SpliceAI DS AL'
                  },
                  SpliceAI_DS_DG: {
                    ___checkTitle: 'SpliceAI DS DG'
                  },
                  SpliceAI_DS_DL: {
                    ___checkTitle: 'SpliceAI DS DL'
                  }
                }
              },
              computationalPredictiveData_proteinFunction: {
                ___title: 'タンパク質機能',
                config: {
                  ESM1b: {
                    ___checkTitle: 'ESM1b'
                  },
                  ESM1b_pred: {
                    ___checkTitle: 'ESM1b予測'
                  },
                  VARITY_ER_LOO: {
                    ___checkTitle: 'VARITY ER LOO'
                  },
                  VARITY_ER_LOO_pred: {
                    ___checkTitle: 'VARITY ER LOO予測'
                  },
                  VARITY_R_LOO: {
                    ___checkTitle: 'VARITY R LOO'
                  },
                  VARITY_R_LOO_pred: {
                    ___checkTitle: 'VARITY R LOO予測'
                  },
                  VARITY_ER: {
                    ___checkTitle: 'VARITY ER'
                  },
                  VARITY_ER_pred: {
                    ___checkTitle: 'VARITY ER予測'
                  },
                  VARITY_R: {
                    ___checkTitle: 'VARITY R'
                  },
                  VARITY_R_pred: {
                    ___checkTitle: 'VARITY R予測'
                  },
                  Alphamissense_score: {
                    ___checkTitle: 'Alphamissenseスコア'
                  },
                  Alphamissense_class: {
                    ___checkTitle: 'Alphamissense class'
                  },
                  SIFT4G_score: {
                    ___checkTitle: 'SIFT4Gスコア'
                  },
                  SIFT4G_pred: {
                    ___checkTitle: 'SIFT4G予測'
                  },
                  Polyphen_score: {
                    ___checkTitle: 'Polyphen-2 HDIV'
                  },
                  Polyphen_pred: {
                    ___checkTitle: 'Polyphen-2 HDIV予測'
                  },
                  FATHMM_score: {
                    ___checkTitle: 'FATHMMスコア'
                  },
                  FATHMM_pred: {
                    ___checkTitle: 'FATHMM予測'
                  },
                  PROVEAN_score: {
                    ___checkTitle: 'PROVEANスコア'
                  },
                  PROVEAN_pred: {
                    ___checkTitle: 'PROVEAN予測'
                  }
                }
              },
              computationalPredictiveData_ensemble: {
                ___title: 'Ensemble',
                config: {
                  CADD_phred: {
                    ___checkTitle: 'CADD予測'
                  },
                  CADD_raw: {
                    ___checkTitle: 'CADD raw'
                  },
                  MetaLR_score: {
                    ___checkTitle: 'MetaLRスコア'
                  },
                  MetaLR_pred: {
                    ___checkTitle: 'MetaLR予測'
                  },
                  MetaSVM_score: {
                    ___checkTitle: 'MetaSVMスコア'
                  },
                  MetaSVM_pred: {
                    ___checkTitle: 'MetaSVM予測'
                  },
                  REVEL_score: {
                    ___checkTitle: 'REVELスコア'
                  },
                  REVEL_pred: {
                    ___checkTitle: 'REVEL予測'
                  },
                  BayesDel_noAF_score: {
                    ___checkTitle: 'BayesDel noAFスコア'
                  },
                  BayesDel_noAF_pred: {
                    ___checkTitle: 'BayesDel noAF予測'
                  }
                }
              },
              computationalPredictiveData_conservation: {
                ___title: 'コンサベーション',
                config: {
                  GERPpp_NR: {
                    ___checkTitle: 'GERP++ NR'
                  },
                  GERPpp_RS: {
                    ___checkTitle: 'GERP++ RS'
                  }
                }
              },
              computationalPredictiveData_gnomADConstraint: {
                ___title: 'gnomAD制約',
                config: {
                  oe_syn: {
                    ___checkTitle: 'シノニマス o/e'
                  },
                  oe_mis: {
                    ___checkTitle: 'ミスセンス o/e'
                  },
                  oe_lof: {
                    ___checkTitle: 'pLoF o/e'
                  },
                  syn_z: {
                    ___checkTitle: 'シノニマス z-スコア'
                  },
                  mis_z: {
                    ___checkTitle: 'ミスセンス z-スコア'
                  },
                  pLI: {
                    ___checkTitle: 'pLI'
                  }
                }
              },
              default02: {
                ___title: '判定基準の設定'
              }
            }
          },
          consequences: {
            ___title: '変異タイプ',
            configGroup: {
              consequences_high: {
                ___title: '高い',
                config: {
                  frameshift_elongation: {
                    ___valueTitle: 'Frameshift elongation'
                  },
                  frameshift_truncation: {
                    ___valueTitle: 'Frameshift truncation'
                  },
                  frameshift_variant: {
                    ___valueTitle: 'Frameshift variant'
                  },
                  splice_acceptor_variant: {
                    ___valueTitle: 'Splice acceptor variant'
                  },
                  splice_donor_variant: {
                    ___valueTitle: 'Splice donor variant'
                  },
                  start_lost: {
                    ___valueTitle: 'Start lost'
                  },
                  stop_gained: {
                    ___valueTitle: 'Stop gained'
                  },
                  stop_lost: {
                    ___valueTitle: 'Stop lost'
                  },
                  transcript_ablation: {
                    ___valueTitle: 'Transcript ablation'
                  },
                  transcript_amplification: {
                    ___valueTitle: 'Transcript amplification'
                  }
                }
              },
              consequences_low: {
                ___title: '低い',
                config: {
                  incomplete_terminal_codon_variant: {
                    ___valueTitle: 'Incomplete terminal codon variant'
                  },
                  splice_region_variant: {
                    ___valueTitle: 'Splice region variant'
                  },
                  start_retained_variant: {
                    ___valueTitle: 'Start retained variant'
                  },
                  stop_retained_variant: {
                    ___valueTitle: 'Stop retained variant'
                  },
                  synonymous_variant: {
                    ___valueTitle: 'Synonymous variant'
                  }
                }
              },
              consequences_moderate: {
                ___title: '中程度',
                config: {
                  direct_tandem_duplication: {
                    ___valueTitle: 'Direct tandem duplication'
                  },
                  disruptive_inframe_deletion: {
                    ___valueTitle: 'Disruptive inframe deletion'
                  },
                  disruptive_inframe_insertion: {
                    ___valueTitle: 'Disruptive inframe insertion'
                  },
                  inframe_deletion: {
                    ___valueTitle: 'Inframe deletion'
                  },
                  inframe_insertion: {
                    ___valueTitle: 'Inframe insertion'
                  },
                  missense_variant: {
                    ___valueTitle: 'Missense variant'
                  },
                  protein_altering_variant: {
                    ___valueTitle: 'Protein altering variant'
                  },
                  regulatory_region_ablation: {
                    ___valueTitle: 'Regulatory region ablation'
                  }
                }
              },
              consequences_modifier: {
                ___title: 'Modifier',
                config: {
                  __3_prime_UTR_exon_variant: {
                    ___valueTitle: '3 prime UTR exon variant'
                  },
                  __3_prime_UTR_intron_variant: {
                    ___valueTitle: '3 prime UTR intron variant'
                  },
                  __3_prime_UTR_variant: {
                    ___valueTitle: '3 prime UTR variant'
                  },
                  __5_prime_UTR_exon_variant: {
                    ___valueTitle: '5 prime UTR exon variant'
                  },
                  __5_prime_UTR_intron_variant: {
                    ___valueTitle: '5 prime UTR intron variant'
                  },
                  __5_prime_UTR_variant: {
                    ___valueTitle: '5 prime UTR variant'
                  },
                  coding_sequence_variant: {
                    ___valueTitle: 'Coding sequence variant'
                  },
                  coding_transcript_intron_variant: {
                    ___valueTitle: 'Coding transcript intron variant'
                  },
                  feature_elongation: {
                    ___valueTitle: 'Feature elongation'
                  },
                  feature_truncation: {
                    ___valueTitle: 'Feature truncation'
                  },
                  intergenic_variant: {
                    ___valueTitle: 'Intergenic variant'
                  },
                  intron_variant: {
                    ___valueTitle: 'Intron variant'
                  },
                  mature_miRNA_variant: {
                    ___valueTitle: 'Mature miRNA variant'
                  },
                  NMD_transcript_variant: {
                    ___valueTitle: 'NMD transcript variant'
                  },
                  non_coding_transcript_exon_variant: {
                    ___valueTitle: 'Non coding transcript exon variant'
                  },
                  non_coding_transcript_intron_variant: {
                    ___valueTitle: 'Non coding transcript intron variant'
                  },
                  non_coding_transcript_variant: {
                    ___valueTitle: 'Non coding transcript variant'
                  },
                  regulatory_region_amplification: {
                    ___valueTitle: 'Regulatory region amplification'
                  },
                  regulatory_region_variant: {
                    ___valueTitle: 'Regulatory region variant'
                  },
                  TF_binding_site_variant: {
                    ___valueTitle: 'TF binding site variant'
                  },
                  TFBS_ablation: {
                    ___valueTitle: 'TFBS ablation'
                  },
                  TFBS_amplification: {
                    ___valueTitle: 'TFBS amplification'
                  }
                }
              },
              default01: {
                config: {
                  consequences_exact_match: {
                    ___valueTitle: '完全一致'
                  }
                }
              }
            }
          },
          miscellaneous: {
            ___title: '種々雑多な',
            configGroup: {
              default01: {
                ___resultTitle: '遺伝子フィルター'
              },
              miscellaneous_genome_coordinate: {
                ___title: '遺伝子配列フィルター',
                ___resultTitle: '遺伝子フィルター',
                config: {
                  genome_coordinate_filter: {
                    ___valuePlaceholder: 'X or 1:12345-12345 or 1:13456-150213…'
                  }
                }
              },
              miscellaneous_rs_id: {
                ___title: 'rs ID フィルター',
                ___resultTitle: 'rs ID フィルター'
              },
              miscellaneous_clinVar: {
                ___title: 'ClinVar',
                config: {
                  clinvar_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  clinvar_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  clinvar_Uncertain_significance: {
                    ___valueTitle: 'Uncertain significance'
                  },
                  clinvar_Conflicting_interpretations_of_pathogenicity: {
                    ___valueTitle: 'Conflicting interpretations of pathogenicity'
                  },
                  clinvar_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  clinvar_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  clinvar_risk_factor: {
                    ___valueTitle: 'Risk factor'
                  },
                  clinvar_other: {
                    ___valueTitle: 'Other'
                  },
                  clinvar_drug_response: {
                    ___valueTitle: 'Drug response'
                  },
                  clinvar_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_mastermind: {
                ___title: 'Mastermind',
                config: {
                  mastermind_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  mastermind_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  mastermind_Conflict: {
                    ___valueTitle: 'Conflict'
                  },
                  mastermind_VUS: {
                    ___valueTitle: 'VUS'
                  },
                  mastermind_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  mastermind_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  mastermind_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_acmg: {
                ___title: 'ACMG分類',
                config: {
                  acmg_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  acmg_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  acmg_Uncertain_significance: {
                    ___valueTitle: 'Uncertain significance'
                  },
                  acmg_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  acmg_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  acmg_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              default02: {
                config: {
                  clinvar_exclude_selections: {
                    ___valueTitle: '選択項目を除く'
                  }
                }
              },
              miscellaneous_omim: {
                ___title: 'OMIM',
                config: {
                  omim_annotation_filter: {
                    ___switchTitle: 'OMIM注釈フィルター'
                  }
                }
              },
              miscellaneous_inheritance: {
                ___title: '継承',
                config: {
                  inheritance_AR: {
                    ___valueTitle: 'AR'
                  },
                  inheritance_AD: {
                    ___valueTitle: 'AD'
                  },
                  inheritance_XL: {
                    ___valueTitle: 'XL'
                  },
                  inheritance_XLD: {
                    ___valueTitle: 'XLD'
                  },
                  inheritance_XLR: {
                    ___valueTitle: 'XLR'
                  },
                  inheritance_YL: {
                    ___valueTitle: 'YL'
                  },
                  inheritance_DD: {
                    ___valueTitle: 'DD'
                  },
                  inheritance_DR: {
                    ___valueTitle: 'DR'
                  },
                  inheritance_IC: {
                    ___valueTitle: 'IC'
                  },
                  inheritance_Mi: {
                    ___valueTitle: 'Mi'
                  },
                  inheritance_Mu: {
                    ___valueTitle: 'Mu'
                  },
                  inheritance_PD: {
                    ___valueTitle: 'PD'
                  },
                  inheritance_PR: {
                    ___valueTitle: 'PR'
                  },
                  inheritance_SMo: {
                    ___valueTitle: 'SMo'
                  },
                  inheritance_SMu: {
                    ___valueTitle: 'SMu'
                  }
                }
              },
              miscellaneous_family_analysis: {
                ___title: 'Family analysis',
                config: {
                  family_analysis_AD_De_Novo: {
                    ___valueTitle: 'AD De Novo'
                  },
                  family_analysis_AD: {
                    ___valueTitle: 'AD'
                  },
                  family_analysis_AR_De_Novo: {
                    ___valueTitle: 'AR De Novo'
                  },
                  family_analysis_AR: {
                    ___valueTitle: 'AR'
                  },
                  family_analysis_AR_Compound_Heterozygosity: {
                    ___valueTitle: 'AR Compound Heterozygosity'
                  },
                  family_analysis_XL_De_Novo: {
                    ___valueTitle: 'XL De Novo'
                  },
                  family_analysis_XL: {
                    ___valueTitle: 'XL'
                  },
                  family_analysis_YL_De_Novo: {
                    ___valueTitle: 'YL De Novo'
                  },
                  family_analysis_YL: {
                    ___valueTitle: 'YL'
                  }
                }
              }
            }
          }
        }
      }
    },
    filter: {
      config: {
        ___title: 'フィルターツールボックス',
        ___selectPlaceholder: 'フィルター構成を選択してください。'
      },
      data: {
        tab: {
          title: {
            ___transcript: 'トランスクリプト',
            ___variantDatabase: 'バリアントデータベース',
            ___populationDatabase: '集団データベース',
            ___predictionScore: '予測スコア',
            ___samples: 'サンプル',
            ___acmg: 'ACMG',
            ___conditions: '疾患'
          }
        },
        table: {
          transcript: {
            title: {
              ___symbol: '遺伝子名',
              ___gene: '遺伝子',
              ___feature: 'トランスクリプト',
              ___biotype: 'バイオタイプ',
              ___rank: 'エクソン/<br>イントロン番号',
              ___HGVSc: 'HGVSc',
              ___HGVSp: 'HGVSp',
              ___cDNAPosition: 'cDNA位置',
              ___CDSPosition: 'CDS位置',
              ___proteinPosition: 'タンパク質位置'
            }
          },
          variantDB: {
            clinVar: {
              ___title: 'ClinVar',
              title: {
                ___clinVarAccession: 'ClinVarアクセッション',
                ___clinVarDisease_Name: 'ClinVar疾患名',
                ___clinVarCLNREVSTAT: 'ClinVarレビュー状況',
                ___cLINSIG: 'ClinVar解釈',
                ___cLINCONF: 'ClinVar競合'
              }
            },
            clinVarGeneStatistic: {
              ___title: 'ClinVar遺伝子統計'
            },
            mastermind: {
              ___title: 'Mastermind'
            },
            mitomap: {
              ___title: 'MITOMAP',
              title: {
                ___mitomapAF: 'AF',
                ___mitomapAachange: 'アミノ酸の変化',
                ___mitomapHomoplasmy: 'ホモプラスミー',
                ___mitomapHeteroplasmy: 'ヘテロプラスミー',
                ___mitomapPubmedIDs: 'PubMed ID',
                ___mitomapDisease: '疾患',
                ___mitomapDiseaseStatus: '病状',
                ___mitomapHGFL: 'HGFL'
              }
            }
          },
          populationDB: {
          },
          prediction: {
          },
          samples: {
            title: {
              ___case_id: '症例ID',
              ___genotype: '遺伝子型',
              ___DP: 'DP',
              ___RD: 'RD',
              ___AD: 'AD',
              ___GT_AF: 'アレル頻度',
              ___QUAL: 'QUAL',
              ___GQ: '遺伝子型品質',
              ___FILTER: 'フィルター',
              ___x10_cov: '遺伝子カバレッジ率(10X)',
              ___x20_cov: '遺伝子カバレッジ率(20X)',
              ___x2000_cov: '遺伝子カバレッジ率(2000X)',
              ___x3000_cov: '遺伝子カバレッジ率(3000X)'
            }
          },
          condition: {
            orphanet: {
              ___title: 'Orphanet',
              linkTitle: {
                ___orphanet: 'Orphanet'
              }
            },
            omim: {
              ___title: 'OMIM',
              linkTitle: {
                ___omim: 'OMIM'
              }
            }
          }
        }
      }
    },
    report: {
      config: {
        group: {
          chapter: {
            ___title: 'チャプターを編集する。',
            display: {
              ___variantEmpty: 'バリアントがまだ追加されていません。'
            }
          },
          variant: {
            ___title: 'モニターにあるバリアント',
            type: {
              ___snv: 'SNV',
              ___sv: 'SV'
            },
            configResult: {
              ___result: 'タグの付いたバリアントが {count} 個あります。'
            },
            result: {
              ___result: 'モニターで {count} 個のバリアントが選択されました。'
            }
          },
          cnv: {
            ___title: 'SVマネジメント',
            result: {
              ___result: 'セクションにSVが {count} 個あります。'
            }
          }
        },
        subChpater: {
          default: {
            title: {
              ___displaySummary: '結果の要約',
              ___displayDetails: '詳しい情報'
            }
          },
          portrait: {
            title: {
              ___displayDetails: '結果テーブル',
              ___displaySummary: 'テキスト説明'
            }
          }
        },
        modal: {
          content: {
            ___removeChapter: '<span style="color:#FA3D3D">チャプターを削除すると、中のコンテンツもすべて削除されます。このチャプターを削除しますか？</span>',
            ___removeFromChapter: '<span style="color:#FA3D3D">バリアントを削除すると、中のすべてのコンテンツも削除されます。このバリアントを削除しますか？</span>',
            ___removeCNVFromChapter: '<span style="color:#FA3D3D">バリアントを削除すると、中のすべてのコンテンツも削除されます。このバリアントを削除しますか？</span>'
          }
        }
      }
    },
    chat: {
      display: {
        ___stopMsg: '生成を停止しました。'
      },
      summary: {
        ___source: 'ソース：'
      }
    },
    user: {
      licenseManager: {
        ___empty: 'アクセスを有効化するには、営業担当者までお問い合わせください。',
        title: {
          ___License_ID: 'ライセンスID',
          ___Request_Code: 'ステップ1：アクティベーションリクエストコードを生成',
          ___Activation_Code: 'ステップ2：アクティベーションコードをアップロード',
          ___Licensed_Information: 'ライセンス情報'
        },
        file: {
          title: {
            ___Request_Code: 'request_code.txt',
            ___Activation_Code: 'activation_request_code.txt'
          }
        },
        table: {
          title: {
            ___Modules: 'モジュール',
            ___Status: 'ステータス',
            ___Started_at: '開始日',
            ___Expired_at: '有効期限',
            ___Licensed_Usage: 'ライセンス使用量 <h5>(残り/合計)</h5>'
          }
        },
        modal: {
          content: {
            ___removeCreateLicenseID: '<span style="color:#FA3D3D">ライセンスを削除すると、このライセンスを共有しているあなたおよび他のユーザーは、このライセンス機能にアクセスできなくなります。ライセンスを削除しますか？</span>',
            ___removeImportLicenseID: '<span style="color:#FA3D3D">ライセンスを削除すると、このライセンス機能にアクセスできなくなります。ライセンスを削除しますか？</span>'
          },
          confirm: {
            ___placeholder: '確認するには「{confirm}」と入力してください。'
          }
        }
      }
    },
    tool: {
      gcsResumable: {
        gcsTable: {
          title: {
            ___caseID: '症例ID',
            ___status: 'ステータス'
          }
        },
        groupState: {
          ___pending: 'ペンディング',
          ___failed: '失敗'
        }
      },
      geneTag: {
        ___empty: '該当する結果は見つかりませんでした。',
        ___filterTitle: '検索フィルター',
        info: {
          ___gene: '遺伝子',
          ___panel: '遺伝子パネル',
          ___hpo: '表現型',
          ___condition: '疾患',
          ___pathway: '経路',
          ___and: ''
        },
        title: {
          ___all: '全カテゴリ',
          ___gene: '遺伝子',
          ___panel: 'パネル',
          ___hpo: '表現型',
          ___condition: '疾患',
          ___pathway: '経路'
        }
      },
      phenotypeTag: {
        info: {
          ___hpo: '表現型',
          ___disease_term: '疾患',
          ___show: '表示',
          ___and: '追加'
        },
        title: {
          ___hpo: '表現型',
          ___disease_term: '疾患'
        },
        ___empty: '該当する結果は見つかりませんでした。'
      },
      igv: {
        ___loading: '読み込み中...'
      },
      toast: {
        title: {
          ___error: 'エラー！',
          ___warning: '警告！',
          ___notice: 'ご注意！',
          ___success: '成功！'
        }
      }
    }
  },
  // dialog
  DIALOG: {
    addLicenseID: {
      ___title: 'ライセンスIDのインポート',
      ___or: 'または',
      form: {
        title: {
          ___create: 'IDを新規作成',
          ___import: '既存のライセンスIDをインポート'
        },
        placeholder: {
          ___import: 'ライセンスIDを入力してください'
        }
      }
    },
    addToPanel: {
      ___or: 'または',
      form: {
        title: {
          ___phenotype: '表現型',
          ___panel: 'パネルを選択してください。',
          ___newPanel: '新しいパネルに追加する。'
        },
        placeholder: {
          ___panel: 'ご希望のパネルを選択してください。',
          ___newPanel: 'パネル名を新規作成してください。'
        },
        alert: {
          newPanel: {
            ___required: '新しいパネル名は必須です。'
          }
        }
      }
    },
    addVariantToChapter: {
      variant: {
        ___title: 'チャプターにバリアントを追加してください。'
      },
      chapter: {
        ___title: '最低1チャプターを選択してください。'
      }
    },
    caseConfirm: {
      ___datasetTitle: '{type} データセット',
      ___pipelineTitle: 'パイプライン',
      ___snvVcfTitle: 'SNV/INDEL VCFファイル',
      ___svVcfTitle: 'SV VCFファイル',
      ___strVcfTitle: 'STR VCFファイル (ExpansionHunter/TRGT/Straglr)',
      ___fastqTitle: 'Set{set}-Fastq-{read}',
      ___ubamTitle: 'Set{set}-uBAM',
      form: {
        case: {
          title: {
            ___caseID: '症例ID',
            ___affected: 'サンプルの種類',
            ___subjectName: '被検者名',
            ___sex: '性別',
            ___birthYear: '生年',
            ___population: '集団',
            ___note: '注釈'
          },
          format: {
            affected: {
              ___true: '疾患あり（Affected）',
              ___false: '疾患なし（Unaffected）'
            },
            sex: {
              ___male: '男性',
              ___female: '女性',
              ___unknown: '不明'
            },
            birthYear: {
              ___empty: '不明'
            }
          }
        },
        analysis: {
          title: {
            ___name: '解析名',
            ___note: '解析注釈',
            ___reportPhenovardb: 'PhenoVarDBに報告する',
            ___intractableDisease: 'D006-4 遺伝学的検査',
            ___intractableDiseaseTag: '指定難病分析',
            ___phenotype: '表現型',
            ___genePanel: '遺伝子パネル',
            ___aft: '遺伝モードのアレル頻度閾値',
            ___st: '表現型・遺伝子パネル選択のスコア閾値'
          },
          aft: {
            title: {
              ___ad_cutoff: 'AD',
              ___ar_cutoff: 'AR',
              ___exclude_low_quality_variants: 'LQバリアントを除く',
              ___comp_het_cutoff: '複合ヘテロ接合性',
              ___enable_clinvar_benign_filter: '既知の良性バリアントの優先度は低い。'
            },
            display: {
              exclude_low_quality_variants: {
                ___true: 'オン',
                ___false: 'オフ'
              },
              enable_clinvar_benign_filter: {
                ___true: 'オン',
                ___false: 'オフ'
              }
            }
          },
          st: {
            title: {
              phenotype_score_cutoff: '表現型スコア',
              variant_score_cutoff: 'バリアントスコア'
            }
          },
          format: {
            reportPhenovardb: {
              ___true: 'オン',
              ___false: 'オフ'
            },
            intractableDiseaseTag: {
              ___true: 'オフ',
              ___false: 'オン'
            }
          }
        }
      },
      modal: {
        content: {
          ___unknownSexAlert: '<span style="color:#FA3D3D">性別が不明な場合、後の解析結果に影響を与える可能性があります。それでも続けますか？</span>'
        }
      }
    },
    caseDetailGenePedigree: {
      ___title: '家系図'
    },
    caseDetailGeneACMG: {
      ___title: 'ACMG',
      ___tabTitle: '判定基準',
      table: {
        title: {
          ___benignCriteria: 'Benignの判定基準',
          ___pathogenicCriteria: 'Pathogenicの判定基準',
          ___strengthofEvidence: 'エビデンスの強度',
          ___strong: '強い',
          ___supporting: '支持的（Supporting）',
          ___moderate: '中程度',
          ___veryStrong: '非常に強い',
          ___populationData: '集団データ',
          ___allelicEvidenceCosegrgationData: '対立遺伝子エビデンスと<br>共分離データ',
          ___computationPredictiveData: '計算・<br>予測データ',
          ___functionalData: '機能データ',
          ___other: 'その他',
          ___automatedCriteria: '自動化基準',
          ___explanation: '説明'
        }
      }
    },
    caseDetailGeneVariantDatabase: {
      ___title: 'バリアントデータベース',
      tab: {
        title: {
          ___clinvar: 'ClinVar',
          ___mastermind: 'Mastermind',
          ___MITOMAP: 'MITOMAP'
        }
      }
    },
    caseDetailGeneQuality: {
      ___title: '品質管理',
      pass: {
        readDepth: {
          ___pass: 'リード深度 ≥ 10<br>の場合は、可とする。',
          ___noPass: 'リード深度 < 10<br>の場合は、不可とする。'
        },
        genotypeQuality: {
          ___pass: '品質 ≥ 20 の場合は、<br>適合です。',
          ___noPass: '品質 < 20 の場合は、<br>不適合です。'
        },
        alleleFractions: {
          ___pass: 'アレル割合が基準を<br>満たしています。',
          ___noPass: 'アレル割合が基準を<br>満たしていません。'
        }
      },
      table: {
        family: {
          title: {
            ___case_id: '症例ID',
            ___relation: '関係',
            ___ra: 'Ref/Alt'
          }
        },
        default: {
          title: {
            ___genotype: '遺伝子型',
            ___readDepth: 'リード深度',
            ___alleleFractions: 'アレル割合',
            ___genotypeQuality: '遺伝子型品質',
            ___geneCoverage: '遺伝子カバレッジ率(CDS)'
          },
          option: {
            geneCoverage: {
              ___x10Cov: '10X',
              ___x20Cov: '20X'
            }
          }
        },
        mt: {
          title: {
            ___readDepth: 'リード深度',
            ___alleleFractions: 'アレル割合',
            ___geneCoverage: '遺伝子カバレッジ率(CDS)'
          },
          option: {
            geneCoverage: {
              ___x2000Cov: '2000X',
              ___x3000Cov: '3000X'
            }
          }
        }
      }
    },
    caseDetailGenePreview: {
      ___psTitle: '予測スコア',
      ___pdTitle: '集団データベース',
      tab: {
        title: {
          ___display: '表示するDBを選択',
          ___select: '選択されたDB'
        },
        info: {
          select: {
            ___ps: '<b style=color:#003679>最大{limit}つのデータベースを選択できます<span>（現在 {count} / {limit} 件選択中）</span>。選択したデータベースがテーブルに表示されます。</b>'
          }
        }
      }
    },
    caseDetailRegionGene: {
      ___title: '遺伝子リスト'
    },
    caseDetailRegionQuality: {
      ___title: '品質と情報',
      ___infoTitle: '情報',
      pass: {
        genotypeQuality: {
          ___pass: '品質 ≥ 15 の場合は、適合です。',
          ___noPass: '品質 < 15 の場合は、不適合です。'
        }
      },
      table: {
        default: {
          title: {
            ___genotype: '遺伝子型',
            ___filter: 'フィルター',
            ___genotypeQuality: '遺伝子型品質',
            ___phredScaled: 'Phred スケールの遺伝子型尤度',
            ___PairedRead: 'ペアリード',
            ___SplitRead: 'スプリットリード'
          }
        },
        info: {
          title: {
            ___IMPRECISE: 'IMPRECISE',
            ___Confidence: '位置の信頼区間（CI）',
            ___SV_Length: 'SV 挿入長',
            ___BF: 'BF',
            ___RATIO: 'RATIO',
            ___SV_Sequence: 'SV 挿入配列'
          }
        }
      }
    },
    caseDetailRegionVariant: {
      ___title: 'バリアントデータベース',
      tab: {
        title: {
          ___dbVar: 'dbVar',
          ___DECIPHER: 'DECIPHER'
        }
      }
    },
    caseDetailRegionPublication: {
      ___title: '集団データベース',
      tab: {
        title: {
          ___gnomAD_SV: 'gnomAD SV',
          ___dbVar: 'dbVar',
          ___JSV2: 'JSV2',
          ___CoLoRSdb: 'CoLoRSdb'
        }
      }
    },
    caseDetailRegionCaller: {
      ___title: 'コーラーの詳細（{count}件）',
      table: {
        title: {
          ___caller: 'コーラー',
          ___description: '説明'
        }
      }
    },
    caseEdit: {
      modal: {
        content: {
          ___changeOwner: '<span style="color:#FA3D3D">所有者を変更すると、症例は {old_owner} から {new_owner} に転送されます。このまま転送しますか？</span>'
        }
      }
    },
    caseDigitalMLPA: {
      ___title: 'DigitalMLPA',
      ___empty: '解析結果がありません',
      card: {
        title: {
          ___created: '作成日'
        }
      },
      top: {
        icon: {
          title: {
            ___delete: '削除'
          }
        }
      },
      modal: {
        content: {
          ___deleteAlert: '<span style="color:#FA3D3D">この解析を削除すると、解析内のすべてのデータも削除されます。この解析を削除しますか？</span>'
        }
      }
    },
    caseFile: {
      ___title: 'データ情報',
      vcf: {
        ___snvTitle: 'SNV/INDEL VCFファイル',
        ___svTitle: 'SV VCFファイル',
        ___strTitle: 'STR VCFファイル (ExpansionHunter/TRGT/Straglr)'
      },
      fastq: {
        ___title: 'Fastqファイル',
        ___file: '<b>Set{set}-{read}: </b>{file}',
        infoTitle: {
          ___omics: 'オーミクス',
          ___pipeline: 'パイプライン',
          ___libraryType: 'ライブラリーの種類',
          ___totalBases: '合計ベース数'
        }
      },
      ubam: {
        ___title: 'uBAMファイル',
        ___file: '<b>Set{set}: </b>{file}',
        infoTitle: {
          ___omics: 'オーミクス',
          ___pipeline: 'パイプライン',
          ___libraryType: 'ライブラリーの種類',
          ___totalBases: '合計ベース数'
        }
      },
      limit: {
        ___limitInfo: '帯域制限のため、<b>大容量ファイル（BAM ファイル等）のダウンロードは既定で 1 回のみ</b>です。追加が必要な場合は営業担当者までお問い合わせください。',
        ___limitAlert: 'ダウンロードは 1 回のみ可能です',
        ___times: 'ダウンロード回数：{times}'
      }
    },
    caseAnalysisVersion: {
      ___title: '解析バージョン',
      mainData: {
        title: {
          ___pipeline: '解析パイプラインバージョン<span>（解析 第1段階）</span>',
          ___analysis: 'アノテーションバージョン<span>（解析 第2段階）</span>'
        }
      },
      tableData: {
        pipeline: {
          category: {
            ___Hardware_Accelerated_Pipeline: 'Hardware-Accelerated Pipeline',
            ___GPU_Accelerated_Pipeline_Wrapper: 'GPU-Accelerated Pipeline Wrapper',
            ___Read_Aligner_GPU_Accelerated: 'Read Aligner (GPU-Accelerated)',
            ___Read_Aligner: 'Read Aligner',
            ___Variant_Caller_GPU_Accelerated: 'Variant Caller (GPU-Accelerated)',
            ___Variant_Caller_Mitochondria: 'Variant Caller (Mitochondria)',
            ___Variant_Phasing_Tool: 'Variant Phasing Tool',
            ___Structural_Variant_Caller: 'Structural Variant Caller',
            ___CNV_Caller_Exome_Based: 'CNV Caller (Exome-Based)',
            ___CNV_Caller_Control_Dataset: 'CNV Caller Control Dataset',
            ___CNV_Caller_WGS: 'CNV Caller (WGS)',
            ___Repeat_Expansion_Caller: 'Repeat Expansion Caller',
            ___HLA_Aligner: 'HLA Aligner',
            ___HLA_Genotyper: 'HLA Genotyper',
            ___Methylation_Caller: 'Methylation Caller',
            ___Pharmacogenomics_Tools: 'Pharmacogenomics Tools'
          },
          name: {
            ___DRAGEN: 'DRAGEN',
            ___Parabrick_pbrun: 'Parabrick pbrun',
            ___Parabrick_BWA_mem: 'Parabrick BWA mem',
            ___Parabricks_Minimap2: 'Parabricks Minimap2',
            ___Minimap2: 'Minimap2',
            ___Parabrick_deepvariant: 'Parabrick deepvariant',
            ___Mitorsaw: 'Mitorsaw',
            ___GATK: 'GATK',
            ___WhatsHap: 'WhatsHap',
            ___Hiphase: 'Hiphase',
            ___Manta: 'Manta',
            ___CuteSV: 'CuteSV',
            ___Sawfish: 'Sawfish',
            ___MitoSAlt: 'MitoSAlt',
            ___Sniffles: 'Sniffles',
            ___ExomeDepth: 'ExomeDepth',
            ___ExomeDepth_Baseline: 'ExomeDepth Baseline',
            ___CNVpytor: 'CNVpytor',
            ___ExpansionHunter: 'ExpansionHunter',
            ___TRGT: 'TRGT',
            ___Straglr: 'Straglr',
            ___HISAT2: 'HISAT2',
            ___HISAT_genotype: 'HISAT-genotype',
            ___Methbat: 'Methbat',
            ___Modkit: 'Modkit',
            ___PharmCAT: 'PharmCAT',
            ___pb_StarPhase: 'pb-StarPhase'
          }
        },
        analysis: {
          category: {
            ___Variant_Annotation_Tools: 'Variant Annotation Tools',
            ___Variant_Annotation_Tools_Database: 'Variant Annotation Tools Database',
            ___Canonical_Transcript_Reference: 'Canonical Transcript Reference',
            ___Protein_Function_Database: 'Protein Function Database',
            ___NCBI_RefSeq_Nucleotide_Protein_Mapping: 'NCBI RefSeq Nucleotide–Protein Mapping',
            ___Structural_Variant_Database: 'Structural Variant Database',
            ___Population_Frequency_Database: 'Population Frequency Database',
            ___Clinical_Variant_Database: 'Clinical Variant Database',
            ___In_Silico_Prediction_Database: 'In Silico Prediction Database',
            ___Variant_Identifier_Database: 'Variant Identifier Database',
            ___Disease_Gene_Database: 'Disease Gene Database',
            ___Mitochondrial_Variant_Database: 'Mitochondrial Variant Database',
            ___Phenotype_Ontology_Database: 'Phenotype Ontology Database',
            ___Others: 'Others'
          },
          name: {
            ___Jannovar: 'Jannovar',
            ___VEP: 'VEP',
            ___AnnotSV: 'AnnotSV',
            ___Jannovar_DB_Version: 'Jannovar DB Version',
            ___MANE: 'MANE',
            ___UniProt: 'UniProt',
            ___Refseq_nuc_prot: 'Refseq_nuc_prot',
            ___dbVar: 'dbVar (SV)',
            ___Decipher: 'DECIPHER (SV)',
            ___GnomAD: 'gnomAD (SV)',
            ___ClinVar: 'ClinVar',
            ___Mastermind: 'Mastermind',
            ___dbNSFP: 'dbNSFP',
            ___dbscSNV: 'dbscSNV',
            ___SpliceAI: 'CI-SpliceAI',
            ___AlphaMissense: 'AlphaMissense',
            ___VARITY: 'VARITY',
            ___ESM1b: 'ESM1b',
            ___dbSNP: 'dbSNP',
            ___ESP6500: 'ESP6500',
            ___ExAC: 'ExAC',
            ___GenomeAsia_100K: 'GenomeAsia 100K',
            ___gnomAD_Exomes: 'gnomAD Exomes',
            ___gnomAD_Exomes_Coverage: 'gnomAD Exomes Coverage',
            ___gnomAD_Exomes_constraint: 'gnomAD Exomes constraint',
            ___gnomAD_Genomes: 'gnomAD Genomes',
            ___gnomAD_Genomes_Coverage: 'gnomAD Genomes Coverage',
            ___gnomAD_Genomes_mtDNA: 'gnomAD Genomes mtDNA',
            ___1000_Genomes: '1000 Genomes',
            ___TaiwanBioBank: 'Taiwan BioBank',
            ___tommo_60kjpn: 'ToMMo 60KJPN',
            ___TOPMed: 'TOPMed',
            ___OMIM: 'OMIM',
            ___Orphanet: 'Orphanet',
            ___Mondo: 'Mondo',
            ___MITOMAP: 'MITOMAP',
            ___HPO: 'HPO',
            ___Pathway: 'Pathway'
          }
        }
      }
    },
    caseDetailSVFilter: {
      ___title: 'SV フィルター',
      gene: {
        ___title: '遺伝子記号',
        ___placeholder: 'ROR1、TP53、または BRCA1...',
        selected: {
          ___title: '選択済み（最大10遺伝子）'
        }
      },
      condition: {
        ___title: '疾患',
        ___placeholder: '疾患名（例：乳がん）',
        selected: {
          ___title: '選択済み（最大10疾患名）'
        }
      },
      variantDatabase: {
        ___title: 'バリアントデータベース',
        ClinVar: {
          ___title: 'ClinVar'
        },
        DECIPHER: {
          ___title: 'DECIPHER'
        }
      },
      afFilter: {
        ___title: 'AF フィルター',
        ___placeholder: '0~0.2, eg:0.01'
      },
      DosageSensitivity: {
        ___title: '遺伝子量感受性'
      },
      caller: {
        ___title: 'SVコーラー',
        genotype: {
          ___title: '遺伝子型'
        },
        svType: {
          ___title: 'SVタイプ'
        },
        genotypeQuality: {
          ___title: 'GQ',
          ___info: '推奨：Genotype Quality (GQ) ≥ 30。'
        },
        numberOfCallers: {
          ___title: 'コーラー数'
        }
      }
    },
    datasetArchiveConfirm: {
      info01: '下記コミュニティ・データセットをあなたのデータプールからアーカイブし、このコミュニティ・データセットに関連するデータセットを利用できなくなります。',
      info02: '<b>{count}</b> 個のデータセットが利用できなくなります。',
      table: {
        title: {
          ___name: 'データセット名',
          ___owner: '所有者',
          ___description: 'データセットの説明'
        }
      }
    },
    datasetDeleteConfirm: {
      info01: 'このデータセットはコミュニティーや他のユーザーと共有されています。共有の取り消しとデータセットの削除を希望しますか？',
      info02: '<b>{count}</b> 個のデータセットが利用できなくなります。',
      table: {
        data: {
          ___user: 'PhenoVarDBコミュニティー'
        },
        title: {
          ___accectedUserID: '影響を受けるユーザーID (所属、メールアドレス)',
          ___permission: '権限'
        }
      }
    },
    datasetDetail: {
      form: {
        title: {
          ___name: 'データセット名',
          ___sampleSize: 'サンプルサイズ',
          ___user: 'ユーザー'
        }
      },
      table: {
        title: {
          ___caseID: '症例ID',
          ___sex: '性別',
          ___birthYear: '生年',
          ___createdAt: '作成日',
          ___updatedAt: '更新日'
        }
      }
    },
    datasetEdit: {
      customForm: {
        shareAlert: {
          ___content: '<b>使用不可</b>'
        },
        sharing: {
          ___content: 'コミュニティー'
        },
        url: {
          ___copyIconTitle: 'コピー'
        },
        user: {
          ___content: '{count} ユーザー'
        }
      },
      form: {
        title: {
          ___shareAlert: '共有',
          ___sharing: '共有',
          ___url: 'データセットのURL',
          ___user: 'ユーザー',
          ___key: 'アクセスキー'
        }
      }
    },
    datasetInvitationConfirm: {
      info01: 'ユーザー {user} があなたに上記のデータセットへのアクセスを許可しました。招待を承認しますか？'
    },
    datasetSelectCase: {
      ___topTitle01: '総サンプル数は <b>{count}</b> です。',
      ___topTitle02: 'このボタンで全てをインポートすることができます。',
      ___searchPlaceholder: 'サンプルのキーワード',
      table: {
        title: {
          ___caseID: '症例ID',
          ___sex: '性別',
          ___birthYear: '生年',
          ___createdAt: '作成日',
          ___updatedAt: '更新日',
          ___phenotypeDatas: '表現型',
          ___genePanels: '遺伝子/疾患パネル'
        }
      }
    },
    datasetShareEdit: {
      form: {
        title: {
          ___user: 'ユーザー',
          ___permission: '権限',
          ___email: 'メールアドレス'
        }
      }
    },
    editChapter: {
      form: {
        title: {
          ___title: 'チャプター名',
          ___newTitle: '新チャプター名',
          ___description: 'チャプターの説明'
        },
        placeholder: {
          ___title: '新チャプター',
          ___description: 'チャプターの概要や説明を入力してください。'
        }
      }
    },
    editCNVToChapter: {
      ___editTitle: '新しいSVを編集する。',
      ___newTitle: '新しいSVを作成する。',
      ___geneTitle: '関連する遺伝子名を入力してください。',
      ___chapterTitle: '最低1チャプターを選択してください。',
      cnvForm: {
        placeholder: {
          ___chrom: 'Chr',
          ___posStart: 'スタート位置',
          ___posEnd: 'エンド位置'
        }
      },
      geneTag: {
        ___placeholder: '遺伝子名'
      },
      modal: {
        content: {
          ___deleteCNV: '<span style="color:#FA3D3D">バリアントを削除すると、中のすべてのコンテンツも削除されます。このバリアントを削除しますか？</span>'
        }
      }
    },
    editPanel: {
      form: {
        title: {
          ___panel: '新しいパネル名'
        },
        placeholder: {
          ___panel: '新しいパネル名を作成してください。'
        }
      }
    },
    editReportCNV: {
      ___typeTitle: 'SVの種類を変更する。',
      ___gtTitle: 'SVのGTを変更する。',
      ___intronTitle: 'SVのイントロン/エクソンを変更する。',
      ___lengthTitle: 'SVの長さを変更する。',
      cnvForm: {
        title: {
          ___type: '<b>SV</b> の種類を選択してください。',
          ___parentalOrigin: '<b>SV</b> の親由来を選択してください。'
        },
        placeholder: {
          ___gt: 'SVの遺伝子型(GT)',
          ___intron: 'SVのイントロン/エクソン',
          ___length: 'SVの長さ'
        }
      }
    },
    editReportSV: {
      ___typeTitle: 'SVの種類を変更する。',
      ___gtTitle: 'SVのGTを変更する。',
      ___intronTitle: 'SVのイントロン/エクソンを変更する。',
      ___lengthTitle: 'SVの長さを変更する。',
      svForm: {
        title: {
          ___type: '<b>SV</b> の種類を選択してください。',
          ___parentalOrigin: '<b>SV</b> の親由来を選択してください。'
        },
        placeholder: {
          ___gt: 'SVの遺伝子型(GT)',
          ___intron: 'SVのイントロン/エクソン',
          ___length: 'SVの長さ'
        }
      }
    },
    editReportVariant: {
      ___acmgTitle: 'バリアントのACMG分類を変更する。',
      ___siftPolyphen2Title: 'バリアントのSIFT&Polyphen2分類を変更する。',
      variantForm: {
        title: {
          ___acmg: '分類を選択してください。',
          ___sift: '<b>SIFT</b> の分類を選択してください。',
          ___polyphen2: '<b>Polyphen2</b> の分類を選択してください。',
          ___parentalOrigin: '親由来を選択してください。'
        }
      }
    },
    fileCloud: {
      ___title: 'Google バケットファイル一覧',
      ___subtitle: 'アップロードするファイルを1つだけ選択してください。'
    },
    editWorkgroupMember: {
      form: {
        title: {
          ___member: 'メンバー',
          ___newMember: '招待するユーザーのメールアドレス',
          ___role: '役割'
        },
        placeholder: {
          ___member: 'ex: InheriNext@compassbioinfo.com',
          ___role: '役割を選択してください。'
        }
      }
    },
    editWorkgroupCase: {
      ___title: '症例リスト',
      ___info: '{count}件の症例が選択されました。 | {count}件の症例が選択されました。 | {count}件の症例が選択されました。',
      ___searchPlaceholder: '症例IDのキーワードを入力して検索してください。',
      table: {
        title: {
          ___Case_ID: '症例ID',
          ___Sex: '性別',
          ___Age: '年齢',
          ___Created_date: '作成日',
          ___Modified_date: '更新日',
          ___Stage: '作業段階',
          ___Workgroup: 'ワークグループ'
        },
        alert: {
          ___added: 'この症例はワークグループに追加されました。'
        },
        pageDisplay: {
          ___item: '{count} 件 | {count} 件'
        }
      },
      modal: {
        content: {
          ___checkAutoShare: '<span>今後の症例をこのワークグループに自動的に共有しますか？</span>'
        }
      }
    },
    editWorkgroupStage: {
      form: {
        title: {
          ___stage: '作業段階',
          ___newStage: '新規作業段階',
          ___assignee: '担当者'
        },
        placeholder: {
          ___stage: '作業段階名は最大20文字で入力してください。',
          ___assignee: 'メンバーを選択してください。'
        }
      }
    },
    genePanelConfirm: {
      ___info01: '下記のリストは変更内容一覧です。更新前に再度ご確認ください。',
      block: {
        title: {
          ___add: '追加',
          ___remove: '削除'
        },
        content: {
          ___geneFreeTyping: '遺伝子-自由入力',
          ___geneUserDefined: '遺伝子-ユーザー定義',
          ___panel: 'パネル',
          ___hpoPhenotypes: 'HPO表現型',
          ___conditions: '疾患',
          ___pathways: '経路'
        }
      }
    },
    genePanelInfo: {
      ___info01: '<b>遺伝子パネルツール</b>へようこそ。',
      ___info02: 'これは無料で公開されている検索ツールです。',
      ___info03: '<span>まずはお客様の情報をご記入いただきますようお願いいたします。</span>',
      form: {
        title: {
          ___name: 'お名前',
          ___organization: '所属機関',
          ___email: 'メールアドレス'
        },
        errorTitle: {
          ___name: 'お名前',
          ___organization: '所属機関',
          ___email: 'メールアドレス'
        },
        placeholder: {
          ___name: '例：Eric Tsai、李大平...',
          ___organization: '例：Taiwan Biobank、コンパスバイオインフォマティクス株式会社...',
          ___email: 'メールアドレス、例：info@compassbioinfo.com'
        }
      }
    },
    genePanelQuickSelection: {
      ___title: 'ディビジョンのクイック選択',
      block: {
        subtitle: {
          ___panel01: 'デフォルト',
          ___panel02: '遺伝子数'
        },
        content: {
          ___division: 'パネル数'
        }
      }
    },
    projectEdit: {
      form: {
        title: {
          ___import: 'パラメータをインポート'
        },
        placeholder: {
          ___import: '解析を選択する。'
        }
      },
      modal: {
        content: {
          ___unknownSexAlert: '<span style="color:#FA3D3D">性別が不明な場合、後の解析結果に影響を与える可能性があります。それでも続けますか？</span>'
        }
      }
    },
    selectDataset: {
      ___description: 'ケースを作成する前にフォーマットを選択してください。<br>InheriNext は、VCF ケースの一括アップロードにも対応しています。',
      select: {
        title: {
          ___vcf: 'VCF',
          ___fastq: 'FASTQ',
          ___ubam: 'uBAM'
        },
        description: {
          ___vcf: '<b>{price}</b> ポイント/症例',
          ___fastq: '<b>{price}</b> ポイント/症例',
          ___ubam: '<b>{price}</b> ポイント/症例'
        },
        option: {
          ___batch: 'バッチアップロード'
        }
      }
    },
    userAvatar: {
      ___userTitle: 'アバターをデフォルトセットから選択するか、ドライブからアップロードしてください。',
      ___customTitle: 'カスタム・アバター'
    },
    userConfirm: {
      ___mainTitle: '成功！',
      ___title01: 'ご登録のメールアドレスに認証コードが送信されました。',
      ___title02: 'ログインするには認証コードを入力してください。',
      form: {
        title: {
          ___code: '認証'
        },
        placeholder: {
          ___code: '6桁の認証コード'
        }
      }
    },
    intractableDiseaseSelect: {
      ___title: 'D006-4 遺伝学的検査疾患名'
    },
    chatbot: {
      ___busyTitle: '現在すべてのインスタンスが混み合っています。10 分ほど時間をおいて再度お試しください。',
      ___inputPlaceholder: '歌舞伎症候群について教えてください。',
      ___deleteAlert: 'この会話は削除されます。<br>続行しますか？',
      agent: {
        ___title: 'AIエージェントの処理概要'
      },
      button: {
        default: {
          clinVar: {
            ___title: 'ClinVarにおけるバリアントの注釈情報。例えばchr3:37042330C>Tのバリアントの臨床的意義。',
            ___content: 'chr3:37042330C>Tのバリアントの臨床的意義は何ですか？'
          },
          caseReports: {
            ___title: 'バリアントに関する症例報告の出典リンク。例えばchr1:69589G>Aのバリアントの症例報告。',
            ___content: 'chr1:69589G>Aのバリアントの症例報告は？'
          },
          prevalence: {
            ___title: '疾患の有病率、病因、および疾患の遺伝性情報。例えば歌舞伎症候群の有病率。',
            ___content: '歌舞伎症候群の有病率は？'
          },
          disease: {
            ___title: '疾患に関する参考文献と出典リンク。例えばアルツハイマー病に関する参考文献。',
            ___content: 'アルツハイマー病に関する参考文献は？'
          }
        }
      }
    }
  },
  // constant
  CONSTANT: {
    data: {
      countryCode: {
        name: {
          ___AF: 'アフガニスタン',
          ___AX: 'アランド諸島',
          ___AL: 'アルバニア',
          ___DZ: 'アルジェリア',
          ___AS: 'アメリカ領サモア',
          ___AD: 'アンドラ',
          ___AO: 'アンゴラ',
          ___AI: 'アンギラ',
          ___AQ: '南極大陸',
          ___AG: 'アンティグア・バーブーダ',
          ___AR: 'アルゼンチン',
          ___AM: 'アルメニア',
          ___AW: 'アルバ',
          ___AU: 'オーストラリア',
          ___AT: 'オーストリア',
          ___AZ: 'アゼルバイジャン',
          ___BS: 'バハマ',
          ___BH: 'バーレーン',
          ___BD: 'バングラデシュ',
          ___BB: 'バルバドス',
          ___BY: 'ベラルーシ',
          ___BE: 'ベルギー',
          ___BZ: 'ベリーズ',
          ___BJ: 'ベナン',
          ___BM: 'バミューダ',
          ___BT: 'ブータン',
          ___BO: 'ボリビア',
          ___BQ: 'ボネール、セント・ユースタティウス、サバ',
          ___BA: 'ボスニア・ヘルツェゴビナ',
          ___BW: 'ボツワナ',
          ___BV: 'ブーベ島',
          ___BR: 'ブラジル',
          ___IO: 'イギリス領インド洋地域',
          ___VG: '英領バージン諸島',
          ___BN: 'ブルネイ',
          ___BG: 'ブルガリア',
          ___BF: 'ブルキナファソ',
          ___BI: 'ブルンジ',
          ___KH: 'カンボジア',
          ___CM: 'カメルーン',
          ___CA: 'カナダ',
          ___CV: 'カーボベルデ',
          ___KY: 'ケイマン諸島',
          ___CF: '中央アフリカ共和国',
          ___TD: 'チャド',
          ___CL: 'チリ',
          ___CN: '中国',
          ___CX: 'クリスマス島',
          ___CC: 'ココス諸島',
          ___CO: 'コロンビア',
          ___KM: 'コモロ',
          ___CK: 'クック諸島',
          ___CR: 'コスタリカ',
          ___HR: 'クロアチア',
          ___CU: 'キューバ',
          ___CW: 'キュラソー',
          ___CY: 'キプロス',
          ___CZ: 'チェコ共和国',
          ___CD: 'コンゴ民主共和国',
          ___DK: 'デンマーク',
          ___DJ: 'ジブチ',
          ___DM: 'ドミニカ国',
          ___DO: 'ドミニカ共和国',
          ___TL: '東ティモール',
          ___EC: 'エクアドル',
          ___EG: 'エジプト',
          ___SV: 'エルサルバドル',
          ___GQ: '赤道ギニア',
          ___ER: 'エリトリア',
          ___EE: 'エストニア',
          ___ET: 'エチオピア',
          ___FK: 'フォークランド諸島',
          ___FO: 'フェロー諸島',
          ___FJ: 'フィジー',
          ___FI: 'フィンランド',
          ___FR: 'フランス',
          ___GF: 'フランス領ギアナ',
          ___PF: 'フランス領ポリネシア',
          ___TF: 'フランス領南方領土',
          ___GA: 'ガボン',
          ___GM: 'ガンビア',
          ___GE: 'グルジア',
          ___DE: 'ドイツ',
          ___GH: 'ガーナ',
          ___GI: 'ジブラルタル',
          ___GR: 'ギリシャ',
          ___GL: 'グリーンランド',
          ___GD: 'グレナダ',
          ___GP: 'グアドループ',
          ___GU: 'グアム',
          ___GT: 'グアテマラ',
          ___GG: 'ガーンジー',
          ___GN: 'ギニア',
          ___GW: 'ギニアビサウ',
          ___GY: 'ガイアナ',
          ___HT: 'ハイチ',
          ___HM: 'ハード島とマクドナルド諸島',
          ___HN: 'ホンジュラス',
          ___HK: '香港',
          ___HU: 'ハンガリー',
          ___IS: 'アイスランド',
          ___IN: 'インド',
          ___ID: 'インドネシア',
          ___IR: 'イラン',
          ___IQ: 'イラク',
          ___IE: 'アイルランド',
          ___IM: 'マン島',
          ___IL: 'イスラエル',
          ___IT: 'イタリア',
          ___CI: 'コートジボワール',
          ___JM: 'ジャマイカ',
          ___JP: '日本',
          ___JE: 'ジャージー',
          ___JO: 'ヨルダン',
          ___KZ: 'カザフスタン',
          ___KE: 'ケニア',
          ___KI: 'キリバス',
          ___XK: 'コソボ',
          ___KW: 'クウェート',
          ___KG: 'キルギス',
          ___LA: 'ラオス',
          ___LV: 'ラトビア',
          ___LB: 'レバノン',
          ___LS: 'レソト',
          ___LR: 'リベリア',
          ___LY: 'リビア',
          ___LI: 'リヒテンシュタイン',
          ___LT: 'リトアニア',
          ___LU: 'ルクセンブルク',
          ___MO: 'マカオ',
          ___MK: 'マケドニア',
          ___MG: 'マダガスカル',
          ___MW: 'マラウイ',
          ___MY: 'マレーシア',
          ___MV: 'モルディブ',
          ___ML: 'マリ',
          ___MT: 'マルタ',
          ___MH: 'マーシャル諸島',
          ___MQ: 'マルティニーク',
          ___MR: 'モーリタニア',
          ___MU: 'モーリシャス',
          ___YT: 'マヨット',
          ___MX: 'メキシコ',
          ___FM: 'ミクロネシア',
          ___MD: 'モルドバ',
          ___MC: 'モナコ',
          ___MN: 'モンゴル',
          ___ME: 'モンテネグロ',
          ___MS: 'モンセラート',
          ___MA: 'モロッコ',
          ___MZ: 'モザンビーク',
          ___MM: 'ミャンマー',
          ___NA: 'ナミビア',
          ___NR: 'ナウル',
          ___NP: 'ネパール',
          ___NL: 'オランダ',
          ___NC: 'ニューカレドニア',
          ___NZ: 'ニュージーランド',
          ___NI: 'ニカラグア',
          ___NE: 'ニジェール',
          ___NG: 'ナイジェリア',
          ___NU: 'ニウエ',
          ___NF: 'ノーフォーク島',
          ___KP: '北朝鮮',
          ___MP: '北マリアナ諸島',
          ___NO: 'ノルウェー',
          ___OM: 'オマーン',
          ___PK: 'パキスタン',
          ___PW: 'パラオ',
          ___PS: 'パレスチナ自治区',
          ___PA: 'パナマ',
          ___PG: 'パプアニューギニア',
          ___PY: 'パラグアイ',
          ___PE: 'ペルー',
          ___PH: 'フィリピン',
          ___PN: 'ピトケアン',
          ___PL: 'ポーランド',
          ___PT: 'ポルトガル',
          ___PR: 'プエルトリコ',
          ___QA: 'カタール',
          ___CG: 'コンゴ共和国',
          ___RE: 'レユニオン',
          ___RO: 'ルーマニア',
          ___RU: 'ロシア',
          ___RW: 'ルワンダ',
          ___BL: 'サン・バルテルミー島',
          ___SH: 'セントヘレナ',
          ___KN: 'セントクリストファー・ネイビス',
          ___LC: 'セントルシア',
          ___MF: 'セント・マーチン島',
          ___PM: 'サンピエール島・ミクロン島',
          ___VC: 'サウスジョージア・サウスサンドウィッチ諸島',
          ___WS: 'サモア',
          ___SM: 'サンマリノ',
          ___ST: 'サントメ・プリンシペ',
          ___SA: 'サウジアラビア',
          ___SN: 'セネガル',
          ___RS: 'セルビア',
          ___SC: 'セーシェル',
          ___SL: 'シエラレオネ',
          ___SG: 'シンガポール',
          ___SX: 'シント・マールテン',
          ___SK: 'スロバキア',
          ___SI: 'スロベニア',
          ___SB: 'ソロモン諸島',
          ___SO: 'ソマリア',
          ___ZA: '南アフリカ共和国',
          ___GS: 'サウスジョージア・サウスサンドウィッチ諸島',
          ___KR: '韓国',
          ___SS: '南スーダン',
          ___ES: 'スペイン',
          ___LK: 'スリランカ',
          ___SD: 'スーダン',
          ___SR: 'スリナム',
          ___SJ: 'スバールバル諸島とヤンマイエン島',
          ___SZ: 'スワジランド',
          ___SE: 'スウェーデン',
          ___CH: 'スイス',
          ___SY: 'シリア',
          ___TW: '台湾',
          ___TJ: 'タジキスタン',
          ___TZ: 'タンザニア',
          ___TH: 'タイ',
          ___TG: 'トーゴ',
          ___TK: 'トケラウ',
          ___TO: 'トンガ',
          ___TT: 'トリニダード・トバゴ',
          ___TN: 'チュニジア',
          ___TR: 'トルコ',
          ___TM: 'トルクメニスタン',
          ___TC: 'タークス・カイコス諸島',
          ___TV: 'ツバル',
          ___VI: '米領バージン諸島',
          ___UG: 'ウガンダ',
          ___UA: 'ウクライナ',
          ___AE: 'アラブ首長国連邦',
          ___GB: 'イギリス',
          ___US: '米国',
          ___UM: '合衆国領有小離島',
          ___UY: 'ウルグアイ',
          ___UZ: 'ウズベキスタン',
          ___VU: 'バヌアツ',
          ___VA: 'バチカン',
          ___VE: 'ベネズエラ',
          ___VN: 'ベトナム',
          ___WF: 'ウォリス・フテュナ',
          ___EH: '西サハラ',
          ___YE: 'イエメン',
          ___ZM: 'ザンビア',
          ___ZW: 'ジンバブエ'
        }
      }
    },
    global: {
      data: {
        caseDataTypeMetadatas: {
          tag: {
            title: {
              ___intractableDisease: 'D006-4',
              ___designatedIntractableDisease: '指定難病',
              ___pgp: '表現型',
              ___gene_filter: '遺伝子パネル',
              ___str: 'STR',
              ___nbs_pathovar: '病原性バリアント',
              ___nbs_nullvar: 'ヌルバリアント',
              ___nbs_carrier: 'キャリア',
              ___incidental: '二次的所見',
              ___monitor: 'モニター',
              ___filter: 'フィルター',
              ___clinvar: 'ClinVar',
              ___nbs: 'nbs',
              ___nbs_nonmendelian: '非メンデル遺伝'
            }
          }
        },
        predictionMetaDataDisplayTitles: {
          ___Damaging: 'Damaging',
          ___Tolerated: 'Tolerated',
          ___ProbablyDamaging: 'Probably Damaging',
          ___PossiblyDamaging: 'Possibly Damaging',
          ___Benign: 'Benign',
          ___High: 'High',
          ___Medium: 'Medium',
          ___Low: 'Low',
          ___Neutral: 'Neutral',
          ___Splicealtering: 'Splice-altering',
          ___Conserved: 'Conserved',
          ___Nonconserved: 'Non-conserved',
          ___Likelyorpossiblypathogenic: 'Likely or possibly pathogenic',
          ___Likelyorpossiblybenign: 'Likely or possibly benign',
          ___Ambiguous: 'Ambiguous',
          ___Likelybenign: 'Likely benign',
          ___LikelyPathogenic: 'Likely pathogenic'
        },
        getClinvarStatisticData: {
          ___title: 'コード領域への影響',
          ___Pathogenic: 'Pathogenic',
          ___Likely_pathogenic: 'Likely Pathogenic',
          ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity',
          ___Uncertain_significance: 'Uncertain Significance',
          ___Likely_benign: 'Likely benign',
          ___Benign: 'Benign',
          ___stop_gained: 'Stop Gained',
          ___splice_site: 'Splice Site',
          ___frameshift: 'Frameshift Variant',
          ___stop_lost: 'Stop Lost',
          ___start_lost: 'Start Lost',
          ___missense: 'Missense',
          ___inframe_indel: 'Inframe Indel',
          ___synonymous: 'Synonymous Variant',
          ___non_coding: 'Non Coding',
          ___total: '合計'
        },
        clinvarACMGMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___PathogenicLikelypathogenic: 'Pathogenic/Likely pathogenic',
            ___Likelypathogenic: 'Likely pathogenic',
            ___Conflictinginterpretationsofpathogenicity: 'Conflicting interpretations of pathogenicity',
            ___Conflictingclassificationsofpathogenicity: 'Conflicting classifications of pathogenicity',
            ___Uncertainsignificance: 'Uncertain significance',
            ___riskfactor: 'risk factor',
            ___Benign: 'Benign',
            ___BenignLikelybenign: 'Benign/Likely benign',
            ___Likelybenign: 'Likely benign',
            ___drugresponse: 'drug response',
            ___protective: 'protective',
            ___other: 'other',
            ___Affects: 'Affects',
            ___vus: 'VUS'
          },
          display: {
            ___Pathogenic: 'Pathogenic',
            ___PathogenicLikelypathogenic: 'Pathogenic/Likely pathogenic',
            ___Likelypathogenic: 'Likely pathogenic',
            ___Conflictinginterpretationsofpathogenicity: 'Conflicting interpretations of pathogenicity',
            ___Conflictingclassificationsofpathogenicity: 'Conflicting classifications of pathogenicity',
            ___Uncertainsignificance: 'Uncertain significance',
            ___riskfactor: 'risk factor',
            ___Benign: 'Benign',
            ___BenignLikelybenign: 'Benign/Likely benign',
            ___Likelybenign: 'Likely benign',
            ___drugresponse: 'drug response',
            ___protective: 'protective',
            ___other: 'other',
            ___Affects: 'Affects',
            ___vus: 'VUS'
          }
        },
        repeatClassificationMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Indeterminate: 'Indeterminate',
            ___Intermediate: 'Intermediate',
            ___Normal: 'Normal'
          }
        },
        acmgMap: {
          info: {
            ___BA1: '集団データベースにおけるアレル頻度が5％以上である。',
            ___BS1: 'アレル頻度が保因者頻度よりも高い。',
            ___BS2: '健康な成人において、劣性（ホモ接合体）、優性（ヘテロ接合体）、またはX連鎖性（半接合体）の障害が観察され、早期の完全浸透が予想されている。',
            ___BS4: '家系内の罹患者においてsegregationが取れない。',
            ___BS3: 'in vitroまたはin vivoの機能解析において、タンパク質の機能やスプライシングに障害を及ぼさないことが確認されている。',
            ___BP2: '既知の病的変異とcisの状態で見出された変異、またはADの病的変異とtransに見出された変異。',
            ___BP5: '他の遺伝子に原因となる変異が見出されている。',
            ___BP1: 'Truncating変異が疾患を引き起こす遺伝子から新規に見出されたミスセンス変異。',
            ___BP3: 'フレーム内欠失／挿入変異が機能未知の繰り返し領域に見出されている。',
            ___BP4: '遺伝子や遺伝子産物への影響（保全、進化、スプライシングの影響など）がないことを複数のコンピューター予測により支持されている。',
            ___BP7: '同義（サイレント）置換を起こす変異でスプライシングにも影響がないと予測され、保存性も低い塩基置換。',
            ___BP6: '他のデータベース等で病的でないことが報告されているが、検査施設における独自に評価する証拠がない。',
            ___PP1: '疾患の原因として確認されている遺伝子において、家系内の複数の罹患者とバリアントがCo-segregationした。',
            ___PP2: '良性ミスセンス変異率が低く、ミスセンス変異が疾患を引き起こすと考えられている遺伝子のミスセンスバリアント。',
            ___PP3: '遺伝子または遺伝子産物への有害な影響（保全、進化、スプライシングの影響など）を複数のコンピューター予測により支持されている。',
            ___PP4: '患者の表現型や家族歴から、一つの遺伝子が原因として想定されている。',
            ___PP5: '他のデータベース等で病的変異であることが報告されているが、検査施設における独自に評価する証拠がない。',
            ___PM2: '集団データベースでは、変異が大規模コントロールに認められない（あるいは頻度が非常に低い）。',
            ___PM3: '劣性遺伝性疾患では、病原性バリアントとtransで見出されている。',
            ___PM6: 'de novo変異だと思われるが、両親のいずれかの確認が取れていない。',
            ___PM1: '変異がhot spotや機能上重要なドメイン（例：酵素の活性部位）にあり、良性の変異がない。',
            ___PM4: 'タンパク質の長さが変わるようなフレーム内欠失／挿入変異およびストップ・ロス変異',
            ___PM5: '異なる種類のアミノ酸置換がすでに病的変異として報告されている。',
            ___PS4: '罹患者におけるアレル頻度が、コントロールと比較して有意的に高い。',
            ___PS2: '家族歴のない患者から見出されたde novo変異（両親ともに確認できている）。',
            ___PS1: '既知の病的変異と同じアミノ酸置換を生じる異なる種類の塩基置換。',
            ___PS3: 'in vitroまたはin vivoの機能解析で障害を及ぼす証拠がある。',
            ___PVS1: 'LOFが疾患の原因で知られている遺伝子のヌル変異（ナンセンス変異、フレームシフト変異、スプライス部位±1～2塩基の変異、開始コドン、シングルまたはマルチエクソン欠失）。'
          },
          explanations: {
            ___BA1: '// 説明',
            ___BS1: '// 説明',
            ___BS2: '// 説明',
            ___BS4: '// 説明',
            ___BS3: '// 説明',
            ___BP2: '// 説明',
            ___BP5: '// 説明',
            ___BP1: '// 説明',
            ___BP3: '// 説明',
            ___BP4: '// 説明',
            ___BP7: '// 説明',
            ___BP6: '// 説明',
            ___PP1: '// 説明',
            ___PP2: '// 説明',
            ___PP3: '// 説明',
            ___PP4: '// 説明',
            ___PP5: '// 説明',
            ___PM2: '// 説明',
            ___PM3: '// 説明',
            ___PM6: '// 説明',
            ___PM1: '// 説明',
            ___PM4: '// 説明',
            ___PM5: '// 説明',
            ___PS4: '// 説明',
            ___PS2: '// 説明',
            ___PS1: '// 説明',
            ___PS3: '// 説明',
            ___PVS1: '// 説明'
          }
        },
        datasetStatusMap: {
          title: {
            ___created: '作成済み',
            ___analyzing: '解析中...',
            ___completed: '完了',
            ___failed: '失敗',
            ___disabled: '無効'
          }
        },
        datasetPermissionTypeMap: {
          title: {
            ___private: 'プライベート',
            ___community: 'コミュニティー'
          }
        },
        datasetPermissionMap: {
          title: {
            ___private: 'プライベート',
            ___basic: 'ベーシック',
            ___explore: 'データ探索',
            ___full: 'フル・アクセス'
          }
        },
        datasetInvitationPermissionMap: {
          title: {
            ___explore: 'データ探索',
            ___full: 'フル・アクセス'
          }
        },
        datasetPipelineMap: {
          title: {
            ___WES: '全エクソーム解析（WES）',
            ___WGS: '全ゲノム解析（WGS）'
          }
        },
        datasetShareAlert: {
          ___external_data_included: 'コミュニティーのデータが含まれています。データセットを共有したい場合は、すべてのデータを含むデータセットを作成してください。',
          ___disabled: 'データセットが無効です。',
          ___analyzing: 'データ解析が実行中です。',
          ___failed: 'データ解析が失敗しました。'
        },
        windowConfirm: {
          ___default: '変更内容が保存されていませんが、このまま終了しますか？'
        },
        defaultEmptyDisplay: {
          ___empty: 'N/A',
          ___noKey: '?'
        },
        pageDisplay: {
          ___item: '{count} 項目',
          ___display: '各ページの項目',
          ___jump: 'へ行く',
          ___page: 'ページ'
        },
        projectState: {
          ___created: 'データなし',
          ___uploading: 'アップロード中',
          ___analyzing: '解析中',
          ___completed: '完了',
          ___failed: '解析失敗',
          ___noAffected: '疾患なし<br>（Unaffected）'
        },
        jobState: {
          ___running: 'パイプライン',
          ___default: '表現型'
        },
        familyRelationOptions: {
          title: {
            ___Father: '父',
            ___Mother: '母',
            ___Brother: '兄・弟',
            ___Sister: '姉・妹',
            ___PaternalGrandfather: '祖父（父方）',
            ___PaternalGrandmother: '祖母（父方）',
            ___MaternalGrandfather: '祖父（母方）',
            ___MaternalGrandmother: '祖母（母方）',
            ___PaternalUncle: '伯父・叔父（父方）',
            ___PaternalAunt: '伯母・叔母（父方）',
            ___MaternalUncle: '伯父・叔父（母方）',
            ___MaternalAunt: '伯母・叔母（母方）'
          }
        },
        svClinvarOptions: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Variant_of_Uncertain_Significance: 'Uncertain Significance',
            ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity'
          },
          subtitle: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Variant_of_Uncertain_Significance: 'Uncertain Significance',
            ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity'
          }
        },
        svDECIPHEROptions: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Uncertain_Significance: 'Uncertain Significance',
            ___Others: 'Others'
          },
          subtitle: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Uncertain_Significance: 'Uncertain Significance',
            ___Others: 'Others'
          }
        },
        svDosageSensitivityOptions: {
          title: {
            ___Sufficient_evidence_for_dosage_pathogenicity: '病的遺伝子量に十分な証拠あり',
            ___Some_evidence_for_dosage_pathogenicity: '病的遺伝子量に一定の証拠あり',
            ___Little_evidence_for_dosage_pathogenicity: '病的遺伝子量にわずかな証拠あり',
            ___No_evidence_for_dosage_pathogenicity: '病的遺伝子量に関する証拠なし',
            ___Evidence_suggests_the_gene_is_not_dosage_sensitive: '遺伝子が量依存的でないことを示す証拠あり',
            ___Gene_associated_with_autosomal_recessive_phenotype: '常染色体劣性表現型に関連する遺伝子'
          }
        },
        svGenotypeOptions: {
          title: {
            ___Homozygous_reference: 'リファレンスホモ',
            ___Heterozygous: 'ヘテロ',
            ___Homozygous_alternate: '変異ホモ'
          }
        },
        svTypeOptions: {
          title: {
            ___DEL: 'DEL',
            ___INS: 'INS',
            ___DUP: 'DUP',
            ___INV: 'INV',
            ___CTX: 'CTX',
            ___CNV: 'CNV',
            ___BND: 'BND'
          }
        },
        strClassificationMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Indeterminate: 'Indeterminate',
            ___Intermediate: 'Intermediate',
            ___Normal: 'Normal',
            ___RU_mismatch: 'RU mismatch',
            ___Catalog_mismatch: 'Catalog mismatch'
          }
        },
        intractableDiseaseDifficutyMap: {
          title: {
            ___easy: '処理が容易なもの',
            ___hard: '処理が複雑なもの',
            ___very_hard: '処理が極めて複雑なもの'
          }
        },
        intractableDiseaseMethodMap: {
          title: {
            ___A: 'ア',
            ___I: 'イ',
            ___U: 'ウ',
            ___E: 'エ',
            ___O: 'オ'
          },
          symbol: {
            ___A: '㋐',
            ___I: '㋑',
            ___U: '㋒',
            ___E: '㋓',
            ___O: '㋔'
          },
          info: {
            ___A: '<span>ＰＣＲ法、ＤＮＡシーケンス法、ＦＩＳＨ法またはサザンブロット法による場合に算定できるもの</span>',
            ___I: '<span>ＰＣＲ法による場合に算定できるもの</span>',
            ___U: '<span>ア、イ、エ及びオ以外のもの</span>',
            ___E: '<span>別に<a href=http://www.kentaikensa.jp/files/37089.pdf target=_blank>厚生労働大臣が定める施設基準に適合しているものとして地方厚生（支）局長に届け出</a>た保険医療機関において検査が行われる場合に算定できるもの</span>',
            ___O: '<span>臨床症状や他の検査等では診断がつかない場合に、別に<a href=http://www.kentaikensa.jp/files/37089.pdf target=_blank>厚生労働大臣が定める施設基準に適合しているものとして地方厚生（支）局長に届け出</a>た保険医療機関において検査が行われる場合に算定できるもの</span>'
          }
        },
        intractableDiseaseOptions: {
          title: {
            ___Duchenne_muscular_dystrophy: 'デュシェンヌ型筋ジストロフィー',
            ___Becker_muscular_dystrophy: 'ベッカー型筋ジストロフィー',
            ___Familial_amyloidosis: '家族性アミロイドーシス(全身性アミロイドーシス)',
            ___Spinal_and_bulbar_muscular_atrophy_SBMA: '球脊髄性筋萎縮症',
            ___Myotonic_dystrophy: '筋強直性ジストロフィー (筋緊張性ジストロフィー)',
            ___Lysosomal_storage_diseases_including_mucopolysaccharidosis_type_I_mucopolysaccharidosis_type_II_Gaucher_disease_Fabry_disease_and_Pompe_disease: 'ライソゾーム病（ムコ多糖症Ⅰ型、ムコ多糖症Ⅱ型、ゴーシェ病、ファブリー病及びポンペ病を含む）',
            ___Fragile_X_syndrome: '脆弱Ｘ症候群',
            ___TNF_receptor_associated_periodic_syndrome_TRAPS: 'TNF受容体関連周期性症候群',
            ___Nakajo_Nishimura_syndrome: '中條－西村症候群',
            ___Familial_Mediterranean_fever: '家族性地中海熱',
            ___Bethlem_myopathy: 'ベスレムミオパチー',
            ___X_linked_myopathy_with_excessive_autophagy: '過剰自己貪食を伴うＸ連鎖性ミオパチー',
            ___Non_dystrophic_myotonia_syndromes: '非ジストロフィー性ミオトニー症候群',
            ___Hereditary_periodic_limb_paralysis: '遺伝性周期性四肢麻痺',
            ___Autosomal_recessive_leukodystrophy_with_alopecia_and_spondylometaphyseal_dysplasia: '禿頭と変形性脊椎症を伴う常染色体劣性白質脳症',
            ___Tuberous_sclerosis: '結節性硬化症',
            ___Pachydermoperiostosis: '肥厚性皮膚骨膜症',
            // ___Neurofibromatosis_Type_I: '神経線維腫症I型',
            // ___Neurofibromatosis_Type_2: '神経線維腫症II型',
            ___Alexander_disease: 'アレキサンダー病',
            ___Chronic_non_specific_multiple_ulcers_of_the_small_intestine: '非特異性多発性小腸潰瘍症',
            ___TRPV4_related_disorder: 'ＴＲＰＶ４異常症',
            ___Fukuyama_congenital_muscular_dystrophy: '福山型先天性筋ジストロフィー',
            ___Spinal_muscular_atrophy: '脊髄性筋萎縮症',
            ___Huntingtons_disease: 'ハンチントン病',
            ___Retinoblastoma: '網膜芽細胞腫',
            ___Medullary_thyroid_carcinoma: '甲状腺髄様癌',
            ___Multiple_endocrine_neoplasia_type_1_MEN1: '多発性内分泌腫瘍症１型',
            ___Phenylketonuria_PKU: 'フェニルケトン尿症',
            ___Homocystinuria: 'ホモシスチン尿症',
            ___Citrullinemia_type_I: 'シトルリン血症（１型）',
            ___Argininosuccinic_aciduria_Urea_cycle_disorder: 'アルギノコハク酸血症（尿素サイクル異常症）',
            ___Isovaleric_acidemia: 'イソ吉草酸血症',
            ___HMG_CoA_lyase_deficiency: 'ＨＭＧ血症 (ＨＭＧ-CoAリアリーゼ血症)',
            ___Multiple_carboxylase_deficiency: '複合カルボキシラーゼ欠損症',
            ___Glutaric_acidemia_type_1: 'グルタル酸血症１型',
            ___MCAD_deficiency_Medium_chain_acyl_CoA_dehydrogenase_deficiency: '中鎖アシルCoA脱水素酵素欠損症（ＭＣＡＤ欠損症）',
            ___VLCAD_deficiency_Very_long_chain_acyl_CoA_dehydrogenase_deficiency: '極長鎖アシルCoA脱水素酵素欠損症（ＶＬＣＡＤ欠損症）',
            ___CPT1_deficiency_Carnitine_palmitoyltransferase_I_deficiency: 'ＣＰＴ１欠損症（カルニチン回路異常症）',
            // ___Menkes_Disease_Congenital_disorder_of_copper_metabolism: 'メンケス病（先天性銅代謝異常症）',
            // ___Occipital_Horn_Syndrome_Congenital_disorder_of_copper_metabolism: 'オクシピタル・ホーン症候群（先天性銅代謝異常症）',
            // ___Wilson_Disease_Congenital_disorder_of_copper_metabolism: 'ウィルソン病（先天性銅代謝異常症）',
            ___Cryopyrin_associated_periodic_syndromes_CAPS: 'クリオピリン関連周期熱症候群',
            ___Neurodegeneration_with_brain_iron_accumulation_NBIA: '脳内鉄沈着神経変性症',
            ___Congenital_cerebral_leukodystrophy_including_central_nervous_system_hypomyelination: '先天性大脳白質形成不全症（中枢神経白質形成異常症を含む。）',
            ___PCDH19_related_disorder: 'ＰＣＤＨ19関連症候群',
            ___Hypophosphatasia: '低ホスファターゼ症',
            ___Apert_syndrome: 'アペール症候群',
            ___Rothmund_Thomson_syndrome: 'ロスムンド・トムソン症候群',
            ___Prader_Willi_syndrome: 'プラダー・ウィリ症候群',
            ___Angelman_syndrome: 'アンジェルマン症候群',
            ___Smith_Magenis_syndrome: 'スミス・マギニス症候群',
            ___Fragile_X_associated_disorders: '脆弱Ｘ症候群関連疾患',
            ___Wolfram_syndrome: 'ウォルフラム症候群',
            ___Hyper_IgD_syndrome: '高ＩｇＤ症候群',
            ___PAPA_syndrome_Pyogenic_sterile_arthritis_pyoderma_gangrenosum_and_acne: '化膿性無菌性関節炎・壊疽性膿皮症・アクネ症候群',
            ___Congenital_anomaly_syndromes: '先天異常症候群',
            ___ACTH_resistance_syndrome: '副腎皮質刺激ホルモン不応症',
            ___Autosomal_recessive_punctate_epiphyseal_dysplasia_type_1_Peroxisomal_diseases_excluding_adrenoleukodystrophy: '根性点状軟骨異形成症１型 （ペルオキシソーム病（副腎白質ジストロフィーを除く））',
            ___Familial_partial_lipodystrophy: '家族性部分性脂肪萎縮症',
            ___Sotos_syndrome: 'ソトス症候群',
            ___Carnitine_deficiency_Carnitine_palmitoyltransferase_II_deficiency: 'CPT2欠損症（カルニチン回路異常症）',
            ___Carnitine_deficiency_Carnitine_acylcarnitine_translocase_deficiency: 'CACT欠損症（カルニチン回路異常症）',
            ___Carnitine_deficiency_OCTN2_deficiency_Primary_carnitine_deficiency: 'OCTN-2異常症（カルニチン回路異常症）',
            ___Citrin_deficiency: 'シトリン欠損症',
            ___Non_ketotic_hyperglycinemia: '非ケトーシス型高グリシン血症',
            ___Beta_ketothiolase_deficiency: 'β-ケトチオラーゼ欠損症',
            ___3_Methylglutaconic_aciduria: 'メチルグルタコン酸血症 (メチルグルタコン酸尿症)',
            ___Glutaric_acidemia_type_2: 'グルタル酸血症２型',
            ___Congenital_adrenal_hypoplasia: '先天性副腎低形成症',
            ___ATR_X_syndrome_Alpha_thalassemia_X_linked_intellectual_disability_syndrome: 'ATR-X症候群',
            ___Hutchinson_Gilford_progeria_syndrome: 'ハッチンソン・ギルフォード症候群',
            ___Achondroplasia: '軟骨無形成症',
            ___Progressive_Myoclonic_Epilepsy_Lafora_disease: '進行性ミオクローヌスてんかん（ラフォラ病）',
            ___Sepiapterin_reductase_SR_deficiency: 'セピアプテリン還元酵素（SR）欠損症',
            ___Aromatic_L_amino_acid_decarboxylase_deficiency: '芳香族L-アミノ酸脱炭酸酵素欠損症',
            ___Osler_disease_Hereditary_hemorrhagic_telangiectasia: 'オスラー病（遺伝性出血性末梢血管拡張症）',
            ___CFC_syndrome_Cardiofaciocutaneous_syndrome: 'ＣＦＣ症候群',
            ___Costello_syndrome: 'コステロ症候群',
            ___CHARGE_syndrome: 'チャージ症候群',
            ___Lysinuric_protein_intolerance: 'リジン尿性蛋白不耐症',
            ___Adrenoleukodystrophy: '副腎白質ジストロフィー',
            ___Blau_syndrome: 'ブラウ症候群',
            ___Branchio_oto_renal_syndrome: '鰓耳腎症候群',
            ___Young_Simpson_syndrome: 'ヤング・シンプソン症候群',
            ___Congenital_nephrogenic_diabetes_insipidus: '先天性腎性尿崩症',
            ___Vitamin_D_dependent_rickets_osteomalacia: 'ビタミンD依存性くる病/骨軟化症',
            ___Nail_patella_syndrome_LMX1B_associated_nephropathy: 'ネイルパテラ症候群（爪膝蓋症候群）/LMX1B 関連腎症',
            ___GLUT1_deficiency_syndrome: 'グルコーストランスポーター1欠損症',
            ___Resistance_to_thyroid_hormone: '甲状腺ホルモン不応症',
            ___Weaver_syndrome: 'ウィーバー症候群',
            ___Coffin_Lowry_syndrome: 'コフィン・ローリー症候群',
            ___Mowat_Wilson_syndrome: 'モワット・ウィルソン症候群',
            ___Hepatic_glycogen_storage_diseases_types_I_III_VI_IXa_IXb_IXc_IV: '肝型糖原病（糖原病Ⅰ型、Ⅲ型、Ⅵ型、Ⅸa型、Ⅸb型、Ⅸc型、Ⅳ型）',
            ___Myopathic_glycogen_storage_diseases_types_III_IV_IXd: '筋型糖原病（糖原病Ⅲ型、Ⅳ型、Ⅸd型）',
            ___Congenital_protein_C_deficiency: '先天性プロテインC欠乏症（特発性血栓症（遺伝性血栓性素因によるものに限る））',
            ___Congenital_protein_S_deficiency: '先天性プロテインS欠乏症（特発性血栓症（遺伝性血栓性素因によるものに限る））',
            ___Congenital_antithrombin_deficiency: '先天性アンチトロンビン欠乏症',
            ___Amyotrophic_lateral_sclerosis_ALS: '筋萎縮性側索硬化症',
            ___Distal_myopathy_with_rimmed_vacuoles: '縁取り空砲を伴う遠位型ミオパチー',
            ___Schwartz_Jampel_syndrome: 'シュワルツ・ヤンペル症候群',
            ___Hypertrophic_cardiomyopathy: '肥大型心筋症',
            ___Familial_hypercholesterolemia_holmozygous: '家族性高コレステロール血症（ホモ接合体）',
            ___Congenital_myopathy: '先天性ミオパチー',
            ___CADASIL_Cerebral_autosomal_dominant_arteriopathy_with_subcortical_infarcts_and_leukoencephalopathy: '皮質下梗塞と白質脳症を伴う常染色体優性脳動脈症',
            ___Hereditary_diffuse_leukoencephalopathy_with_axonal_spheroids: '神経軸索スフェロイド形成を伴う遺伝性びまん性白質脳症',
            ___Congenital_insensitivity_to_pain_with_anhidrosis: '先天性無痛無汗症',
            ___Familial_benign_chronic_pemphigus_Hailey_Hailey_disease: '家族性良性慢性天疱瘡',
            ___Nasu_Hakola_disease: '那須・ハコラ病',
            ___Carney_complex: 'カーニー複合',
            ___Peroxisome_biogenesis_disorder: 'ペルオキシソーム形成異常症',
            ___Peroxisomal_beta_oxidation_enzyme_deficiency: 'ペルオキシソームβ酸化系酵素欠損症',
            ___Plasmalogen_synthesis_enzyme_deficiency: 'プラスマローゲン合成酵素欠損症',
            ___Acatalasemia: 'アカタラセミア',
            ___Primary_hyperoxaluria_type_I: '原発性高シュウ酸尿症Ⅰ型',
            ___Refsum_disease: 'レフサム病',
            ___Hereditary_folate_malabsorption: '先天性葉酸吸収不全症',
            ___Atypical_porphyria: '異型ポルフィリン症',
            ___Congenital_erythropoietic_porphyria: '先天性骨髄性ポルフィリン症',
            ___Acute_intermittent_porphyria: '急性間欠性ポルフィリン症',
            ___Erythropoietic_protoporphyria: '赤芽球性プロトポルフィリン症',
            ___X_linked_protoporphyria: 'Ｘ連鎖優性プロトポルフィリン症',
            ___Hereditary_coproporphyria: '遺伝性コプロポルフィリン症',
            ___Porphyria_cutanea_tarda: '晩発性皮膚ポルフィリン症',
            ___Hepatoerythropoietic_porphyria: '肝性骨髄性ポルフィリン症',
            ___Primary_hyperchylomicronemia: '原発性高カイロミクロン血症',
            ___Abetalipoproteinemia: '無βリポタンパク血症',
            ___Thanatophoric_dysplasia: 'タナトフォリック骨異形成症',
            ___Hereditary_pancreatitis: '遺伝性膵炎',
            ___Cystic_fibrosis: '嚢胞性線維症',
            ___Usher_syndrome_type_1_type_2_type_3: 'アッシャー症候群（タイプ１、タイプ２、タイプ３）',
            ___Canavan_disease: 'カナバン病',
            ___Congenital_glycosylphosphatidylinositol_deficiency: '先天性グリコシルホスファチジルイノシトール欠損症',
            ___Osteopetrosis: '大理石骨病',
            ___Cerebral_creatine_deficiency_syndrome: '脳クレアチン欠乏症候群',
            ___Nephronophthisis: 'ネフロン癆',
            ___Familial_hypobetalipoproteinemia_type_1_homozygous_form: '家族性低βリポタンパク血症１（ホモ接合体）',
            ___Progressive_familial_intrahepatic_cholestasis: '進行性家族性肝内胆汁うっ滞症',
            ___Nutritional_epidermolysis_bullosa: '栄養障害型表皮水疱症',
            ___Congenital_long_QT_syndrome: '先天性ＱＴ延長症候群',
            ___Maple_syrup_urine_disease: 'メープルシロップ尿症',
            ___Methylmalonic_acidemia: 'メチルマロン酸血症',
            ___Propionic_acidemia: 'プロピオン酸血症',
            ___3_Methylcrotonylglycinuria: 'メチルクロトニルグリシン尿症',
            ___MTP_LCHAD_deficiency_Triple_Enzyme_Deficiency: 'ＭＴＰ（ＬＣＨＡＤ）欠損症（三頭酵素欠損症）',
            ___Xeroderma_pigmentosum: '色素性乾皮症',
            ___Loeys_Dietz_syndrome: 'ロイスディーツ症候群',
            ___Familial_thoracic_aortic_aneurysm_and_dissection: '家族性大動脈瘤・解離',
            ___Neuroacanthocytosis: '神経有棘赤血球症',
            ___Congenital_myasthenic_syndrome: '先天性筋無力症候群',
            ___Primary_immunodeficiency_syndrome: '原発性免疫不全症候群',
            ___Perry_syndrome: 'ペリー症候群',
            ___Crouzon_syndrome: 'クルーゾン症候群',
            ___Pfeiffer_syndrome: 'ファイファー症候群',
            ___Antley_Bixler_syndrome: 'アントレー・ビクスラー症候群',
            ___Tangier_disease: 'タンジール病',
            ___Congenital_dyserythropoietic_anemia: '先天性赤血球形成異常性貧血',
            ___Early_onset_bilateral_sensorineural_hearing_loss: '若年発症型両側性感音難聴',
            ___Urea_cycle_disorder: '尿素サイクル異常症',
            ___Marfan_syndrome_Loeys_Dietz_Syndrome: 'マルファン症候群/ロイス・ディーツ症候群',
            ___Vascular_Ehlers_Danlos_syndrome: '血管型エーラスダンロス症候群',
            ___Hereditary_autoinflammatory_disease: '遺伝性自己炎症疾患',
            ___Hereditary_dystonia: '遺伝性ジストニア',
            ___Dravet_syndrome: 'ドラベ症候群',
            ___Coffin_Siris_syndrome: 'コフィン・シリス症候群',
            ___Kabuki_syndrome: '歌舞伎症候群',
            ___Pulmonary_alveolar_proteinosis_autoimmune_or_congenital: '肺胞蛋白症（自己免疫性又は先天性）',
            ___Noonan_syndrome: 'ヌーナン症候群',
            ___Osteogenesis_imperfecta: '骨形成不全症',
            ___Spinocerebellar_degeneration_excluding_multiple_system_atrophy: '脊髄小脳変性症（多系統萎縮症を除く）',
            ___Classical_Ehlers_Danlos_syndrome: '古典型エーラス・ダンロス症候群',
            ___Atypical_hemolytic_uremic_syndrome_aHUS: '非典型溶血性尿毒症症候群',
            ___Alport_syndrome: 'アルポート症候群',
            ___Fanconi_anemia: 'ファンコニ貧血',
            ___Alagille_syndrome: 'アラジール症候群',
            ___Rubinstein_Taybi_syndrome: 'ルビンシュタイン・テイビ症候群',
            ___Primary_ciliary_dyskinesia_including_Kartagener_syndrome: '線毛機能不全症候群（カルタゲナー症候群を含む）',
            ___Proteinuria_group: 'タンパク尿群',
            ___Cardiomyopathy_group: '心筋症群',
            ___Growth_disorder_intellectual_disability_and_characteristic_facial_features_group: '成長障害・知的障害・特徴的な顔貌群',
            ___Intellectual_disability_and_epilepsy_group: '知的障害・てんかん群',
            ___Fever_inflammation_rash_and_osteoarticular_syndrome_group: '発熱・炎症・皮疹・骨関節症候群',
            ___Muscle_weakness_group: '筋力低下群',
            ___Rett_syndrome: 'レット症候群',
            ___Lowe_syndrome_oculocerebrorenal_syndrome: 'ロウ症候群',
            ___Miyoshi_myopathy: '三好型ミオパチー',
            ___Lecithin_cholesterol_acyltransferase_LCAT_deficiency: 'レシチンコレステロールアシルトランスフェラーゼ欠損症',
            ___Sitosterolemia: 'シトステロール血症',
            ___Pseudohypoparathyroidism: '偽性副甲状腺機能低下症',
            ___Marinesco_Sjögren_syndrome: 'マリネスコ・シェーグレン症候群',
            ___Galactose_1_phosphate_uridyltransferase_deficiency: 'ガラクトース−1−リン酸ウリジルトランスフェラーゼ欠損症',
            ___Fibrodysplasia_ossificans_progressiva_FOP: '進行性骨化性線維異形成症',
            ___Aniridia: '無虹彩症',
            ___PURA_related_neurodevelopmental_disorders: 'PURA関連神経発達異常症',
            ___Leber_hereditary_optic_neuropathy_LHON: 'レーベル遺伝性視神経症',
            ___Alveolar_hypoventilation_syndrome: '肺胞低換気症候群',
            ___Cerebrotendinous_xanthomatosis_CTX: '脳腱黄色腫症',
            ___Joubert_syndrome_and_related_disorders_JSRD: 'ジュベール症候群関連疾患',
            ___Werner_syndrome: 'ウェルナー症候群',
            ___Cockayne_syndrome: 'コケイン症候群',
            ___Pseudoxanthoma_elasticum_PXE: '弾性線維性仮性黄色腫',
            ___Diamond_Blackfan_anemia: 'ダイアモンド・ブラックファン貧血',
            ___LMNB1_related_leukoencephalopathy_ADLD: 'LMNB1関連大脳白質脳症',
            ___Congenital_ichthyosis: '先天性魚鱗癬',
            ___Oculocutaneous_albinism: '眼皮膚白皮症',
            ___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy: '乳児発症STING関連血管炎',
            ___Progressive_leukoencephalopathy: '進行性白質脳症',
            ___Charcot_Marie_Tooth_disease_CMT: 'シャルコー・マリー・トゥース病',
            ___Congenital_adrenal_hyperplasia_congenital_adrenal_enzyme_deficiency: '先天性副腎皮質酵素欠損症',
            ___Hemorrhagic_disorders_due_to_abnormal_fibrinolysis: '出血性線溶異常症',
            ___Mitochondrial_diseases: 'ミトコンドリア病',
            ___Epstein_syndrome: 'エプスタイン症候群',
            ___neurofibromatosis: '神経線維腫症',
            ___congenital_hearing_loss: '先天性難聴',
            ___prion_disease: 'プリオン病',
            ___familial_idiopathic_basal_ganglia_calcification: '家族性特発性基底核石灰化症',
            ___williams_syndrome: 'ウィリアムズ症候群',
            ___1p36_deletion_syndrome: '1p36欠失症候群',
            ___4p_deletion_syndrome: '4p欠失症候群',
            ___5p_deletion_syndrome: '5p欠失症候群',
            ___paternal_uniparental_disomy_of_chromosome_14: '第14番染色体父親性ダイソミー症候群',
            ___22q11_2_deletion_syndrome: '22q11.2欠失症候群',
            ___unverricht_lundborg_disease: 'ウンフェルリヒト・ルンドボルグ病',
            ___congenital_disorder_of_copper_metabolism: '先天性銅代謝異常症',
            ___hereditary_sideroblastic_anemia: '遺伝性鉄芽球性貧血',
            ___ring_chromosome_20_syndrome: '環状20番染色体症候群',
            ___emanuel_syndrome: 'エマヌエル症候群',
            ___dermatofibrosarcoma_protuberans: '隆起性皮膚線維肉腫',
            ___Primary_lateral_sclerosis: '原発性側索硬化症',
            ___Progressive_supranuclear_palsy: '進行性核上性麻痺',
            ___Parkinsons_disease: 'パーキンソン病',
            ___Corticobasal_degeneration: '大脳皮質基底核変性症',
            ___Charcot_Marie_Tooth_disease: 'シャルコー・マリー・トゥース病',
            ___Myasthenia_gravis: '重症筋無力症',
            ___Multiple_sclerosis_Neuromyelitis_optica_spectrum_disorders: '多発性硬化症/視神経脊髄炎',
            ___Chronic_inflammatory_demyelinating_polyneuropathy_Multifocal_motor_neuropathy: '慢性炎症性脱髄性多発神経炎/多巣性運動ニューロパチー',
            ___Sporadic_inclusion_body_myositis: '封入体筋炎',
            ___Multiple_system_atrophy: '多系統萎縮症',
            ___Moyamoya_disease: 'もやもや病',
            ___Pemphigus: '天疱瘡',
            ___Pustular_psoriasis: '膿疱性乾癬(汎発型)',
            ___Stevens_Johnson_syndrome: 'スティーヴンス・ジョンソン症候群',
            ___Toxic_epidermal_necrolysis: '中毒性表皮壊死症',
            ___Takayasu_arteritis: '高安動脈炎',
            ___Giant_cell_arteritis: '巨細胞性動脈炎',
            ___Polyarteritis_nodosa: '結節性多発動脈炎',
            ___Granulomatosis_with_polyangiitis: '多発血管炎性肉芽腫症',
            ___Systemic_lupus_erythematosus: '全身性エリテマトーデス',
            ___Systemic_sclerosis: '全身性強皮症',
            ___Behcets_disease: 'ベーチェット病',
            ___Idiopathic_dilated_cardiomyopathy: '特発性拡張型心筋症',
            ___Restrictive_cardiomyopathy: '拘束型心筋症',
            ___Aplastic_anemia: '再生不良性貧血',
            ___Paroxysmal_nocturnal_hemoglobinuria: '発作性夜間ヘモグロビン尿症',
            ___Immune_thrombocytopenia: '免疫性血小板減少症',
            ___Thrombotic_thrombocytopenic_purpura: '血栓性血小板減少性紫斑病',
            ___IgA_nephropathy: 'IgA腎症',
            ___Polycystic_kidney_disease: '多発性嚢胞腎',
            ___Ossification_of_posterior_longitudinal_ligament: '後縦靱帯骨化症',
            ___Idiopathic_osteonecrosis_of_femoral_head: '特発性大腿骨頭壊死症',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_ADH_syndrome: '下垂体性ADH分泌異常症',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_thyroid_stimulating_hormone_syndrome: '下垂体性TSH分泌亢進症',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_prolactin_syndrome: '下垂体性PRL分泌亢進症',
            ___Cushing_disease: 'クッシング病',
            ___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_gonadotropin: '下垂体性ゴナドトロピン分泌亢進症',
            ___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_growth_hormone: '下垂体性成長ホルモン分泌亢進症',
            ___Hypopituitarism_syndrome: '下垂体前葉機能低下症',
            ___Congenital_adrenal_enzyme_deficiency: '先天性副腎皮質酵素欠損症',
            ___Addisons_disease: 'アジソン病',
            ___Sarcoidosis: 'サルコイドーシス',
            ___Pulmonary_arterial_hypertension: '肺動脈性肺高血圧症',
            ___Pulmonary_veno_occlusive_disease_pulmonary_capillary_hemangiomatosis: '肺静脈閉塞症/肺毛細血管腫症',
            ___Chronic_thromboembolic_pulmonary_hypertension: '慢性血栓塞栓性肺高血圧症',
            ___Lymphangioleiomyomatosis: 'リンパ脈管筋腫症',
            ___Retinitis_pigmentosa: '網膜色素変性症',
            ___Budd_Chiari_syndrome: 'バッド・キアリ症候群',
            ___Primary_biliary_cholangitis: '原発性胆汁性胆管炎',
            ___Primary_sclerosing_cholangitis: '原発性硬化性胆管炎',
            ___Crohns_disease: 'クローン病',
            ___Ulcerative_colitis: '潰瘍性大腸炎',
            ___Chronic_idiopathic_intestinal_pseudo_obstruction: '慢性特発性偽性腸閉塞症',
            ___Megacystis_microcolon_intestinal_hypoperistalsis_syndrome: '巨大膀胱短小結腸腸管蠕動不全症',
            ___Juvenile_idiopathic_arthritis: '若年性特発性関節炎',
            ___Marinesco_Sjogren_syndrome: 'マリネスコ・シェーグレン症候群',
            ___Myelomeningocele: '脊髄髄膜瘤',
            ___Frontotemporal_lobar_degeneration: '前頭側頭葉変性症',
            ___Acute_encephalopathy_with_biphasic_seizures_and_late_reduced_diffusion: '痙攣重積型(二相性)急性脳症',
            ___Moebius_syndrome: 'メビウス症候群',
            ___Septo_optic_dysplasia_De_Morsier_syndrome: '中隔視神経形成異常症/ドモルシア症候群',
            ___Aicardi_syndrome: 'アイカルディ症候群',
            ___Hemimegalencephaly: '片側巨脳症',
            ___Focal_cortical_dysplasia: '限局性皮質異形成',
            ___Neuronal_migration_defects: '神経細胞移動異常症',
            ___Epilepsy_with_myoclonic_atonic_seizures: 'ミオクロニー脱力発作を伴うてんかん',
            ___Lennox_Gastaut_syndrome: 'レノックス・ガストー症候群',
            ___West_syndrome: 'ウエスト症候群',
            ___Ohtahara_syndrome: '大田原症候群',
            ___Early_myoclonic_encephalopathy: '早期ミオクロニー脳症',
            ___Epilepsy_of_infancy_with_migrating_focal_seizures: '遊走性焦点発作を伴う乳児てんかん',
            ___Hemiconvulsion_hemiplegia_epilepsy_syndrome: '片側痙攣・片麻痺・てんかん症候群',
            ___Rasmussens_encephalitis: 'ラスムッセン脳炎',
            ___Developmental_and_or_epileptic_encephalopathy_with_spike_wave_activation_in_sleep: '睡眠時棘徐波活性化を示す発達性てんかん性脳症およびてんかん性脳症',
            ___Landau_Kleffner_syndrome: 'ランドウ・クレフナー症候群',
            // ___Rett_syndrome: 'レット症候群',
            ___Sturge_Weber_syndrome: 'スタージ・ウェーバー症候群',
            // ___Congenital_ichthyosis: '先天性魚鱗癬',
            ___Pemphigoid_including_Epidermolysis_bullosa_acquisita: '類天疱瘡(後天性表皮水疱症を含む。)',
            // ___Oculocutaneous_albinism: '眼皮膚白皮症',
            ___Pseudoxanthoma_elasticum: '弾性線維性仮性黄色腫',
            ___VATER_syndrome: 'VATER症候群',
            ___Joubert_syndrome_and_related_disorders: 'ジュベール症候群関連疾患',
            ___Polysplenia_syndrome: '多脾症候群',
            ___Asplenia_syndrome: '無脾症候群',
            // ___Werner_syndrome: 'ウェルナー症候群',
            // ___Cockayne_syndrome: 'コケイン症候群',
            ___Truncus_arteriosus_communis: '総動脈幹遺残症',
            ___Corrected_transposition_of_great_arteries: '修正大血管転位症',
            ___Complete_transposition_of_the_great_arteries: '完全大血管転位症',
            ___Hypoplastic_left_heart_syndrome: '左心低形成症候群',
            ___Tetralogy_of_Fallot: 'ファロー四徴症',
            ___Double_outlet_right_ventricle: '両大血管右室起始症',
            ___Ebsteins_anomaly: 'エプスタイン病',
            ___Galloway_Mowat_syndrome: 'ギャロウェイ・モワト症候群',
            ___Primary_nephrotic_syndrome: '一次性ネフローゼ症候群',
            ___Primary_membranoproliferative_glomerulonephritis: '一次性膜性増殖性糸球体腎炎',
            // ___Alveolar_hypoventilation_syndrome: '肺胞低換気症候群',
            ___Alpha_1_antitrypsin_deficiency: 'α1-アンチトリプシン欠乏症',
            ___Hypoparathyroidism: '副甲状腺機能低下症',
            // ___Pseudohypoparathyroidism: '偽性副甲状腺機能低下症',
            ___Vitamin_D_resistant_rickets_Vitamin_D_resistant_osteomalacia: 'ビタミンD抵抗性くる病/骨軟化症',
            ___Tyrosinemia_type_1: '高チロシン血症1型',
            ___Tyrosinemia_type_2: '高チロシン血症2型',
            ___Tyrosinemia_type_3: '高チロシン血症3型',
            // ___Galactose_1_phosphate_uridyltransferase_deficiency: 'ガラクトース-1-リン酸ウリジルトランスフェラーゼ欠損症',
            ___Lecithin_cholesterol_acyltransferase_deficiency: 'レシチンコレステロールアシルトランスフェラーゼ欠損症',
            // ___Sitosterolemia: 'シトステロール血症',
            ___Cerebrotendinous_xanthomatosis: '脳腱黄色腫症',
            ___Chronic_recurrent_multifocal_osteomyelitis: '慢性再発性多発性骨髄炎',
            ___Ankylosing_spondylitis: '強直性脊椎炎',
            ___Fibrodysplasia_ossificans_progressiva: '進行性骨化性線維異形成症',
            ___Congenital_scoliosis_with_rib_anomalies: '肋骨異常を伴う先天性側弯症',
            ___Giant_lymphatic_malformation_cervicofacial_lesion: '巨大リンパ管奇形(頚部顔面病変)',
            ___Giant_venous_malformation_cervical_oral_and_oropharyngeal_diffuse_lesion: '巨大静脈奇形(頚部口腔咽頭びまん性病変)',
            ___Klippel_Trenaunay_Weber_syndrome: 'クリッペル・トレノネー・ウェーバー症候群',
            // ___Diamond_Blackfan_anemia: 'ダイアモンド・ブラックファン貧血',
            ___Hirschsprung_disease: 'ヒルシュスプルング病(全結腸型又は小腸型)',
            ___Congenital_diaphragmatic_hernia: '先天性横隔膜ヘルニア',
            ___Biliary_atresia: '胆道閉鎖症',
            ___Macular_dystrophy: '黄斑ジストロフィー',
            // ___Progressive_leukoencephalopathy: '進行性白質脳症',
            ___Anterior_segment_dysgenesis: '前眼部形成異常',
            // ___Aniridia: '無虹彩症',
            ___Idiopathic_multicentric_Castlemans_disease: '特発性多中心性キャッスルマン病',
            ___Gelatinous_drop_like_corneal_dystrophy: '膠様滴状角膜ジストロフィー',
            ___MECP2_Duplication_Syndrome: 'MECP2重複症候群',
            ___Autosomal_Dominant_Adult_Onset_Demyelinating_Leukodystrophy: 'LMNB1関連大脳白質脳症',
            ___PURA_related_severe_neonatal_hypotonia_seizures_encephalopathy_syndrome: 'PURA関連神経発達異常症',
            ___very_long_chain_acyl_CoA_dehydrogenase: '極長鎖アシル-CoA脱水素酵素欠損症',
            // ___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy: '乳児発症STING関連血管炎',
            ___Bleeding_disorder_with_abnormal_fibrinolysis: '出血性線溶異常症',
            ___Lowe_syndrome: 'ロウ症候群'
          }
        },
        workgroupRoleOptions: {
          title: {
            ___owner: '管理者',
            ___director: 'ディレクター',
            ___member: 'メンバー'
          }
        },
        reportPreviewOptions: {
          categoryTitle: {
            ___AlleleFrequency: 'アレル頻度',
            ___coverage: 'カバレッジ率',
            ___psSpliceSite: 'スプライス・サイト',
            ___psFunctionPrediction: '機能予測',
            ___psEnsemble: 'Ensemble',
            ___psConservation: 'コンサベーション',
            ___psgnomADConstraint: 'gnomAD制約'
          },
          groupTitle: {
            ___1000Genomes: '1000 Genomes',
            ___gnomADExomes: 'gnomAD Exomes',
            ___gnomADGenomes: 'gnomAD Genomes',
            ___phenoVarDBPrivate: 'PhenoVarDBプライベート',
            ___phenoVarDBCommunity: 'PhenoVarDB コミュニティー',
            ___phenoVarDBAdmin: 'PhenoVarDB管理者',
            ___other: 'その他',
            ___coverageGnomADExomes: 'gnomAD Exomes',
            ___coverageGnomADGenomes: 'gnomAD Genomes'
          },
          linkTitle: {
            ___SpliceAI: 'ここをクリックしてSpliceAIスコアを調べてください。'
          },
          title: {
            ___KG_AF: 'AF',
            ___KG_EAS_AF: 'EAS AF',
            ___KG_AMR_AF: 'AMR AF',
            ___KG_AFR_AF: 'AFR AF',
            ___KG_EUR_AF: 'EUR AF',
            ___KG_SAS_AF: 'SAS AF',
            ___gnomAD_AF: 'AF',
            ___gnomAD_AFR_AF: 'AFR AF',
            ___gnomAD_AMR_AF: 'AMR AF',
            ___gnomAD_ASJ_AF: 'ASJ AF',
            ___gnomAD_EAS_AF: 'EAS AF',
            ___gnomAD_FIN_AF: 'FIN AF',
            ___gnomAD_NFE_AF: 'NFE AF',
            ___gnomAD_OTH_AF: 'OTH AF',
            ___gnomAD_SAS_AF: 'SAS AF',
            ___gnomAD_MID_AF: 'MID AF',
            ___gnomAD_g_AF: 'AF',
            ___gnomAD_g_AF_afr: 'AFR AF',
            ___gnomAD_g_AF_ami: 'AMI AF',
            ___gnomAD_g_AF_amr: 'AMR AF',
            ___gnomAD_g_AF_asj: 'ASJ AF',
            ___gnomAD_g_AF_eas: 'EAS AF',
            ___gnomAD_g_AF_fin: 'FIN AF',
            ___gnomAD_g_AF_mid: 'MID AF',
            ___gnomAD_g_AF_nfe: 'NFE AF',
            ___gnomAD_g_AF_oth: 'OTH AF',
            ___gnomAD_g_AF_sas: 'SAS AF',
            ___gnomAD_g_mt_AF_het: 'ヘテロプラスミー AF',
            ___gnomAD_g_mt_pop_AF_het_afr: 'ヘテロプラスミー AFR AF',
            ___gnomAD_g_mt_pop_AF_het_ami: 'ヘテロプラスミー AMI AF',
            ___gnomAD_g_mt_pop_AF_het_amr: 'ヘテロプラスミー AMR AF',
            ___gnomAD_g_mt_pop_AF_het_asj: 'ヘテロプラスミー ASJ AF',
            ___gnomAD_g_mt_pop_AF_het_eas: 'ヘテロプラスミー EAS AF',
            ___gnomAD_g_mt_pop_AF_het_fin: 'ヘテロプラスミー FIN AF',
            ___gnomAD_g_mt_pop_AF_het_mid: 'ヘテロプラスミー MID AF',
            ___gnomAD_g_mt_pop_AF_het_nfe: 'ヘテロプラスミー NFE AF',
            ___gnomAD_g_mt_pop_AF_het_oth: 'ヘテロプラスミー OTH AF',
            ___gnomAD_g_mt_pop_AF_het_sas: 'ヘテロプラスミー SAS AF',
            ___gnomAD_g_mt_AF_hom: 'ホモプラスミー AF',
            ___gnomAD_g_mt_pop_AF_hom_afr: 'ホモプラスミー AFR AF',
            ___gnomAD_g_mt_pop_AF_hom_ami: 'ホモプラスミー AMI AF',
            ___gnomAD_g_mt_pop_AF_hom_amr: 'ホモプラスミー AMR AF',
            ___gnomAD_g_mt_pop_AF_hom_asj: 'ホモプラスミー ASJ AF',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'ホモプラスミー EAS AF',
            ___gnomAD_g_mt_pop_AF_hom_fin: 'ホモプラスミー FIN AF',
            ___gnomAD_g_mt_pop_AF_hom_mid: 'ホモプラスミー MID AF',
            ___gnomAD_g_mt_pop_AF_hom_nfe: 'ホモプラスミー NFE AF',
            ___gnomAD_g_mt_pop_AF_hom_oth: 'ホモプラスミー OTH AF',
            ___gnomAD_g_mt_pop_AF_hom_sas: 'ホモプラスミー SAS AF',
            ___PVDB_P_FILTER: 'フィルター',
            ___PVDB_P_F_MISSING: '欠損率',
            ___PVDB_P_AC: 'AC',
            ___PVDB_P_AN: 'AN',
            ___PVDB_P_AF: 'AF',
            ___PVDB_P_DP: 'DP',
            ___PVDB_P_AC_Het: 'ヘテロ接合体遺伝子型におけるAC',
            ___PVDB_P_AC_Hom: 'ホモ接合体遺伝子型におけるAC',
            ___PVDB_P_AC_Hemi: 'ヘミ接合体遺伝子型におけるAC',
            ___PVDB_S_FILTER: 'フィルター',
            ___PVDB_S_F_MISSING: '欠損率',
            ___PVDB_S_AC: 'AC',
            ___PVDB_S_AN: 'AN',
            ___PVDB_S_AF: 'AF',
            ___PVDB_S_DP: 'DP',
            ___PVDB_S_AC_Het: 'ヘテロ接合体遺伝子型におけるAC',
            ___PVDB_S_AC_Hom: 'ホモ接合体遺伝子型におけるAC',
            ___PVDB_S_AC_Hemi: 'ヘミ接合体遺伝子型におけるAC',
            ___PVDB_A_FILTER: 'フィルター',
            ___PVDB_A_F_MISSING: '欠損率',
            ___PVDB_A_AC: 'AC',
            ___PVDB_A_AN: 'AN',
            ___PVDB_A_AF: 'AF',
            ___PVDB_A_DP: 'DP',
            ___PVDB_A_AC_Het: 'ヘテロ接合体遺伝子型におけるAC',
            ___PVDB_A_AC_Hom: 'ホモ接合体遺伝子型におけるAC',
            ___PVDB_A_AC_Hemi: 'ヘミ接合体遺伝子型におけるAC',
            ___ESP6500_AF: 'ESP6500 AF',
            ___ESP6500_AA_AF: 'ESP6500 AA',
            ___ESP6500_EA_AF: 'ESP6500 EA',
            ___TW_AF: 'Taiwan Biobank AF',
            ___TOPMED_AF: 'TOPMed AF',
            ___UK10K_AF: 'UK10K AF',
            ___ChinaMAP_AF: 'ChinaMAP AF',
            ___GA_AF: 'GenomeAsia 100K AF',
            ___KJ_AF: '4.7KJPN AF',
            ___ExAC_AF: 'ExAC AF',
            ___tommo_60kjpn_AF: 'ToMMo 60KJPN AF',
            ___tommo_60kjpn_AN: 'ToMMo 60KJPN AN',
            ___gnomAD_cov_MEAN: '平均値',
            ___gnomAD_cov_MEDIAN: '中央値',
            ___gnomAD_cov_PCT_20X: '>20xカバレッジ率(%)',
            ___gnomAD_g_cov_MEAN: '平均値',
            ___gnomAD_g_cov_MEDIAN: '中央値',
            ___gnomAD_g_cov_PCT_20X: '>20xカバレッジ率(%)',
            ___ESM1b: 'ESMb1',
            ___ESM1b_pred: 'ESMb1予測',
            ___VARITY_ER_LOO: 'VARITY ER LOO',
            ___VARITY_ER_LOO_pred: 'VARITY ER LOO予測',
            ___VARITY_R_LOO: 'VARITY R LOO',
            ___VARITY_R_LOO_pred: 'VARITY R LOO予測',
            ___VARITY_ER: 'VARITY ER',
            ___VARITY_ER_pred: 'VARITY ER予測',
            ___VARITY_R: 'VARITY R',
            ___VARITY_R_pred: 'VARITY R予測',
            ___Alphamissense_score: 'Alphamissenseスコア',
            ___Alphamissense_class: 'Alphamissense class',
            ___SIFT4G_score: 'SIFT4Gスコア',
            ___SIFT4G_pred: 'SIFT4G予測',
            ___Polyphen: 'Polyphen-2 HDIV',
            ___Polyphen_pred: 'Polyphen-2 HDIV予測',
            ___FATHMM_score: 'FATHMMスコア',
            ___FATHMM_pred: 'FATHMM予測',
            ___PROVEAN_score: 'PROVEANスコア',
            ___PROVEAN_pred: 'PROVEAN予測',
            ___CADD_phred: 'CADD phred',
            ___CADD_phred_pred: 'CADD phred予測',
            ___MetaLR_score: 'MetaLRスコア',
            ___MetaLR_pred: 'MetaLR予測',
            ___MetaSVM_score: 'MetaSVMスコア',
            ___MetaSVM_pred: 'MetaSVM予測',
            ___REVEL_score: 'REVELスコア',
            ___REVEL_pred: 'REVEL予測',
            ___BayesDel_noAF_score: 'BayesDel noAFスコア',
            ___BayesDel_noAF_pred: 'BayesDel noAF予測',
            ___gnomAD_g_mt_mitotip_score: 'MitoTipスコア',
            ___gnomAD_g_mt_mitotip_score_pred: 'MitoTip予測',
            ___ada_score: 'adaスコア',
            ___ada_pred: 'ada予測',
            ___rf_score: 'rfスコア',
            ___rf_pred: 'rf予測',
            ___CI_SpliceAI_DS_AG: 'CI-SpliceAI DS AG',
            ___CI_SpliceAI_DS_AL: 'CI-SpliceAI DS AL',
            ___CI_SpliceAI_DS_DG: 'CI-SpliceAI DS DG',
            ___CI_SpliceAI_DS_DL: 'CI-SpliceAI DS DL',
            ___CI_SpliceAI_DP_AG: 'CI-SpliceAI DP AG',
            ___CI_SpliceAI_DP_AL: 'CI-SpliceAI DP AL',
            ___CI_SpliceAI_DP_DG: 'CI-SpliceAI DP DG',
            ___CI_SpliceAI_DP_DL: 'CI-SpliceAI DP DL',
            ___SpliceAI: 'SpliceAI',
            ___SpliceAI_DS_AG: 'SpliceAI アクセプター・ゲイン・スコア',
            ___SpliceAI_DS_AL: 'SpliceAI アクセプター・ロス・スコア',
            ___SpliceAI_DS_DG: 'SpliceAI ドナー・ゲイン・スコア',
            ___SpliceAI_DS_DL: 'SpliceAI ドナー・ロス・スコア',
            ___SpliceAI_DP_AG: 'SpliceAI アクセプター・ゲイン・ポジション',
            ___SpliceAI_DP_AL: 'SpliceAI アクセプター・ロス・ポジション',
            ___SpliceAI_DP_DG: 'SpliceAI ドナー・ゲイン・ポジション',
            ___SpliceAI_DP_DL: 'SpliceAI ドナー・ロス・ポジション',
            ___GERPpp_NR: 'GERP++NR',
            ___GERPpp_RS: 'GERP++RS',
            ___GERPpp_RS_pred: 'GERP++RS予測',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds',
            ___SiPhy_29way_logOdds_pred: 'SiPhy 29way logOdds予測',
            ___SiPhy_29way_pi: 'SiPhy 29way pi',
            ___oe_syn: 'シノニマス o/e',
            ___oe_mis: 'ミスセンス o/e',
            ___oe_lof: 'pLoF o/e',
            ___syn_z: 'シノニマス z-スコア',
            ___mis_z: 'ミスセンス z-スコア',
            ___pLI: 'pLI'
          }
        },
        licenseStatusMap: {
          title: {
            ___inactive: '非アクティブ',
            ___active: '有効化済み',
            ___exceeded: '使用上限超過',
            ___expired: '期限切れ',
            ___unlimited: '無制限'
          }
        },
        licenseApiMap: {
          title: {
            ___vcf_analysis: 'VCF解析',
            ___fastq_analysis: 'FASTQ解析',
            ___report_module: 'レポートモジュール',
            ___mastermind: 'Mastermind'
          }
        }
      }
    }
  },
  // common
  COMMON: {
    button: {
      ___add: '追加',
      ___select: '選択',
      ___export: 'エクスポート',
      ___hideDeleted: '削除されたものを非表示にする',
      ___showDeleted: '削除されたものを表示する',
      ___reset: 'リセット',
      ___apply: '適用する',
      ___generate: '生成',
      ___regenerate: '再生成',
      ___createUrl: 'URLを作成',
      ___search: '検索',
      ___cancel: 'キャンセル',
      ___create: '作成',
      ___return: '戻る',
      ___update: '更新',
      ___archive: 'アーカイブ',
      ___delete: '削除',
      ___leave: '退出',
      ___shareSetting: '設定の共有',
      ___accept: '承認',
      ___addAll: 'すべて追加',
      ___save: '保存',
      ___confirm: '確認',
      ___enter: '入力',
      ___import: 'インポート',
      ___reanalysis: '再解析',
      ___vcf: 'VCF',
      ___fastq: 'fastq',
      ___ubam: 'uBAM',
      ___upload: 'アップロード',
      ___newChapter: '新しいチャプター',
      ___newCNV: '新しいSV',
      ___newWorkgroup: 'グループを作成',
      ___newConfig: '新しい構成',
      ___addMember: 'メンバーを追加',
      ___addCases: '症例を追加',
      ___addStage: '作業段階を追加',
      ___newPanel: '新しいパネル',
      ___newAnalysis: '新しい解析',
      ___analysis: '解析',
      ___submit: '提出',
      ___hideArchives: 'アーカイブを非表示にする',
      ___showArchives: 'アーカイブを表示する',
      ___active: 'アクティブ',
      ___send: '送信',
      ___ignore: '無視',
      ___login: 'ログイン',
      ___signUp: '登録',
      ___backToSearch: '検索に戻る',
      ___buyMore: '追加購入',
      ___contactUs: 'お問い合わせ',
      ___verify: '認証',
      ___change: '変更',
      ___proceed: '続行',
      ___set: '設定',
      ___retry: '再実行',
      ___stop: '停止',
      ___date: '日付',
      ___none: 'なし',
      ___yes: 'はい',
      ___no: 'いいえ',
      ___unlock: 'ロック解除'
    },
    toast: {
      ___licenseInvalid: 'ライセンスIDが無効です。',
      ___licenseExceeded: '機能の使用制限を超えました。',
      ___licenseExpired: 'ライセンスの有効期限が切れています。',
      ___noPermission: '権限がありません。',
      ___pleaseLogin: 'ログインしてください。',
      ___xhrCanNotUpload: 'Xhrはアップロードできません。',
      ___pleaseAgreeTerms: '規約に同意してください。',
      ___phenotypesAnalyzeLimit: '{amount} 個以上の表現型を解析できません。',
      ___datasetReachLimit: 'データセットが最大容量に達しました。',
      ___analysisTimeout: '解析がタイムアウトしました。担当チームに通知済みです。',
      ___wrongFiles: 'ファイルが間違っています。',
      ___getSignUrlFailed: '署名付きURLの発行に失敗しました。',
      ___addSameHPOTerm: '同じ HPO ID がすでに追加されています。',
      ___geneSymbolInvalidFormat: '遺伝子名または Entrez ID の形式が無効です。',
      ___fileTypeAlert: 'ファイル形式が無効です。{types}形式のファイルをアップロードしてください。',
      ___variantInAllChapter: 'このバリアントはすべてのチャプターに追加されました。',
      ___noPermissionToOpenDataset: 'このデータセットを表示する権限がありません。',
      ___reportUpdated: '報告書が更新されました。',
      ___tsvExportLimit: 'TSV エクスポートは最大 {amount} 件までです。',
      ___atLeastOneCardOpen: 'カードは最低1枚オープンにしてください。',
      ___noPermissionToUploadFile: 'ファイルをアップロードする権限がありません。',
      ___snvFileRequired: 'SNV ファイルは必須です。',
      ___dataShouldBePaired: 'データはペアである必要があります。ファイル数をご確認ください。',
      ___sampleFamilyAnalysis: 'このサンプルは家族分析のサンプル使用のため、一時的に保護されています。',
      ___familyMemberLimit: '選択できるメンバーは {limit} 名までです。',
      ___workgroupLimit: 'グループの最大数は{limit}であり、制限に達しました。',
      ___workgroupMemberExist: 'このメンバーはすでにグループに存在しています。',
      ___addWorkgroupMember: 'メンバーが追加されました。',
      ___editWorkgroupMember: 'メンバーが更新されました。',
      ___addWorkgroupCase: '{count}件の症例が追加されました。 | {count}件の症例が追加されました。',
      ___addWorkgroupCaseAutoShare: '{count}件の症例が追加されました。自動共有が有効になり、今後アップロードされる症例は自動的にこのワークグループに共有されます。 | {count}件の症例が追加されました。自動共有が有効になり、今後アップロードされる症例は自動的にこのワークグループに共有されます。',
      ___workgroupStageLimit: '作業段階の最大数は{limit}であり、制限に達しました。',
      ___workgroupStageExist: 'この作業段階はすでにグループに存在しています。',
      ___addWorkgroupStage: '作業段階が追加されました。',
      ___editWorkgroupStage: '作業段階が更新されました。',
      ___batchExpired: '{created} に作成されたバッチは、<span style="color:#FA3D3D">5日以上編集されていないため</span>、VCF およびサンプルシートを含むすべての記録が削除されました。新しいバッチを作成してください。',
      ___exportCaseReport: 'レポートを開くパスワードは、ご利用のアカウントのメールアドレスです。',
      ___fileUploadLimit: 'ファイルは最大{count}件までアップロードできます。',
      ___genePanelItemExist: '選択した{type}は、すでに追加されています。',
      ___mastermindLicense: 'Mastermind のライセンスをご購入いただくか、営業担当者にお問い合わせいただくことで、アノテーションの内容をご覧いただけます。'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/ja/lang.js